/* ═══════════════════════════════════════════════════════════
     INTAKE INBOX — full feature set
  ═══════════════════════════════════════════════════════════ */

  let intakeData    = {};          // live snapshot: { firebaseKey: payload }
  let intakeTabFilter = 'all';
  let expandedCard  = null;        // currently expanded card key

  /* ── Bootstrap: listen for realtime updates ── */
  function initIntakeListener() {
    db.ref('intakeRequests').on('value', (snap) => {
      intakeData = snap.val() || {};
      renderIntakeList();
      renderIntakeInlinePreview();
      updateIntakeBadges();
    });
  }

  /* ── Count new requests ── */
  function countNew() {
    return Object.values(intakeData).filter(r => r.status === 'new').length;
  }

  /* ── Update all badges ── */
  function updateIntakeBadges() {
    const n = countNew();

    // Header button badge
    const hb = document.getElementById('intake-header-badge');
    if (hb) {
      hb.textContent = n > 9 ? '9+' : String(n);
      hb.classList.toggle('visible', n > 0);
    }

    // Modal title count
    const mc = document.getElementById('intake-new-count');
    if (mc) mc.textContent = n > 0 ? `${n} new` : '';

    // Accordion badge
    const ab = document.getElementById('intake-accordion-badge');
    if (ab) {
      ab.textContent = n > 0 ? `${n} new` : '';
      ab.style.display = n > 0 ? 'inline' : 'none';
    }
  }

  /* ── Format timestamp ── */
  function formatIntakeDate(ts) {
    if (!ts) return '—';
    const d = new Date(ts);
    const now = new Date();
    const diffMs = now - d;
    const diffMin = Math.floor(diffMs / 60000);
    const diffH   = Math.floor(diffMs / 3600000);
    const diffD   = Math.floor(diffMs / 86400000);

    if (diffMin < 2)  return 'Just now';
    if (diffMin < 60) return `${diffMin}m ago`;
    if (diffH < 24)   return `${diffH}h ago`;
    if (diffD < 7)    return `${diffD}d ago`;
    return d.toLocaleDateString('en-CA', { month: 'short', day: 'numeric' });
  }

  /* ── Filter entries by tab ── */
  function filteredEntries() {
    return Object.entries(intakeData)
      .filter(([, r]) => intakeTabFilter === 'all' || r.status === intakeTabFilter)
      .sort((a, b) => (b[1].submittedAt || 0) - (a[1].submittedAt || 0));
  }

  /* ── Build a single card HTML string ── */
  function buildIntakeCard(key, r, expanded = false) {
    const isNew      = r.status === 'new';
    const statusMap  = { new: 'status-new', reviewed: 'status-reviewed', done: 'status-done' };
    const statusLabel = { new: 'New', reviewed: 'Reviewed', done: 'Done' };
    const statusClass = statusMap[r.status] || 'status-new';
    const statusText  = statusLabel[r.status] || 'New';

    const addr = r.address
      ? [r.address.street, r.address.city, r.address.prov, r.address.postal, r.address.country].filter(Boolean).join(', ')
      : '—';

    const waLink = r.phone
      ? `https://wa.me/${r.phone.replace(/\D/g,'')}?text=${encodeURIComponent(`Hi ${r.name}, this is Global JDM Auto Parts following up on your inquiry (Ref: ${r.ref}). `)}`
      : null;

    return `
      <div class="intake-card ${isNew ? 'is-new' : ''}" id="ic-${key}">
        <div class="intake-card-header" onclick="toggleIntakeCard('${key}')">
          <div class="intake-card-left">
            <div class="intake-card-name">
              ${escI(r.name || '—')}
              ${isNew ? '<span class="intake-new-pill">New</span>' : ''}
            </div>
            <div class="intake-card-meta">
              <span>📞 ${escI(r.phone || '—')}</span>
              <span>✉️ ${escI(r.email || '—')}</span>
              <span>🕐 ${formatIntakeDate(r.submittedAt)}</span>
            </div>
          </div>
          <div class="intake-card-right">
            <span class="intake-status-badge ${statusClass}">${statusText}</span>
          </div>
        </div>

        <div class="intake-card-body ${expanded ? 'open' : ''}" id="icb-${key}">
          <div class="intake-detail-grid">
            <div class="intake-detail-item">
              <div class="intake-detail-label">Reference</div>
              <div class="intake-detail-value" style="font-family:var(--font-head);color:var(--accent);">${escI(r.ref || '—')}</div>
            </div>
            <div class="intake-detail-item">
              <div class="intake-detail-label">Order Type</div>
              <div class="intake-detail-value">${escI(r.orderType || '—')}</div>
            </div>
            <div class="intake-detail-item">
              <div class="intake-detail-label">Preferred Date</div>
              <div class="intake-detail-value">${r.prefDate ? escI(r.prefDate) : '—'} ${r.prefTime ? '· ' + escI(r.prefTime) : ''}</div>
            </div>
            <div class="intake-detail-item">
              <div class="intake-detail-label">Address</div>
              <div class="intake-detail-value">${escI(addr)}</div>
            </div>
          </div>

          ${r.notes ? `
            <div class="intake-detail-label" style="margin-bottom:6px;">Notes</div>
            <div class="intake-notes-block">${escI(r.notes)}</div>
          ` : ''}

          <div class="intake-actions">
            <button class="intake-btn intake-btn-load" onclick="loadIntakeIntoInvoice('${key}')">
              ⬇ Load into Invoice
            </button>
            ${r.status !== 'done' ? `
              <button class="intake-btn intake-btn-done" onclick="setIntakeStatus('${key}','done')">
                ✓ Mark Done
              </button>` : `
              <button class="intake-btn intake-btn-done" onclick="setIntakeStatus('${key}','new')">
                ↩ Reopen
              </button>`
            }
            ${r.status === 'new' ? `
              <button class="intake-btn intake-btn-done" style="background:rgba(232,255,74,0.1);color:var(--accent);border-color:rgba(232,255,74,0.2);" onclick="setIntakeStatus('${key}','reviewed')">
                👁 Mark Reviewed
              </button>` : ''
            }
            ${waLink ? `
              <button class="intake-btn intake-btn-wa" onclick="window.open('${waLink}','_blank')">
                💬 WhatsApp
              </button>` : ''
            }
            <button class="intake-btn intake-btn-delete" onclick="deleteIntakeRequest('${key}')">
              🗑
            </button>
          </div>
        </div>
      </div>
    `;
  }

  /* ── Render full modal list ── */
  function renderIntakeList() {
    const list = document.getElementById('intake-list');
    if (!list) return;

    const entries = filteredEntries();

    if (!entries.length) {
      list.innerHTML = `<div class="intake-empty">No ${intakeTabFilter === 'all' ? '' : intakeTabFilter + ' '}requests yet.</div>`;
      return;
    }

    list.innerHTML = entries.map(([key, r]) =>
      buildIntakeCard(key, r, expandedCard === key)
    ).join('');
  }

  /* ── Render inline accordion preview (latest 3) ── */
  function renderIntakeInlinePreview() {
    const preview = document.getElementById('intake-inline-preview');
    if (!preview) return;

    const entries = Object.entries(intakeData)
      .sort((a,b) => (b[1].submittedAt||0) - (a[1].submittedAt||0))
      .slice(0, 3);

    if (!entries.length) {
      preview.innerHTML = `<div class="intake-empty">No requests yet. Share your intake form link with customers.</div>`;
      return;
    }

    preview.innerHTML = entries.map(([key, r]) => buildIntakeCard(key, r, false)).join('');
  }

  /* ── Toggle expand/collapse card ── */
  function toggleIntakeCard(key) {
    const body = document.getElementById(`icb-${key}`);
    if (!body) return;

    if (expandedCard && expandedCard !== key) {
      const prev = document.getElementById(`icb-${expandedCard}`);
      if (prev) prev.classList.remove('open');
    }

    const isOpen = body.classList.toggle('open');
    expandedCard = isOpen ? key : null;

    // Mark as reviewed when first opened
    if (isOpen && intakeData[key]?.status === 'new') {
      setIntakeStatus(key, 'reviewed', true);
    }
  }

  /* ── Update status ── */
  async function setIntakeStatus(key, status, silent = false) {
    try {
      await db.ref(`intakeRequests/${key}/status`).set(status);
      if (!silent) showToast(`✓ Marked as ${status}`);
    } catch(e) {
      console.error('Status update failed:', e);
    }
  }

  /* ── Delete request ── */
  async function deleteIntakeRequest(key) {
    if (!can('manageIntake')) return;
    if (!confirm('Delete this intake request? This cannot be undone.')) return;
    try {
      await db.ref(`intakeRequests/${key}`).remove();
      showToast('Request deleted.');
    } catch(e) {
      console.error('Delete failed:', e);
    }
  }

  /* ── Load intake data into invoice customer fields ── */
  function loadIntakeIntoInvoice(key) {
    const r = intakeData[key];
    if (!r) return;

    // Customer fields (matching your existing IDs)
    const setVal = (id, val) => {
      const el = document.getElementById(id);
      if (el && val) el.value = val;
    };

    setVal('cust-name',    r.name);
    setVal('cust-email',   r.email);
    setVal('cust-street',  r.address?.street);
    setVal('cust-city',    r.address?.city);
    setVal('cust-prov',    r.address?.prov);
    setVal('cust-postal',  r.address?.postal);
    setVal('cust-country', r.address?.country);

    // Phone — your invoicer uses cust-phone if it exists
    setVal('cust-phone', r.phone);

    // Shipping terms — try to map order type to your dropdown
    const shippingMap = {
      'Local Pickup - Brampton, ON': 'Local Pickup - Brampton, ON',
      'Delivery - Canada':           'DAP - Delivered at Place',
      'Delivery - USA':              'DDU - Duties Unpaid (USA Freight)',
      'Delivery - International':    'FOB - Free on Board',
    };
    const shippingEl = document.getElementById('doc-shipping');
    if (shippingEl && shippingMap[r.orderType]) {
      shippingEl.value = shippingMap[r.orderType];
    }

    // Internal memo — prepend intake notes
    const memoEl = document.getElementById('doc-memo');
    if (memoEl && r.notes) {
      const prefix = `[Intake Ref: ${r.ref}]\nCustomer Note: ${r.notes}\n\n`;
      memoEl.value = prefix + (memoEl.value || '');
    }

    // Add preferred date to memo if present
    if (memoEl && r.prefDate) {
      memoEl.value = `Preferred Date: ${r.prefDate}${r.prefTime ? ' ' + r.prefTime : ''}\n` + (memoEl.value || '');
    }

    // Mark request as done
    setIntakeStatus(key, 'done', true);

    // Close modal, scroll to customer section
    closeIntakeModal();
    showToast('✓ Customer details loaded into invoice!');

    // Expand the customer accordion if collapsed
    const custAccordion = document.getElementById('accordion-customer');
    if (custAccordion && !custAccordion.open) custAccordion.open = true;

    // Scroll to customer section
    setTimeout(() => {
      custAccordion?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 200);
  }

  /* ── Tab filter ── */
  function setIntakeTab(tab, btn) {
    intakeTabFilter = tab;
    document.querySelectorAll('.intake-tab').forEach(b => b.classList.remove('active'));
    if (btn) btn.classList.add('active');
    expandedCard = null;
    renderIntakeList();
  }

  /* ── Modal open/close ── */
  function openIntakeModal() {
    if (!can('viewIntake')) return;
    document.getElementById('intake-modal-overlay').classList.add('open');
    document.getElementById('intake-modal').classList.add('open');
    renderIntakeList();
  }

  function copyIntakeLink() {
    navigator.clipboard.writeText('https://globaljdmautoparts.com/pages/customer-information-form')
      .then(() => showToast('✓ Intake form link copied!'))
      .catch(() => showToast('Could not copy — link: globaljdmautoparts.com/pages/customer-information-form'));
  }

  function closeIntakeModal() {
    document.getElementById('intake-modal-overlay').classList.remove('open');
    document.getElementById('intake-modal').classList.remove('open');
  }

  /* ═══════════════════════════════════════════════════════════
       LOCAL PICKUP REQUESTS — full feature set
     ═══════════════════════════════════════════════════════════ */

  let pickupData      = {};
  let pickupTabFilter = 'all';
  let pickupExpandedCard = null;

  /* ── Bootstrap: realtime listener ── */
  function initPickupListener() {
    db.ref('pickupRequests').on('value', (snap) => {
      pickupData = snap.val() || {};
      renderPickupList();
      updatePickupBadges();
    });

    // Toast on new submission
    db.ref('pickupRequests').orderByChild('submittedAt').startAt(Date.now()).on('child_added', (snap) => {
      const d = snap.val();
      if (!d) return;
      showToast('📦 New pickup request from ' + (d.name || 'a customer') + '!');
      if (Notification.permission === 'granted') {
        new Notification('Global JDM — New Pickup Request', {
          body: (d.name || 'Someone') + ' wants to pick up on ' + (d.pickupDate || '—'),
          icon: 'https://globaljdmautoparts.com/cdn/shop/t/10/assets/favicon-96x96.png'
        });
      }
    });
  }

  /* ── Count new ── */
  function countNewPickup() {
    return Object.values(pickupData).filter(r => r.status === 'new').length;
  }

  /* ── Update badges ── */
  function updatePickupBadges() {
    const n = countNewPickup();

    const ab = document.getElementById('pickup-accordion-badge');
    if (ab) {
      ab.textContent = n > 0 ? `${n} new` : '';
      ab.style.display = n > 0 ? 'inline' : 'none';
    }

    const mb = document.getElementById('more-menu-badge-pickup');
    if (mb) {
      mb.textContent = n > 0 ? String(n) : '';
      mb.style.display = n > 0 ? 'inline' : 'none';
    }

    const tb = document.getElementById('pickup-tab-new-badge');
    if (tb) {
      tb.textContent = n > 0 ? String(n) : '';
      tb.style.display = n > 0 ? 'inline' : 'none';
    }
  }

  /* ── Filter entries ── */
  function filteredPickupEntries() {
    return Object.entries(pickupData)
      .filter(([, r]) => pickupTabFilter === 'all' || r.status === pickupTabFilter)
      .sort((a, b) => (b[1].submittedAt || 0) - (a[1].submittedAt || 0));
  }

  /* ── Build a single pickup card ── */
  function buildPickupCard(key, r, expanded = false) {
    const isNew = r.status === 'new';
    const statusMap   = { new: 'status-new', confirmed: 'status-reviewed', done: 'status-done' };
    const statusLabel = { new: 'New', confirmed: 'Confirmed', done: 'Done' };
    const statusClass = statusMap[r.status] || 'status-new';
    const statusText  = statusLabel[r.status] || 'New';

    const waLink = r.phone
      ? `https://wa.me/${r.phone.replace(/\D/g,'')}?text=${encodeURIComponent(`Hi ${r.name}, this is Global JDM Auto Parts confirming your pickup on ${r.pickupDate} at ${r.pickupTime}. Please bring your order confirmation. See you then!`)}`
      : null;

    return `
      <div class="intake-card ${isNew ? 'is-new' : ''}" id="puc-${key}">
        <div class="intake-card-header" onclick="togglePickupCard('${key}')">
          <div class="intake-card-left">
            <div class="intake-card-name">
              ${escI(r.name || '—')}
              ${isNew ? '<span class="intake-new-pill">New</span>' : ''}
            </div>
            <div class="intake-card-meta">
              <span>📞 ${escI(r.phone || '—')}</span>
              <span>📅 ${escI(r.pickupDate || '—')} @ ${escI(r.pickupTime || '—')}</span>
              ${r.productTitle ? `<span>🛒 ${escI(r.productTitle)}${r.productPrice ? ' · $' + escI(r.productPrice) : ''}</span>` : ''}
              <span>🕐 ${formatIntakeDate(r.submittedAt)}</span>
            </div>
          </div>
          <div class="intake-card-right">
            <span class="intake-status-badge ${statusClass}">${statusText}</span>
          </div>
        </div>

        <div class="intake-card-body ${expanded ? 'open' : ''}" id="pucb-${key}">
          <div class="intake-detail-grid">
            <div class="intake-detail-item">
              <div class="intake-detail-label">Item ID</div>
              <div class="intake-detail-value" style="font-family:var(--font-head);color:var(--accent);">${escI(r.itemId || '—')}</div>
            </div>
            <div class="intake-detail-item">
              <div class="intake-detail-label">Pickup Date</div>
              <div class="intake-detail-value">${escI(r.pickupDate || '—')}</div>
            </div>
            <div class="intake-detail-item">
              <div class="intake-detail-label">Pickup Time</div>
              <div class="intake-detail-value">${escI(r.pickupTime || '—')}</div>
            </div>
            <div class="intake-detail-item">
              <div class="intake-detail-label">Phone</div>
              <div class="intake-detail-value">${escI(r.phone || '—')}</div>
            </div>
          </div>

          ${r.message ? `
            <div class="intake-detail-label" style="margin-bottom:6px;">Customer Message</div>
            <div class="intake-notes-block">${escI(r.message)}</div>
          ` : ''}

          <div class="intake-actions">
            ${r.status !== 'confirmed' && r.status !== 'done' ? `
              <button class="intake-btn intake-btn-done" style="background:rgba(232,255,74,0.1);color:var(--accent);border-color:rgba(232,255,74,0.2);" onclick="setPickupStatus('${key}','confirmed')">
                ✅ Confirm Pickup
              </button>` : ''
            }
            ${r.status !== 'done' ? `
              <button class="intake-btn intake-btn-done" onclick="setPickupStatus('${key}','done')">
                ✓ Mark Done
              </button>` : `
              <button class="intake-btn intake-btn-done" onclick="setPickupStatus('${key}','new')">
                ↩ Reopen
              </button>`
            }
            ${waLink ? `
              <button class="intake-btn intake-btn-wa" onclick="window.open('${waLink}','_blank')">
                💬 WhatsApp
              </button>` : ''
            }
            <button class="intake-btn" onclick="loadPickupIntoInvoice('${key}')" style="background:rgba(74,133,255,0.1);color:#4a85ff;border-color:rgba(74,133,255,0.2);">
              ⬇ Load into Invoice
            </button>
            <button class="intake-btn intake-btn-delete" onclick="deletePickupRequest('${key}')">
              🗑
            </button>
          </div>
        </div>
      </div>
    `;
  }

  /* ── Render list ── */
  function renderPickupList() {
    const list = document.getElementById('pickup-list');
    if (!list) return;

    const entries = filteredPickupEntries();
    if (!entries.length) {
      list.innerHTML = `<div class="intake-empty">No ${pickupTabFilter === 'all' ? '' : pickupTabFilter + ' '}pickup requests yet.</div>`;
      return;
    }
    list.innerHTML = entries.map(([key, r]) => buildPickupCard(key, r, pickupExpandedCard === key)).join('');
  }

  /* ── Toggle expand/collapse ── */
  function togglePickupCard(key) {
    const body = document.getElementById(`pucb-${key}`);
    if (!body) return;

    if (pickupExpandedCard && pickupExpandedCard !== key) {
      const prev = document.getElementById(`pucb-${pickupExpandedCard}`);
      if (prev) prev.classList.remove('open');
    }

    const isOpen = body.classList.toggle('open');
    pickupExpandedCard = isOpen ? key : null;

    if (isOpen && pickupData[key]?.status === 'new') {
      setPickupStatus(key, 'new', true); // keep as new until explicitly confirmed
    }
  }

  /* ── Set status ── */
  async function setPickupStatus(key, status, silent = false) {
    try {
      await db.ref(`pickupRequests/${key}/status`).set(status);
      if (!silent) showToast(`✓ Pickup marked as ${status}`);
    } catch(e) {
      console.error('Pickup status update failed:', e);
    }
  }

  /* ── Delete request ── */
  async function deletePickupRequest(key) {
    if (!confirm('Delete this pickup request? This cannot be undone.')) return;
    try {
      await db.ref(`pickupRequests/${key}`).remove();
      showToast('Pickup request deleted.');
    } catch(e) {
      console.error('Pickup delete failed:', e);
    }
  }

  /* ── Load into invoice ── */
  function loadPickupIntoInvoice(key) {
    const r = pickupData[key];
    if (!r) return;

    const setVal = (id, val) => {
      const el = document.getElementById(id);
      if (el && val) el.value = val;
    };

    setVal('cust-name',  r.name);
    setVal('cust-phone', r.phone);

    // Set shipping to Local Pickup
    const shippingEl = document.getElementById('doc-shipping');
    if (shippingEl) shippingEl.value = 'Local Pickup - Brampton, ON';
    handleShippingChange('Local Pickup - Brampton, ON');

    // Prepend memo with pickup details
    const memoEl = document.getElementById('doc-memo');
    if (memoEl) {
      const prefix = `[Pickup Request]\nItem ID: ${r.itemId || 'N/A'}\nDate: ${r.pickupDate || '—'} @ ${r.pickupTime || '—'}\n${r.message ? 'Note: ' + r.message + '\n' : ''}\n`;
      memoEl.value = prefix + (memoEl.value || '');
    }

    setPickupStatus(key, 'done', true);
    showToast('✓ Pickup details loaded into invoice!');

    const custAccordion = document.getElementById('accordion-customer');
    if (custAccordion && !custAccordion.open) custAccordion.open = true;
    setTimeout(() => custAccordion?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 200);
  }

  /* ── Tab filter ── */
  function setPickupTab(tab, btn) {
    pickupTabFilter = tab;
    document.querySelectorAll('#accordion-pickup .wr-tab').forEach(b => b.classList.remove('active'));
    if (btn) btn.classList.add('active');
    pickupExpandedCard = null;
    renderPickupList();
  }

  /* ── Escape HTML ── */
  function escI(str) {
    return String(str || '')
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;').replace(/'/g,'&#39;');
  }

    const auth = firebase.auth();

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/assets/firebase-messaging-sw.js')
        .then((reg) => console.log('Service worker registered:', reg))
        .catch((err) => console.error('Service worker failed:', err));
    }

    let lastIntakeCheck = Date.now();

    function watchForNewIntake() {
      db.ref('intakeRequests').orderByChild('submittedAt').startAt(Date.now()).on('child_added', (snap) => {
        const data = snap.val();
        if (!data) return;
        const name = data.name || 'Someone';
        if (Notification.permission === 'granted') {
          new Notification('Global JDM — New Intake', {
            body: name + ' just submitted their information.',
            icon: 'https://globaljdmautoparts.com/cdn/shop/t/10/assets/favicon-96x96.png'
          });
        }
        showToast('📬 New intake from ' + name + '!');
        sendNtfy('📬 New Intake Form — ' + name, 'A customer submitted an intake form. Open your admin terminal to review.', 'high');
      });
    }

    function watchForNewPickup() {
      db.ref('pickupRequests').orderByChild('submittedAt').startAt(Date.now()).on('child_added', (snap) => {
        const data = snap.val();
        if (!data) return;
        const name = data.name || 'Someone';
        const date = data.pickupDate || '—';
        const item = data.productTitle || data.itemId || '—';
        if (Notification.permission === 'granted') {
          new Notification('Global JDM — New Pickup Request', {
            body: name + ' wants to pick up ' + item + ' on ' + date + '.',
            icon: 'https://globaljdmautoparts.com/cdn/shop/t/10/assets/favicon-96x96.png'
          });
        }
        showToast('📦 New pickup from ' + name + ' — ' + date + '!');
        sendNtfy('📦 New Pickup Request — ' + name, 'Pickup date: ' + date + '. Open your admin terminal to confirm.', 'high');
      });
    }

    async function registerForPushNotifications() {
      try {
        if (!('Notification' in window)) return;
        const messaging = firebase.messaging();
        const permission = await Notification.requestPermission();
        if (permission !== 'granted') return;
        const token = await messaging.getToken({
          vapidKey: 'BN_7T1f9zHcS8V0BZH07KNcsJA9qQccqWbM6uknmMEuOUb9AEGghRX-y9HmoTNEmLR_oZl0rHZdK0MxgElBk_nY'
        });
        if (token) {
          const uid = firebase.auth().currentUser?.uid;
          if (uid) await db.ref('fcmTokens/' + uid).set(token);
        }
        messaging.onMessage((payload) => {
          showToast('📬 ' + payload.notification.title + ' — ' + payload.notification.body);
        });
      } catch (err) {
        console.warn('Push notification setup failed:', err);
      }
    }

    /* ====================== AUTH STATE LISTENER ====================== */
    // Skip auth entirely in photo-transfer sender mode — phone doesn't need to log in
    auth.onAuthStateChanged((user) => {
      if (window.__ptSenderMode) return;
      if (user) {
        document.getElementById('gate').style.display = 'none';
        document.getElementById('main-app').style.display = 'flex';
        initApp();
          initIntakeListener();
          initPickupListener();
          initWaitlistListener();
          initChat();
          initReminders();
          registerForPushNotifications();
        watchForNewIntake();
        watchForNewPickup();
      } else {
        document.getElementById('gate').style.display = 'flex';
        document.getElementById('main-app').style.display = 'none';
      }
    });

    let currentDocType = 'INVOICE';
    let inventory = {};
    let currentPhotos = new Map(); // rowKey → string[] (multiple base64)
    let autosaveTimer = null;
    let draftKey = 'gjdm_draft';

    // ====================== FIX 5: Dynamic warranty date ======================
    function buildDefaultNotes() {
      const today = new Date();
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      const dateStr = today.toLocaleDateString('en-CA', options);
      return `This product is a used JDM part imported from Japan. Exact mileage cannot be 100% confirmed. Our supplier estimates the part had approximately 80,000 km at the time of removal, however this is not guaranteed and should be considered an estimate only.\n\n30-Day Warranty on internal engine mechanicals (Block & Head only). Warranty starts ${dateStr}.\n\nNOT COVERED: Labour, towing, fluids, or external accessories. INSTALLATION REQUIREMENT: `;
    }

    function initApp() {
      document.getElementById('doc-date').valueAsDate = new Date();
      document.getElementById('doc-notes').value = buildDefaultNotes();

      // Calculate next doc number from actual saved documents instead of a separate counter
      db.ref('savedDocuments').once('value', (snap) => {
        const data = snap.val();
        document.getElementById('doc-id').value = getNextDocNumber(data, currentDocType);
        restoreDraft();
      });

      document.querySelectorAll('#inventory-list option').forEach(opt => {
        inventory[opt.value] = {
          price: parseFloat(opt.dataset.price.replace(/,/g, '')) || 0,
          sku: opt.dataset.sku || ''
        };
      });

      db.ref('savedDocuments').on('value', (snapshot) => {
        const data = snapshot.val();
        renderSavedDocuments(data ? data : {});
      });

      // FIX 1: Attach auto-save listeners to all sidebar inputs
      attachAutosaveListeners();
      addRow();
      calc();
      updatePaidToggleUI('unpaid');
      handleShippingChange(document.getElementById('doc-shipping').value);
      // Re-apply translation if active
      if (isDari) setTimeout(translateUI, 300);
      // Load dashboard
      setTimeout(loadDashboard, 500);
      // Init delivery map when accordion is first opened
      const mapAccordion = document.getElementById('accordion-deliverymap');
      if (mapAccordion) {
        mapAccordion.addEventListener('toggle', () => {
          if (mapAccordion.open) {
            setTimeout(() => {
              if (deliveryMapInstance) deliveryMapInstance.invalidateSize();
              if (!deliveryMapPins.length) loadDeliveryMap();
            }, 150);
          }
        });
      }
      const warrantyAccordion = document.getElementById('accordion-warranties');
      if (warrantyAccordion) {
        warrantyAccordion.addEventListener('toggle', () => {
          if (warrantyAccordion.open && !warrantyAllItems.length) {
            // Only auto-load warranties if warranties tab is active
            const warrantiesPanel = document.getElementById('warranties-panel');
            if (warrantiesPanel && warrantiesPanel.classList.contains('active')) {
              loadWarrantyList();
            }
          }
        });
      }
      // Init calendar
      setTimeout(initCalendar, 600);
    }

    // ====================== FIX 1: AUTO-SAVE DRAFT ======================
    function attachAutosaveListeners() {
      const watchIds = ['doc-id','doc-date','doc-shipping','doc-currency','doc-tax-rate','doc-export',
                        'doc-discount','cust-name','cust-email','cust-street','cust-city','cust-prov',
                        'cust-postal','cust-country','doc-notes','doc-memo',
                        'freight-company','freight-tracking','freight-bol'];
      watchIds.forEach(id => {
        const el = document.getElementById(id);
        if (el) {
          el.addEventListener('input', scheduleAutosave);
          el.addEventListener('change', scheduleAutosave);
        }
      });
      // Also watch line items via event delegation
      document.getElementById('line-items').addEventListener('input', scheduleAutosave);
      document.getElementById('line-items').addEventListener('change', scheduleAutosave);
    }

    let isHydratingDocument = false;
    let lastShippingValue = null;

    function scheduleAutosave() {
      if (isHydratingDocument) return;
      clearTimeout(autosaveTimer);
      setAutosaveStatus('saving');
      autosaveTimer = setTimeout(() => {
        saveDraft();
      }, 1500);
    }

    function saveDraft() {
  try {
    const data = getDocumentData();

    // Don't save to Firebase unless there's actually meaningful content
    const hasContent = data.customer?.name?.trim() ||
      (data.lineItems || []).some(i => i.desc?.trim() || i.price > 0);

    if (!hasContent) {
      setAutosaveStatus('idle');
      return;
    }

    // Persist the current Firebase key so it survives page reloads
    if (currentFirebaseKey) data._firebaseKey = currentFirebaseKey;
    localStorage.setItem(draftKey, JSON.stringify(data));
    saveDocument(true); // update in place on Firebase
    setAutosaveStatus('saved');
    setTimeout(() => setAutosaveStatus('idle'), 3000);
  } catch(e) {
    console.warn('Draft save failed:', e);
    setAutosaveStatus('idle');
  }
}

function handleShippingChange(value) {
      const addressWrap = document.getElementById('address-fields-wrap');
      if (!addressWrap) return;
      const isPickup = value === 'Local Pickup - Brampton, ON';
      const pickupOption = document.getElementById('pickup-address-option');
      const pickupToggle = document.getElementById('pickup-address-enabled');
      if (isPickup && lastShippingValue && lastShippingValue !== value && pickupToggle) pickupToggle.checked = false;
      if (pickupOption) pickupOption.style.display = isPickup ? 'flex' : 'none';
      if (pickupToggle && !isPickup) pickupToggle.checked = false;
      if (pickupToggle && isPickup) addressWrap.style.display = pickupToggle.checked ? 'block' : 'none';
      else addressWrap.style.display = 'block';
      lastShippingValue = value;
      const freightWrap = document.getElementById('freight-details-wrap');
      const bolWrap = document.getElementById('freight-bol-wrap');
      const freightCompanyWrap = document.getElementById('freight-company-wrap');
      if (freightWrap) freightWrap.style.display = (value === 'Shipped via Freight' || value === 'Shipped via Parcel') ? 'flex' : 'none';
      if (bolWrap) bolWrap.style.display = value === 'Shipped via Freight' ? 'block' : 'none';
      if (freightCompanyWrap) freightCompanyWrap.style.display = value === 'Shipped via Freight' ? 'block' : 'none';
    }

    function refreshPickupAddressUI() {
      const isPickup = document.getElementById('doc-shipping')?.value === 'Local Pickup - Brampton, ON';
      const addressWrap = document.getElementById('address-fields-wrap');
      const pickupToggle = document.getElementById('pickup-address-enabled');
      if (addressWrap) addressWrap.style.display = (!isPickup || pickupToggle?.checked) ? 'block' : 'none';
    }

// ===== FREE ADDRESS AUTOCOMPLETE (Nominatim / OpenStreetMap) =====
    let addressTimer = null;
    function addressAutocomplete(query) {
      const box = document.getElementById('address-suggestions');
      clearTimeout(addressTimer);
      if (!query || query.length < 5) { box.style.display = 'none'; return; }
      addressTimer = setTimeout(async () => {
        try {
          const res = await fetch(`https://nominatim.openstreetmap.org/search?format=json&addressdetails=1&limit=5&countrycodes=ca&q=${encodeURIComponent(query)}`, {
            headers: { 'Accept-Language': 'en' }
          });
          const results = await res.json();
          if (!results.length) { box.style.display = 'none'; return; }
          box.innerHTML = results.map((r, i) => {
            const a = r.address || {};
            const road = a.road || a.house_number && `${a.house_number} ${a.road}` || '';
            const houseNum = a.house_number ? a.house_number + ' ' : '';
            const street = houseNum + (a.road || '');
            const city = a.city || a.town || a.village || a.hamlet || '';
            const state = a.state || a.province || '';
            const postal = a.postcode || '';
            const country = a.country || '';
            return `<div onclick="fillAddress('${encodeURIComponent(JSON.stringify({street, city, state, postal, country}))}')" style="padding:10px 12px;cursor:pointer;border-bottom:1px solid var(--border);font-size:12px;transition:background 0.15s;" onmouseover="this.style.background='var(--surface-2)'" onmouseout="this.style.background='transparent'">
              <div style="color:var(--text);font-weight:500;">${street}</div>
              <div style="color:var(--text-3);font-size:11px;">${[city, state, postal, country].filter(Boolean).join(', ')}</div>
            </div>`;
          }).join('');
          box.style.display = 'block';
        } catch(e) { box.style.display = 'none'; }
      }, 500);
    }

    function fillAddress(encoded) {
      const a = JSON.parse(decodeURIComponent(encoded));
      document.getElementById('cust-street').value  = a.street  || '';
      document.getElementById('cust-city').value    = a.city    || '';
      document.getElementById('cust-prov').value    = a.state   || '';
      document.getElementById('cust-postal').value  = a.postal  || '';
      document.getElementById('cust-country').value = a.country || '';
      document.getElementById('address-suggestions').style.display = 'none';
      scheduleAutosave();
    }

    // Close address suggestions when clicking outside
    document.addEventListener('click', (e) => {
      if (!e.target.closest('#cust-street') && !e.target.closest('#address-suggestions')) {
        const s = document.getElementById('address-suggestions');
        if (s) s.style.display = 'none';
      }
    });

function searchCustomers(query) {
      const dropdown = document.getElementById('customer-dropdown');
      db.ref('savedDocuments').once('value', (snap) => {
        const data = snap.val();
        if (!data) { dropdown.classList.remove('open'); return; }

        // Build a unique customer list from all saved docs
        const seen = {};
        const customers = [];
        Object.values(data).forEach(doc => {
          const cust = doc.customer;
          if (!cust || !cust.name) return;
          const key = cust.name.toLowerCase().trim();
          if (!seen[key]) {
            seen[key] = true;
            customers.push(cust);
          }
        });

        // Filter by query
        const q = query.toLowerCase().trim();
        const filtered = q
          ? customers.filter(c => c.name.toLowerCase().includes(q))
          : customers;

        if (filtered.length === 0) { dropdown.classList.remove('open'); return; }

        dropdown.innerHTML = '';
        filtered.forEach(cust => {
          const div = document.createElement('div');
          div.className = 'customer-option';
          div.innerHTML = `<strong>${cust.name}</strong><small>${[cust.street, cust.city, cust.prov].filter(Boolean).join(', ')}</small>`;
          div.onclick = () => {
            // Populate all customer fields
            document.getElementById('cust-name').value = cust.name || '';
            document.getElementById('cust-street').value = cust.street || '';
            document.getElementById('cust-city').value = cust.city || '';
            document.getElementById('cust-prov').value = cust.prov || '';
            document.getElementById('cust-postal').value = cust.postal || '';
            document.getElementById('cust-country').value = cust.country || 'Canada';
            document.getElementById('cust-email').value = cust.email || '';
            const searchEl = document.getElementById('customer-search');
            searchEl.value = '';
            searchEl.blur(); // dismiss keyboard on mobile
            dropdown.classList.remove('open');
            scheduleAutosave();
          };
          dropdown.appendChild(div);
        });
        dropdown.classList.add('open');
      });
    }

    // Close customer dropdown when clicking outside
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.customer-search-wrap')) {
        const dropdown = document.getElementById('customer-dropdown');
        if (dropdown) dropdown.classList.remove('open');
      }
    });

    function restoreDraft() {
      try {
        const raw = localStorage.getItem(draftKey);
        if (!raw) return;
        const draft = JSON.parse(raw);
        if (!draft || !draft.lineItems) return;
        if (confirm('You have an unsaved draft. Restore it?')) {
          // Restore the Firebase key so saves update the existing doc instead of creating a new one
          if (draft._firebaseKey) currentFirebaseKey = draft._firebaseKey;
          loadDocument(draft);
        } else {
          localStorage.removeItem(draftKey);
        }
      } catch(e) {
        localStorage.removeItem(draftKey);
      }
    }

    function setAutosaveStatus(state) {
      const dot = document.getElementById('autosave-dot');
      const label = document.getElementById('autosave-label');
      if (!dot || !label) return;
      dot.className = 'autosave-dot ' + (state === 'saving' ? 'saving' : state === 'saved' ? 'saved' : '');
      label.textContent = state === 'saving' ? 'Saving...' : state === 'saved' ? 'Draft Saved' : 'Draft';
    }

    // ====================== FIX 6: VALIDATION TOAST ======================
    function showToast(msg) {
      const toast = document.getElementById('toast');
      toast.textContent = msg;
      toast.classList.add('show');
      setTimeout(() => toast.classList.remove('show'), 3500);
    }

    function validateBeforeExport() {
      highlightMissingFields();

      const custName = document.getElementById('cust-name').value.trim();
      if (!custName) {
        showToast('⚠️ Customer name is missing — highlighted in yellow.');
        // Expand customer accordion if collapsed
        const acc = document.getElementById('accordion-customer');
        if (acc && !acc.open) acc.open = true;
        document.getElementById('cust-name')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      }
      const rows = document.querySelectorAll('.line-row');
      let hasItem = false;
      for (const row of rows) {
        const desc = row.querySelector('.item-desc').value.trim();
        const price = parseFloat(row.querySelector('.item-price').value) || 0;
        if (desc && price > 0) { hasItem = true; break; }
      }
      if (!hasItem) {
        showToast('⚠️ Add at least one item — highlighted in yellow.');
        return false;
      }
      return true;
    }

    async function loginWithEmail() {
      const email = document.getElementById('gate-email').value.trim();
      const password = document.getElementById('gate-password').value.trim();
      const errorEl = document.getElementById('gate-error');

      if (!email || !password) {
        errorEl.textContent = 'Please enter both email and password.';
        return;
      }

      try {
        errorEl.textContent = 'Signing in...';
        await auth.signInWithEmailAndPassword(email, password);
      } catch (error) {
        console.error(error);
        let msg = 'Login failed. Please check your credentials.';
        if (error.code === 'auth/user-not-found' || error.code === 'auth/wrong-password') {
          msg = 'Invalid email or password.';
        } else if (error.code === 'auth/invalid-email') {
          msg = 'Invalid email format.';
        }
        errorEl.textContent = msg;
      }
    }

    // ===== SEPARATE NUMBERING PER DOC TYPE =====
    function getNextDocNumber(data, type) {
      const prefix = type === 'INVOICE' ? 'INV' : type === 'QUOTE' ? 'QUO' : 'DEP';
      if (!data) return prefix + '-1001';
      const nums = Object.values(data)
        .filter(doc => doc.type === type)
        .map(doc => {
          const id = String(doc.id || '');
          const num = parseInt(id.replace(/^(INV|QUO|DEP)-/i, ''));
          return isNaN(num) ? 0 : num;
        });
      const next = nums.length > 0 ? Math.max(...nums) + 1 : 1001;
      return prefix + '-' + next;
    }

    function setType(type) {
      currentDocType = type;
      document.getElementById('pill-invoice').classList.toggle('active', type === 'INVOICE');
      document.getElementById('pill-quote').classList.toggle('active', type === 'QUOTE');
      document.getElementById('pill-deposit').classList.toggle('active', type === 'DEPOSIT');

      const label = type === 'INVOICE' ? 'Invoice #' : type === 'QUOTE' ? 'Quote #' : 'Deposit #';
      const title = type === 'INVOICE' ? 'TAX INVOICE' : type === 'QUOTE' ? 'OFFICIAL QUOTE' : 'DEPOSIT CONFIRMATION';
      document.getElementById('doc-id-label').innerText = label;
      document.getElementById('canvas-title').innerText = title;

      // Refresh doc number when switching types — but only on a blank/new doc
      const currentId = document.getElementById('doc-id').value || '';
      const isNewDoc = !currentFirebaseKey || /^(INV|QUO|DEP)-/.test(currentId) || currentId === '';
      if (isNewDoc && !isHydratingDocument) {
        db.ref('savedDocuments').once('value', (snap) => {
          document.getElementById('doc-id').value = getNextDocNumber(snap.val(), type);
        });
      }

      // HST — only on invoices
      const hst = document.getElementById('hst-line');
      if (hst) hst.style.display = type === 'INVOICE' ? '' : 'none';

      // Deposit amount field — only on deposit type
      const depositWrap = document.getElementById('deposit-amount-wrap');
      if (depositWrap) depositWrap.style.display = type === 'DEPOSIT' ? 'flex' : 'none';

      // Update notes label and content based on doc type
      const notesLabel = document.getElementById('notes-label');
      const notesField = document.getElementById('doc-notes');
      if (type === 'DEPOSIT') {
        if (notesLabel) notesLabel.textContent = 'Important Notice (Public)';
        if (notesField && !notesField.dataset.userEdited) {
          notesField.value = `⚠ IMPORTANT — PLEASE READ\n\nThis document confirms a deposit has been received and must be presented in its original form when paying the remaining balance.\n\nUpon receipt of full payment, this deposit confirmation must be returned to Global JDM Auto Parts and will no longer be valid. Failure to present this document may result in delays.\n\nThis document is non-transferable.`;
        }
      } else if (type === 'QUOTE') {
        if (notesLabel) notesLabel.textContent = 'Quote Terms (Public)';
        if (notesField && !notesField.dataset.userEdited) {
          notesField.value = `This document is a quote only and does not constitute a confirmed order or payment obligation.\n\nPrices quoted are valid for 30 days from the date of issue and are subject to change without notice.\n\nTo proceed with this order, please contact Global JDM Auto Parts to confirm availability and arrange payment.\n\nGlobal JDM Auto Parts\n11 Blair Drive, Brampton, Ontario\n905-460-9797`;
        }
      } else {
        if (notesLabel) notesLabel.textContent = 'Warranty & Engine Terms (Public)';
        if (notesField && !notesField.dataset.userEdited) {
          notesField.value = buildDefaultNotes();
        }
      }

      // Paid toggle — only on invoices
      updatePaidToggleUI(type === 'INVOICE' ? 'unpaid' : 'quote');

      // Convert to invoice button — only visible on quotes
      const convertBtn = document.getElementById('btn-convert-to-invoice');
      if (convertBtn) convertBtn.style.display = type === 'QUOTE' ? 'block' : 'none';
      calc();
      scheduleAutosave();
    }

    // ===== CONVERT QUOTE TO INVOICE =====
    function convertQuoteToInvoice() {
      if (currentDocType !== 'QUOTE') return;
      if (!confirm('Convert this Quote to an Invoice? This will change the document type and assign the next invoice number.')) return;

      // Get next invoice number
      db.ref('savedDocuments').once('value', (snap) => {
        const nextId = getNextDocNumber(snap.val(), 'INVOICE');
        document.getElementById('doc-id').value = nextId;
        const notesField = document.getElementById('doc-notes');
        if (notesField) delete notesField.dataset.userEdited;
        setType('INVOICE');
        showToast('✓ Quote converted to ' + nextId);
        scheduleAutosave();
      });
    }

    // ===== GUIDED MODE =====
    let guidedModeEnabled = false;
    let guidedStep = 1;
    const GUIDED_TOTAL_STEPS = 4;
    const GUIDED_FIRST_STEP = 0;
    let guidedLineItems = [];

    function toggleGuidedMode() {
      guidedModeEnabled = !guidedModeEnabled;
      const btn = document.getElementById('guided-mode-btn');
      const status = document.getElementById('guided-mode-status');
      if (guidedModeEnabled) {
        btn.classList.add('active');
        status.textContent = 'On';
        openGuidedModal();
      } else {
        btn.classList.remove('active');
        status.textContent = 'Off';
        closeGuidedModal();
      }
    }

    function openGuidedModal() {
      guidedStep = 0;
      guidedLineItems = [{ desc: '', sku: '', qty: 1, price: '' }];
      document.getElementById('guided-overlay').classList.add('open');
      document.getElementById('guided-modal').classList.add('open');
      renderGuidedStep();
    }

    function closeGuidedModal() {
      document.getElementById('guided-overlay').classList.remove('open');
      document.getElementById('guided-modal').classList.remove('open');
      guidedModeEnabled = false;
      const btn = document.getElementById('guided-mode-btn');
      const status = document.getElementById('guided-mode-status');
      if (btn) btn.classList.remove('active');
      if (status) status.textContent = 'Off';
    }

    function highlightMissingFields() {
      // Fields to check: [ elementId, required? ]
      const fields = [
        ['cust-name',    true],
        ['cust-street',  false],
        ['cust-city',    false],
        ['cust-prov',    false],
        ['cust-postal',  false],
        ['cust-country', false],
        ['doc-notes',    false],
      ];

      fields.forEach(([id, required]) => {
        const el = document.getElementById(id);
        if (!el) return;
        const isEmpty = !el.value.trim();
        if (isEmpty) {
          el.classList.add('guided-field-missing');
          // Remove highlight as soon as user starts typing
          el.addEventListener('input', function clearHighlight() {
            el.classList.remove('guided-field-missing');
            el.removeEventListener('input', clearHighlight);
          });
        }
      });

      // Check line items — highlight any desc or price that's empty
      document.querySelectorAll('.line-row').forEach(row => {
        const desc  = row.querySelector('.item-desc');
        const price = row.querySelector('.item-price');
        if (desc && !desc.value.trim()) {
          desc.classList.add('guided-field-missing');
          desc.addEventListener('input', function clearHighlight() {
            desc.classList.remove('guided-field-missing');
            desc.removeEventListener('input', clearHighlight);
          });
        }
        if (price && (!price.value || parseFloat(price.value) === 0)) {
          price.classList.add('guided-field-missing');
          price.addEventListener('input', function clearHighlight() {
            price.classList.remove('guided-field-missing');
            price.removeEventListener('input', clearHighlight);
          });
        }
      });
    }

    function renderGuidedStep() {
      const stepLabel = document.getElementById('guided-step-label');
      const title = document.getElementById('guided-title');
      const body = document.getElementById('guided-body');
      const backBtn = document.getElementById('guided-back-btn');
      const nextBtn = document.getElementById('guided-next-btn');

      // Update progress pips
      for (let i = 1; i <= GUIDED_TOTAL_STEPS; i++) {
        const pip = document.getElementById(`guided-pip-${i}`);
        if (pip) pip.classList.toggle('done', i <= guidedStep);
      }

      backBtn.style.display = guidedStep > 0 ? 'block' : 'none';
      nextBtn.textContent = guidedStep === GUIDED_TOTAL_STEPS ? '✓ Finish' : 'Next →';

      stepLabel.textContent = guidedStep === 0 ? 'Getting Started' : `Step ${guidedStep} of ${GUIDED_TOTAL_STEPS}`;

      if (guidedStep === 0) {
        title.textContent = 'Document Type';
        body.innerHTML = `
          <div class="guided-step-hint">What type of document are you creating today?</div>
          <div style="display:flex;flex-direction:column;gap:12px;margin-top:8px;">
            <button onclick="guidedSelectType('INVOICE')" id="gd-type-invoice" style="display:flex;align-items:center;gap:16px;padding:18px 20px;background:var(--surface-2);border:2px solid ${currentDocType==='INVOICE'?'var(--accent)':'var(--border)'};border-radius:var(--radius);cursor:pointer;transition:all 0.2s;text-align:left;width:100%;">
              <span style="font-size:28px;">📄</span>
              <div>
                <div style="font-family:var(--font-head);font-weight:700;font-size:14px;color:var(--text);">Invoice</div>
                <div style="font-size:12px;color:var(--text-3);margin-top:2px;">Full payment document with HST</div>
              </div>
              ${currentDocType==='INVOICE'?'<span style="margin-left:auto;color:var(--accent);font-size:18px;">✓</span>':''}
            </button>
            <button onclick="guidedSelectType('QUOTE')" id="gd-type-quote" style="display:flex;align-items:center;gap:16px;padding:18px 20px;background:var(--surface-2);border:2px solid ${currentDocType==='QUOTE'?'var(--accent)':'var(--border)'};border-radius:var(--radius);cursor:pointer;transition:all 0.2s;text-align:left;width:100%;">
              <span style="font-size:28px;">📋</span>
              <div>
                <div style="font-family:var(--font-head);font-weight:700;font-size:14px;color:var(--text);">Quote</div>
                <div style="font-size:12px;color:var(--text-3);margin-top:2px;">Price estimate, valid for 30 days</div>
              </div>
              ${currentDocType==='QUOTE'?'<span style="margin-left:auto;color:var(--accent);font-size:18px;">✓</span>':''}
            </button>
            <button onclick="guidedSelectType('DEPOSIT')" id="gd-type-deposit" style="display:flex;align-items:center;gap:16px;padding:18px 20px;background:var(--surface-2);border:2px solid ${currentDocType==='DEPOSIT'?'var(--accent)':'var(--border)'};border-radius:var(--radius);cursor:pointer;transition:all 0.2s;text-align:left;width:100%;">
              <span style="font-size:28px;">💰</span>
              <div>
                <div style="font-family:var(--font-head);font-weight:700;font-size:14px;color:var(--text);">Deposit</div>
                <div style="font-size:12px;color:var(--text-3);margin-top:2px;">Deposit confirmation with balance due</div>
              </div>
              ${currentDocType==='DEPOSIT'?'<span style="margin-left:auto;color:var(--accent);font-size:18px;">✓</span>':''}
            </button>
          </div>
        `;
      }

      else if (guidedStep === 1) {
        title.textContent = 'Customer Information';
        const cur = {
          name:    document.getElementById('cust-name')?.value    || '',
          street:  document.getElementById('cust-street')?.value  || '',
          city:    document.getElementById('cust-city')?.value    || '',
          prov:    document.getElementById('cust-prov')?.value    || '',
          postal:  document.getElementById('cust-postal')?.value  || '',
          country: document.getElementById('cust-country')?.value || '',
          email:   document.getElementById('cust-email')?.value   || '',
        };
        body.innerHTML = `
          <div class="guided-step-hint">Fill in the customer's details. All address fields will autofill once you start typing the street address.</div>
          <div class="input-wrap"><label class="input-label">Full Name *</label><input type="text" id="gd-name" class="ui-input" placeholder="Client Name" value="${cur.name}"></div>
          <div class="input-wrap" style="position:relative;">
            <label class="input-label">Street Address</label>
            <input type="text" id="gd-street" class="ui-input" placeholder="123 Street Name — type to search..." autocomplete="off" value="${cur.street}" oninput="guidedAddressAutocomplete(this.value)">
            <div id="gd-address-suggestions" style="display:none;position:absolute;top:100%;left:0;right:0;background:var(--surface-3);border:1px solid var(--border-light);border-radius:var(--radius);z-index:9000;max-height:200px;overflow-y:auto;"></div>
          </div>
          <div style="display:grid;grid-template-columns:1.2fr 1fr;gap:10px;">
            <div class="input-wrap"><label class="input-label">City</label><input type="text" id="gd-city" class="ui-input" placeholder="City" value="${cur.city}"></div>
            <div class="input-wrap"><label class="input-label">Prov / State</label><input type="text" id="gd-prov" class="ui-input" placeholder="Province" value="${cur.prov}"></div>
          </div>
          <div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;">
            <div class="input-wrap"><label class="input-label">Postal / Zip</label><input type="text" id="gd-postal" class="ui-input" placeholder="Postal Code" value="${cur.postal}"></div>
            <div class="input-wrap"><label class="input-label">Country</label><input type="text" id="gd-country" class="ui-input" placeholder="Country" value="${cur.country}"></div>
          </div>
          <div class="input-wrap"><label class="input-label">Email Address</label><input type="email" id="gd-email" class="ui-input" placeholder="customer@email.com" value="${cur.email}"></div>
        `;
      }

      else if (guidedStep === 2) {
        title.textContent = 'Line Items';
        body.innerHTML = `
          <div class="guided-step-hint">Add the parts or services for this ${currentDocType.toLowerCase()}. You can add as many rows as you need.</div>
          <div id="gd-line-rows"></div>
          <button class="guided-add-row-btn" onclick="guidedAddRow()">+ Add Another Item</button>
        `;
        renderGuidedLineRows();
      }

      else if (guidedStep === 3) {
        title.textContent = 'Notes & Totals';
        const notesVal = document.getElementById('doc-notes')?.value || '';
        const taxVal   = document.getElementById('doc-tax-rate')?.value || '13';
        const discVal  = document.getElementById('doc-discount')?.value || '0';
        const currVal  = document.getElementById('doc-currency')?.value || 'CAD';
        const shipVal  = document.getElementById('doc-shipping')?.value || '';
        body.innerHTML = `
          <div class="guided-step-hint">Review the public-facing notes, tax, discount, and shipping terms.</div>
          <div class="input-wrap">
            <label class="input-label" id="gd-notes-label">${currentDocType === 'DEPOSIT' ? 'Important Notice (Public)' : currentDocType === 'QUOTE' ? 'Quote Terms (Public)' : 'Warranty & Engine Terms (Public)'}</label>
            <textarea id="gd-notes" class="ui-textarea" style="min-height:140px;">${notesVal}</textarea>
          </div>
          <div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;">
            <div class="input-wrap"><label class="input-label">Tax Rate (%)</label><input type="number" id="gd-tax" class="ui-input" value="${taxVal}" step="0.1" inputmode="decimal"></div>
            <div class="input-wrap"><label class="input-label">Discount ($)</label><input type="number" id="gd-discount" class="ui-input" value="${discVal}" step="0.01" inputmode="decimal"></div>
          </div>
          <div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;">
            <div class="input-wrap">
              <label class="input-label">Currency</label>
              <select id="gd-currency" class="ui-select">
                <option value="CAD" ${currVal==='CAD'?'selected':''}>CAD</option>
                <option value="USD" ${currVal==='USD'?'selected':''}>USD</option>
              </select>
            </div>
            <div class="input-wrap">
              <label class="input-label">Shipping Terms</label>
              <select id="gd-shipping" class="ui-select">
                <option value="DDU - Duties Unpaid (USA Freight)" ${shipVal.includes('DDU')?'selected':''}>DDU - USA Freight</option>
                <option value="Local Pickup - Brampton, ON" ${shipVal.includes('Local')?'selected':''}>Local Pickup</option>
                <option value="DAP - Delivered at Place" ${shipVal.includes('DAP')?'selected':''}>DAP - Delivered</option>
                <option value="FOB - Free on Board" ${shipVal.includes('FOB')?'selected':''}>FOB - Port</option>
              </select>
            </div>
          </div>
          ${currentDocType === 'DEPOSIT' ? `
          <div class="input-wrap" id="gd-deposit-wrap">
            <label class="input-label">Deposit Amount ($)</label>
            <input type="number" id="gd-deposit-amount" class="ui-input" placeholder="0.00" step="0.01" inputmode="decimal" value="${document.getElementById('deposit-amount')?.value || ''}">
          </div>` : ''}
        `;
      }

      else if (guidedStep === 4) {
        title.textContent = 'Internal Memo & Settings';
        const memoVal = document.getElementById('doc-memo')?.value || '';
        body.innerHTML = `
          <div class="guided-step-hint">This section is private — it never appears on the PDF. Use it for internal notes, follow-up reminders, or anything you want to remember about this job.</div>
          <div class="input-wrap">
            <label class="input-label">Internal Memo (Private)</label>
            <textarea id="gd-memo" class="ui-textarea" style="min-height:120px;" placeholder="e.g. Customer paid deposit, waiting on shipping quote...">${memoVal}</textarea>
          </div>
        `;
      }
    }

    function renderGuidedLineRows() {
      const container = document.getElementById('gd-line-rows');
      if (!container) return;
      container.innerHTML = guidedLineItems.map((item, i) => `
        <div class="guided-line-row" style="margin-bottom:10px;">
          <div style="display:flex;justify-content:space-between;align-items:center;">
            <span class="guided-line-row-num">Item ${i + 1}</span>
            ${guidedLineItems.length > 1 ? `<button class="guided-remove-row" onclick="guidedRemoveRow(${i})">✕</button>` : ''}
          </div>
          <div class="input-wrap"><label class="input-label">Description *</label><input type="text" class="ui-input gd-item-desc" list="inventory-list" placeholder="Search product..." value="${item.desc}" oninput="guidedItemInput(${i}, this.value)" onchange="guidedItemChange(${i}, this.value)" autocomplete="off"></div>
          <div class="guided-line-grid">
            <div class="input-wrap"><label class="input-label">SKU / Item ID</label><input type="text" class="ui-input gd-item-sku" placeholder="Item-ID" value="${item.sku}" oninput="guidedSaveRow(${i})"></div>
            <div class="input-wrap"><label class="input-label">Qty</label><input type="number" class="ui-input gd-item-qty" value="${item.qty}" min="1" inputmode="numeric" oninput="guidedSaveRow(${i})"></div>
            <div class="input-wrap"><label class="input-label">Price ($)</label><input type="number" class="ui-input gd-item-price" placeholder="0.00" value="${item.price}" step="0.01" inputmode="decimal" oninput="guidedSaveRow(${i})"></div>
          </div>
        </div>
      `).join('');
    }

    function guidedSaveRow(i) {
      const rows = document.querySelectorAll('#gd-line-rows .guided-line-row');
      const row = rows[i];
      if (!row) return;
      guidedLineItems[i] = {
        desc:  row.querySelector('.gd-item-desc')?.value  || '',
        sku:   row.querySelector('.gd-item-sku')?.value   || '',
        qty:   row.querySelector('.gd-item-qty')?.value   || 1,
        price: row.querySelector('.gd-item-price')?.value || '',
      };
    }

    function guidedItemInput(i, val) {
      guidedSaveRow(i);
    }

    function guidedItemChange(i, val) {
      if (inventory[val]) {
        guidedLineItems[i].price = inventory[val].price.toFixed(2);
        guidedLineItems[i].sku   = inventory[val].sku;
        renderGuidedLineRows();
      }
    }

    function guidedAddRow() {
      // Save current rows first
      document.querySelectorAll('#gd-line-rows .guided-line-row').forEach((row, i) => {
        guidedLineItems[i] = {
          desc:  row.querySelector('.gd-item-desc')?.value  || '',
          sku:   row.querySelector('.gd-item-sku')?.value   || '',
          qty:   row.querySelector('.gd-item-qty')?.value   || 1,
          price: row.querySelector('.gd-item-price')?.value || '',
        };
      });
      guidedLineItems.push({ desc: '', sku: '', qty: 1, price: '' });
      renderGuidedLineRows();
      // Scroll to new row
      setTimeout(() => {
        const container = document.getElementById('guided-body');
        if (container) container.scrollTop = container.scrollHeight;
      }, 50);
    }

    function guidedRemoveRow(i) {
      if (guidedLineItems.length <= 1) return;
      document.querySelectorAll('#gd-line-rows .guided-line-row').forEach((row, idx) => {
        guidedLineItems[idx] = {
          desc:  row.querySelector('.gd-item-desc')?.value  || '',
          sku:   row.querySelector('.gd-item-sku')?.value   || '',
          qty:   row.querySelector('.gd-item-qty')?.value   || 1,
          price: row.querySelector('.gd-item-price')?.value || '',
        };
      });
      guidedLineItems.splice(i, 1);
      renderGuidedLineRows();
    }

    function guidedNext() {
      // Validate & save current step before advancing
      if (guidedStep === 0) {
        if (!currentDocType) { showToast('⚠️ Please select a document type.'); return; }
      }

      else if (guidedStep === 1) {
        const name = document.getElementById('gd-name')?.value.trim();
        if (!name) { showToast('⚠️ Please enter a customer name.'); return; }
        // Commit step 1 to main form
        document.getElementById('cust-name').value    = name;
        document.getElementById('cust-street').value  = document.getElementById('gd-street')?.value  || '';
        document.getElementById('cust-city').value    = document.getElementById('gd-city')?.value    || '';
        document.getElementById('cust-prov').value    = document.getElementById('gd-prov')?.value    || '';
        document.getElementById('cust-postal').value  = document.getElementById('gd-postal')?.value  || '';
        document.getElementById('cust-country').value = document.getElementById('gd-country')?.value || '';
        document.getElementById('cust-email').value   = document.getElementById('gd-email')?.value   || '';
      }

      else if (guidedStep === 2) {
        // Save all rows
        document.querySelectorAll('#gd-line-rows .guided-line-row').forEach((row, i) => {
          guidedLineItems[i] = {
            desc:  row.querySelector('.gd-item-desc')?.value  || '',
            sku:   row.querySelector('.gd-item-sku')?.value   || '',
            qty:   row.querySelector('.gd-item-qty')?.value   || 1,
            price: row.querySelector('.gd-item-price')?.value || '',
          };
        });
        const hasItem = guidedLineItems.some(i => i.desc.trim() && parseFloat(i.price) > 0);
        if (!hasItem) { showToast('⚠️ Add at least one item with a description and price.'); return; }
      }

      else if (guidedStep === 3) {
        // Commit step 3
        const notesEl   = document.getElementById('doc-notes');
        const taxEl     = document.getElementById('doc-tax-rate');
        const discEl    = document.getElementById('doc-discount');
        const currEl    = document.getElementById('doc-currency');
        const shipEl    = document.getElementById('doc-shipping');
        if (notesEl)   notesEl.value   = document.getElementById('gd-notes')?.value   || '';
        if (taxEl)     taxEl.value     = document.getElementById('gd-tax')?.value     || '13';
        if (discEl)    discEl.value    = document.getElementById('gd-discount')?.value || '0';
        if (currEl)    currEl.value    = document.getElementById('gd-currency')?.value || 'CAD';
        if (shipEl)    shipEl.value    = document.getElementById('gd-shipping')?.value || '';
        if (currentDocType === 'DEPOSIT') {
          const depEl = document.getElementById('deposit-amount');
          if (depEl) depEl.value = document.getElementById('gd-deposit-amount')?.value || '';
        }
      }

      if (guidedStep < GUIDED_TOTAL_STEPS) {
        guidedStep++;
        renderGuidedStep();
        document.getElementById('guided-body').scrollTop = 0;
      } else {
        // Final step — commit memo and flush line items to the real form
        const memoEl = document.getElementById('doc-memo');
        if (memoEl) memoEl.value = document.getElementById('gd-memo')?.value || '';

        // Clear existing line rows and repopulate
        const tbody = document.getElementById('line-items');
        tbody.innerHTML = '';
        guidedLineItems.forEach((item, i) => {
          addRow();
          const rows = tbody.querySelectorAll('tr.line-row');
          const row = rows[rows.length - 1];
          if (!row) return;
          row.querySelector('.item-desc').value  = item.desc;
          row.querySelector('.item-sku').value   = item.sku;
          row.querySelector('.item-qty').value   = item.qty;
          row.querySelector('.item-price').value = item.price;
        });

        calc();
        scheduleAutosave();
        closeGuidedModal();
        setTimeout(highlightMissingFields, 300);
        showToast('✓ All done! Review and export when ready.');

        // Scroll to top of canvas
        setTimeout(() => {
          document.querySelector('.canvas')?.scrollTo({ top: 0, behavior: 'smooth' });
        }, 200);
      }
    }

    function guidedSelectType(type) {
      setType(type);
      renderGuidedStep();
    }

    function guidedBack() {
      if (guidedStep > 1) {
        guidedStep--;
        renderGuidedStep();
        document.getElementById('guided-body').scrollTop = 0;
      }
    }

    // Address autocomplete inside guided modal
    let guidedAddressTimer = null;
    function guidedAddressAutocomplete(query) {
      const box = document.getElementById('gd-address-suggestions');
      clearTimeout(guidedAddressTimer);
      if (!query || query.length < 5) { box.style.display = 'none'; return; }
      guidedAddressTimer = setTimeout(async () => {
        try {
          const res = await fetch(`https://nominatim.openstreetmap.org/search?format=json&addressdetails=1&limit=5&countrycodes=ca&q=${encodeURIComponent(query)}`, {
            headers: { 'Accept-Language': 'en' }
          });
          const results = await res.json();
          if (!results.length) { box.style.display = 'none'; return; }
          box.innerHTML = results.map(r => {
            const a = r.address || {};
            const street  = (a.house_number ? a.house_number + ' ' : '') + (a.road || '');
            const city    = a.city || a.town || a.village || a.hamlet || '';
            const state   = a.state || a.province || '';
            const postal  = a.postcode || '';
            const country = a.country || '';
            return `<div onclick="guidedFillAddress('${encodeURIComponent(JSON.stringify({street,city,state,postal,country}))}')" style="padding:10px 12px;cursor:pointer;border-bottom:1px solid var(--border);font-size:12px;transition:background 0.15s;" onmouseover="this.style.background='var(--surface-2)'" onmouseout="this.style.background='transparent'">
              <div style="color:var(--text);font-weight:500;">${street}</div>
              <div style="color:var(--text-3);font-size:11px;">${[city,state,postal,country].filter(Boolean).join(', ')}</div>
            </div>`;
          }).join('');
          box.style.display = 'block';
        } catch(e) { box.style.display = 'none'; }
      }, 500);
    }

    function guidedFillAddress(encoded) {
      const a = JSON.parse(decodeURIComponent(encoded));
      const set = (id, val) => { const el = document.getElementById(id); if (el) el.value = val || ''; };
      set('gd-street',  a.street);
      set('gd-city',    a.city);
      set('gd-prov',    a.state);
      set('gd-postal',  a.postal);
      set('gd-country', a.country);
      document.getElementById('gd-address-suggestions').style.display = 'none';
    }

    function addRow() {
      const tbody = document.getElementById('line-items');
      const count = tbody.querySelectorAll('tr').length + 1;
      const row = document.createElement('tr');
      row.className = 'line-row';
      row.dataset.rowKey = Date.now();

      // FIX 4: iOS autocomplete - use both oninput and onchange, remove capture="camera" to allow photo library too
      row.innerHTML = `
        <td style="color: var(--text-3); font-size: 10px;">${count}</td>
        <td><input type="text" class="line-input item-desc" list="inventory-list" placeholder="Search product..." autocomplete="off" oninput="onItemSelectDebounced(this)" onchange="onItemSelect(this)"></td>
        <td><input type="text" class="line-input item-sku" placeholder="Item-ID"></td>
        <td><input type="number" class="line-input qty-cell item-qty" value="1" inputmode="numeric" oninput="calc()" placeholder="Qty" style="width:100%;text-align:right;"></td>
        <td><input type="number" class="line-input price-cell item-price" value="" step="0.01" inputmode="decimal" oninput="calc()" placeholder="0.00" style="width:100%;text-align:right;"></td>
        <td class="line-total-cell item-total">$0.00</td>
        <td style="text-align:center;vertical-align:middle;padding:0 4px;" title="Tax exemption type">
          <select class="item-no-tax" onchange="calc();scheduleAutosave();" style="background:var(--surface-2);border:1px solid var(--border);border-radius:4px;color:var(--text);font-size:9px;padding:4px 2px;cursor:pointer;width:68px;text-align:center;">
            <option value="">Tax</option>
            <option value="export">No Tax (Export)</option>
            <option value="local">No Tax (Local)</option>
            <option value="shipping">No Tax (Shipping)</option>
          </select>
        </td>
        <td class="photo-cell">
          <div class="photo-multi-container">
            <div class="thumbs-wrapper"></div>
            <button onclick="triggerCamera(this)" class="btn-camera">📸</button>
            <input type="file" class="photo-input" accept="image/*" multiple style="display:none;" onchange="handlePhotoUpload(this)">
          </div>
        </td>
        <td><button class="btn-danger" onclick="removeRow(this)">✕</button></td>
      `;
      tbody.appendChild(row);
    }

    function triggerCamera(btn) {
      btn.closest('tr').querySelector('.photo-input').click();
    }

    // ====================== FIX 2: COMPRESS PHOTOS ON UPLOAD ======================
    async function handlePhotoUpload(input) {
      const files = input.files;
      if (!files || !files.length) return;
      const row = input.closest('tr');
      const rowKey = row.dataset.rowKey;
      let photos = currentPhotos.get(rowKey) || [];

      for (const file of Array.from(files)) {
        const raw = await readFileAsBase64(file);
        // Compress to max 1200px wide, 0.80 quality - good enough for PDF, small enough for Firebase
        const compressed = await resizeImage(raw, 1200, 0.80);
        photos.push(compressed);
      }

      currentPhotos.set(rowKey, [...photos]);
      refreshPhotoGallery(row);
      scheduleAutosave();
    }

    function readFileAsBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    }

    function refreshPhotoGallery(row) {
      const wrapper = row.querySelector('.thumbs-wrapper');
      if (!wrapper) return;
      wrapper.innerHTML = '';
      const rowKey = row.dataset.rowKey;
      const photos = currentPhotos.get(rowKey) || [];
      photos.forEach((base64, idx) => {
        const thumbDiv = document.createElement('div');
        thumbDiv.className = 'photo-thumb-multi';
        thumbDiv.dataset.index = idx;

        const img = document.createElement('img');
        img.src = base64;
        thumbDiv.appendChild(img);

        const del = document.createElement('span');
        del.className = 'delete-btn';
        del.textContent = '×';
        del.onclick = (e) => {
          e.stopImmediatePropagation();
          removePhotoFromRow(del);
        };
        thumbDiv.appendChild(del);

        wrapper.appendChild(thumbDiv);
      });
    }

    function removePhotoFromRow(delBtn) {
      const thumbDiv = delBtn.parentElement;
      const index = parseInt(thumbDiv.dataset.index);
      const row = thumbDiv.closest('tr');
      if (!row) return;
      const rowKey = row.dataset.rowKey;
      let photos = currentPhotos.get(rowKey) || [];
      if (index >= 0 && index < photos.length) {
        photos.splice(index, 1);
        currentPhotos.set(rowKey, photos);
      }
      refreshPhotoGallery(row);
    }

    function removeRow(btn) {
      const rows = document.querySelectorAll('.line-row');
      if (rows.length > 1) {
        const row = btn.closest('tr');
        currentPhotos.delete(row.dataset.rowKey);
        row.remove();
        calc();
        scheduleAutosave();
      }
    }

    // FIX 4: iOS datalist debounced input handler
    let itemSelectTimer = null;
    function onItemSelectDebounced(input) {
      clearTimeout(itemSelectTimer);
      itemSelectTimer = setTimeout(() => onItemSelect(input), 300);
    }

    function onItemSelect(input) {
      const val = input.value;
      const row = input.closest('tr');
      const noTaxBox = row.querySelector('.item-no-tax');
      if (noTaxBox && /^shipping$/i.test(val.trim())) {
        noTaxBox.value = 'local';
        calc();
        scheduleAutosave();
      }
      if (inventory[val]) {
        row.querySelector('.item-price').value = inventory[val].price.toFixed(2);
        row.querySelector('.item-sku').value = inventory[val].sku;
        calc();
        scheduleAutosave();
      } else {
        // Custom product — focus price field so user can type immediately
        const priceField = row.querySelector('.item-price');
        if (priceField && (parseFloat(priceField.value) === 0 || priceField.value === '0.00')) {
          priceField.value = '';
          priceField.focus();
        }
      }
    }

    function calc() {
      let sub = 0;
      let noTaxSub = 0;
      const rows = document.querySelectorAll('.line-row');
      rows.forEach(row => {
        const qty = parseFloat(row.querySelector('.item-qty').value) || 0;
        const prc = parseFloat(row.querySelector('.item-price').value) || 0;
        const total = qty * prc;
        sub += total;
        if (row.querySelector('.item-no-tax')?.value) noTaxSub += total;
        row.querySelector('.item-total').innerText = '$' + total.toLocaleString(undefined, {minimumFractionDigits: 2});
      });

      const discount = parseFloat(document.getElementById('doc-discount').value) || 0;
      const isExport = document.getElementById('doc-export')?.checked || false;
      const taxRateInput = document.getElementById('doc-tax-rate');
      const taxRate = isExport ? 0 : (parseFloat(taxRateInput?.value) || 0);
      const taxableSub = (sub - noTaxSub) - discount;
      const taxAmount = taxableSub * (taxRate / 100);
      const grand = sub - discount + taxAmount;

      // Disable the tax rate input + swap visible tax row for export note
      if (taxRateInput) {
        taxRateInput.disabled = isExport;
        taxRateInput.style.opacity = isExport ? '0.4' : '1';
      }
      const taxLine    = document.getElementById('tax-line');
      const exportLine = document.getElementById('export-line');
      if (taxLine)    taxLine.style.display    = isExport ? 'none' : '';
      if (exportLine) exportLine.style.display = isExport ? 'flex' : 'none';

      document.getElementById('subtotal-val').innerText = '$' + sub.toLocaleString(undefined, {minimumFractionDigits: 2});
      document.getElementById('tax-label').innerText = `Tax (${taxRate}%)`;
      document.getElementById('tax-val').innerText = '$' + taxAmount.toLocaleString(undefined, {minimumFractionDigits: 2});
      document.getElementById('grand-total-display').innerText = '$' + grand.toLocaleString(undefined, {minimumFractionDigits: 2});

      // Show balance due row if deposit mode
      const depositAmount = parseFloat(document.getElementById('doc-deposit-amount')?.value) || 0;
      const balanceRow = document.getElementById('balance-due-row');
      const depositRow = document.getElementById('deposit-paid-row');
      if (balanceRow && depositRow) {
        if (currentDocType === 'DEPOSIT' && depositAmount > 0) {
          const balance = grand - depositAmount;
          document.getElementById('deposit-paid-val').innerText = '$' + depositAmount.toLocaleString(undefined, {minimumFractionDigits: 2});
          document.getElementById('balance-due-val').innerText = '$' + Math.max(0, balance).toLocaleString(undefined, {minimumFractionDigits: 2});
          depositRow.style.display = 'flex';
          balanceRow.style.display = 'flex';
        } else {
          depositRow.style.display = 'none';
          balanceRow.style.display = 'none';
        }
      }
    }

    function getDocumentData() {
      const isExport = document.getElementById('doc-export')?.checked || false;
      const isLocalPickup = document.getElementById('doc-shipping').value === 'Local Pickup - Brampton, ON';
      const includePickupAddress = !isLocalPickup || document.getElementById('pickup-address-enabled')?.checked === true;
      const data = {
        id: document.getElementById('doc-id').value || '1001',
        type: currentDocType,
        date: document.getElementById('doc-date').value || new Date().toISOString().split('T')[0],
        shipping: document.getElementById('doc-shipping').value,
        pickupAddressEnabled: isLocalPickup && includePickupAddress,
        freightCompany: document.getElementById('freight-company')?.value || '',
        freightTracking: document.getElementById('freight-tracking')?.value || '',
        freightBol: document.getElementById('freight-bol')?.value || '',
        currency: document.getElementById('doc-currency').value,
        taxRate: isExport ? 0 : (parseFloat(document.getElementById('doc-tax-rate').value) || 0),
        isExport: isExport,
        discount: parseFloat(document.getElementById('doc-discount').value) || 0,
        depositAmount: parseFloat(document.getElementById('doc-deposit-amount').value) || 0,
        customer: {
          name: document.getElementById('cust-name').value || '',
          street: includePickupAddress ? (document.getElementById('cust-street').value || '') : '',
          city: includePickupAddress ? (document.getElementById('cust-city').value || '') : '',
          prov: includePickupAddress ? (document.getElementById('cust-prov').value || 'Ontario') : '',
          postal: includePickupAddress ? (document.getElementById('cust-postal').value || '') : '',
          country: includePickupAddress ? (document.getElementById('cust-country').value || 'Canada') : '',
          email: document.getElementById('cust-email').value || ''
        },
        notes: document.getElementById('doc-notes').value || '',
        memo: document.getElementById('doc-memo').value || '',
        lineItems: []
      };

      const rows = document.querySelectorAll('.line-row');
      rows.forEach((row) => {
        const desc = row.querySelector('.item-desc').value || '';
        const sku = row.querySelector('.item-sku').value || '';
        const qty = parseFloat(row.querySelector('.item-qty').value) || 1;
        const price = parseFloat(row.querySelector('.item-price').value) || 0;
        const rowKey = row.dataset.rowKey;
        const photos = currentPhotos.get(rowKey) || [];

        const noTax = row.querySelector('.item-no-tax')?.value || '';
        data.lineItems.push({ desc, sku, qty, price, noTax, photos: [...photos] });
      });

      let sub = data.lineItems.reduce((acc, item) => acc + (item.qty * item.price), 0);
      const noTaxSub = data.lineItems.filter(i => i.noTax).reduce((acc, item) => acc + (item.qty * item.price), 0);
      const adjusted = (sub - noTaxSub) - data.discount;
      const taxAmount = adjusted * (data.taxRate / 100);
      const grand = sub - data.discount + taxAmount;
      data.total = '$' + grand.toLocaleString(undefined, {minimumFractionDigits: 2});

      return data;
    }

    function loadDocument(doc) {
      if (!doc) return;
      clearTimeout(autosaveTimer);
      setAutosaveStatus('idle');
      isHydratingDocument = true;

      const tbody = document.getElementById('line-items');
      tbody.innerHTML = '';
      currentPhotos.clear();

      currentDocType = doc.type || 'INVOICE';
      setType(currentDocType);
      document.getElementById('doc-id').value = doc.id || '';
      document.getElementById('doc-date').value = doc.date || new Date().toISOString().split('T')[0];
      document.getElementById('doc-shipping').value = doc.shipping || 'DDU - Duties Unpaid (USA Freight)';
      if (document.getElementById('freight-company')) document.getElementById('freight-company').value = doc.freightCompany || '';
      if (document.getElementById('freight-tracking')) document.getElementById('freight-tracking').value = doc.freightTracking || '';
      if (document.getElementById('freight-bol')) document.getElementById('freight-bol').value = doc.freightBol || '';
      handleShippingChange(doc.shipping || 'DDU - Duties Unpaid (USA Freight)');

      if (doc.currency) document.getElementById('doc-currency').value = doc.currency;
      if (doc.taxRate !== undefined) document.getElementById('doc-tax-rate').value = doc.taxRate;
      const exportEl = document.getElementById('doc-export');
      if (exportEl) exportEl.checked = doc.isExport === true;
      if (doc.discount !== undefined) document.getElementById('doc-discount').value = doc.discount;
      if (doc.depositAmount !== undefined) document.getElementById('doc-deposit-amount').value = doc.depositAmount;

      const cust = doc.customer || {};
      document.getElementById('cust-name').value = cust.name || '';
      document.getElementById('cust-street').value = cust.street || '';
      document.getElementById('cust-city').value = cust.city || '';
      document.getElementById('cust-prov').value = cust.prov || '';
      document.getElementById('cust-postal').value = cust.postal || '';
      document.getElementById('cust-country').value = cust.country || 'Canada';
      document.getElementById('cust-email').value = cust.email || '';
      const hasPickupAddress = Boolean(doc.pickupAddressEnabled || cust.street || cust.city || cust.postal);
      const pickupAddressToggle = document.getElementById('pickup-address-enabled');
      if (pickupAddressToggle) pickupAddressToggle.checked = hasPickupAddress;
      refreshPickupAddressUI();

      document.getElementById('doc-notes').value = doc.notes || buildDefaultNotes();
      document.getElementById('doc-memo').value = doc.memo || '';

      if (doc.lineItems && Array.isArray(doc.lineItems) && doc.lineItems.length > 0) {
        doc.lineItems.forEach(item => {
          addRow();
          const rows = document.querySelectorAll('.line-row');
          const lastRow = rows[rows.length - 1];
          if (lastRow) {
            lastRow.querySelector('.item-desc').value = item.desc || '';
            lastRow.querySelector('.item-sku').value = item.sku || '';
            lastRow.querySelector('.item-qty').value = item.qty || 1;
            lastRow.querySelector('.item-price').value = (item.price || 0).toFixed(2);
            const noTaxEl = lastRow.querySelector('.item-no-tax');
            if (noTaxEl) noTaxEl.value = item.noTax || '';

            if (item.photos && Array.isArray(item.photos) && item.photos.length > 0) {
              const rowKey = lastRow.dataset.rowKey;
              currentPhotos.set(rowKey, [...item.photos]);
              refreshPhotoGallery(lastRow);
            }
          }
        });
      } else {
        addRow();
      }

      calc();

      // Sync the paid toggle button when loading a document
      if (currentFirebaseKey) {
        db.ref('savedDocuments/' + currentFirebaseKey + '/status').once('value', (snap) => {
          updatePaidToggleUI(snap.val() || 'unpaid');
        });
      } else {
        updatePaidToggleUI('unpaid');
      }
      isHydratingDocument = false;
    }

    // ====================== IMAGE RESIZE + COMPRESSION ======================
    function resizeImage(base64, maxWidth = 1200, quality = 0.80) {
      return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => {
          let { width, height } = img;
          if (width > maxWidth) {
            height = Math.round((height * maxWidth) / width);
            width = maxWidth;
          }
          const canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, width, height);
          resolve(canvas.toDataURL('image/jpeg', quality));
        };
        img.src = base64;
      });
    }

    // ====================== PDF BUILDER ======================
    async function buildPDF() {
      const renderZone = document.getElementById('pdf-render-zone');
      const docId = document.getElementById('doc-id').value || '1001';

      // Read paid status for this invoice from Firebase (or default unpaid)
      let paidStatus = 'unpaid';
      if (currentFirebaseKey && currentDocType === 'INVOICE') {
        const statusSnap = await db.ref('savedDocuments/' + currentFirebaseKey + '/status').once('value');
        paidStatus = statusSnap.val() || 'unpaid';
      }
      const isPaid = paidStatus === 'paid';
      const isExport = document.getElementById('doc-export')?.checked || false;
      const depositAmt = parseFloat(document.getElementById('doc-deposit-amount').value) || 0;
      const grandTotal = parseFloat(document.getElementById('grand-total-display').innerText.replace(/[$,]/g, '')) || 0;
      const date = document.getElementById('doc-date').value || new Date().toISOString().split('T')[0];
      const shipping = document.getElementById('doc-shipping').value;
      const notes = document.getElementById('doc-notes').value;
      const curr = document.getElementById('doc-currency').value;

      const c = {
        name: document.getElementById('cust-name').value || 'VALUED CUSTOMER',
        street: document.getElementById('cust-street').value || '---',
        city: document.getElementById('cust-city').value || '',
        prov: document.getElementById('cust-prov').value || '',
        zip: document.getElementById('cust-postal').value || '',
        country: document.getElementById('cust-country').value || 'Canada'
      };

      let rowsHtml = '';
      let photoList = [];

      document.querySelectorAll('.line-row').forEach((row, i) => {
        const desc = row.querySelector('.item-desc').value || `Item ${i+1}`;
        const noTaxVal = row.querySelector('.item-no-tax')?.value || '';
        const isNoTax = !!noTaxVal;
        const isNoTaxLocal = noTaxVal === 'local';
        const rowKey = row.dataset.rowKey;
        const rowPhotos = currentPhotos.get(rowKey) || [];

        rowPhotos.forEach(base64 => {
          if (base64) photoList.push({ desc, base64 });
        });

        rowsHtml += `
          <tr style="border-bottom: 1px solid #eeeeee;">
            <td style="padding: 8px 5px; color: #888;">${i+1}</td>
            <td style="padding: 8px 5px;"><strong>${desc}</strong>${noTaxVal === 'export' ? ' <span style="font-size:9px;background:#e8f4ff;color:#0a5fa3;border:1px solid #0a5fa3;border-radius:3px;padding:1px 5px;font-weight:700;">EXPORT — NO TAX</span>' : ''}${noTaxVal === 'local' ? ' <span style="font-size:9px;background:#fff0f0;color:#cc0000;border:1px solid #cc0000;border-radius:3px;padding:1px 5px;font-weight:700;">NO TAX — NOT FOR RESALE</span>' : ''}</td>
            <td style="padding: 8px 5px;">${row.querySelector('.item-sku').value || ''}</td>
            <td style="padding: 8px 5px; text-align:center;">${row.querySelector('.item-qty').value || '1'}</td>
            <td style="padding: 8px 5px; text-align:right;">${row.querySelector('.item-price').value || '0.00'}</td>
            <td style="padding: 8px 5px; text-align:right;"><strong>${row.querySelector('.item-total').innerText}</strong></td>
          </tr>
        `;
      });

      // Build watermark HTML for quotes and deposits
      const watermarkText = currentDocType === 'QUOTE' ? 'QUOTE' : currentDocType === 'DEPOSIT' ? 'DEPOSIT' : '';
      const watermarkHTML = watermarkText ? `
        <div style="
          position: absolute;
          inset: 0;
          pointer-events: none;
          overflow: hidden;
          z-index: 999;
        ">
          ${Array.from({length: 30}).map((_, i) => {
            const row = Math.floor(i / 3);
            const col = i % 3;
            const top = (row * 18) - 10;
            const left = (col * 36) - 10;
            return `<div style="
              position: absolute;
              top: ${top}%;
              left: ${left}%;
              transform: rotate(-35deg);
              font-family: 'Helvetica Neue', Arial, sans-serif;
              font-size: 52px;
              font-weight: 900;
              color: rgba(0,0,0,0.06);
              letter-spacing: 0.1em;
              white-space: nowrap;
              text-transform: uppercase;
              user-select: none;
            ">${watermarkText}</div>`;
          }).join('')}
        </div>
      ` : '';

      const hasLocalNoTax = Array.from(document.querySelectorAll('.line-row')).some(
        row => (row.querySelector('.item-no-tax')?.value || '') === 'local'
      );

      renderZone.innerHTML = `
        <div style="padding: 14px 20px; font-family: 'Helvetica Neue', Arial, sans-serif; font-size: 13px; position: relative;">
          ${watermarkHTML}
          <div style="display:flex; justify-content:space-between; align-items:flex-start; margin-bottom: 20px; border-bottom: 4px solid #000; padding-bottom: 16px;">
            <div>
              <img src="https://globaljdmautoparts.com/cdn/shop/t/10/assets/footer.png?v=49175908779904570431576873565" alt="Global JDM" style="height:65px; margin-bottom:15px;">
<h1 style="font-size: 32px; margin:0; font-family:'Syne'; font-weight:800; text-transform:uppercase;">${currentDocType === 'DEPOSIT' ? 'DEPOSIT CONFIRMATION' : currentDocType}</h1>
              ${currentDocType === 'INVOICE' ? `<div style="display:inline-block;margin-top:10px;padding:4px 14px;border-radius:4px;font-size:12px;font-weight:700;letter-spacing:0.1em;text-transform:uppercase;background:${isPaid ? '#e6fff2' : '#fff2f2'};color:${isPaid ? '#1a7a45' : '#cc0000'};border:2px solid ${isPaid ? '#1a7a45' : '#cc0000'};">${isPaid ? '✓ PAID' : '⚠ PAYMENT DUE'}</div>` : ''}
              ${currentDocType === 'DEPOSIT' ? `<div style="display:inline-block;margin-top:10px;padding:4px 14px;border-radius:4px;font-size:12px;font-weight:700;letter-spacing:0.1em;text-transform:uppercase;background:#fff8e1;color:#b8860b;border:2px solid #b8860b;">⚠ DEPOSIT RECEIVED</div>` : ''}
              ${isExport ? `<div style="display:inline-block;margin-top:10px;margin-left:6px;padding:4px 14px;border-radius:4px;font-size:12px;font-weight:700;letter-spacing:0.1em;text-transform:uppercase;background:#e8f4ff;color:#0a5fa3;border:2px solid #0a5fa3;">⛟ EXPORT — ZERO-RATED</div>` : ''}
                          </div>
            <div style="text-align:right;">
              <div style="color:#888; font-size:11px; text-transform:uppercase; margin-bottom:5px; letter-spacing:0.1em;">Reference ID</div>
              <div style="font-size:22px; font-weight:800; font-family:'Syne';">#${docId}</div>
              <div style="margin-top:12px; font-size:13px;">Date: ${date}</div>
            </div>
          </div>

          <div style="display:grid; grid-template-columns: 1fr 1fr; gap: 40px; margin-bottom: 20px;">
            <div>
              <div style="font-size:10px; text-transform:uppercase; color:#999; margin-bottom:10px; letter-spacing:0.1em;">ISSUED BY</div>
              <div style="font-size:13px; line-height:1.6;">
                <strong style="font-size:15px;">Global JDM Auto Parts</strong><br>
                11 Blair Drive, Brampton<br>
                Ontario, L6T2H4 Canada<br>
                japan_jdm@hotmail.com<br>
                ${currentDocType === 'INVOICE' ? `HST: #76353 2926 RT 0001` : ''}
                ${hasLocalNoTax ? '<div style="margin-top:6px;font-size:10px;background:#fff0f0;color:#cc0000;border:1px solid #cc0000;border-radius:3px;padding:4px 8px;font-weight:700;">⚠ TAX HAS NOT BEEN PAID ON THIS TRANSACTION. This document cannot be used to claim input tax credits or collect tax from the government.</div>' : ''}
              </div>
            </div>
            <div>
              <div style="font-size:10px; text-transform:uppercase; color:#999; margin-bottom:10px; letter-spacing:0.1em;">Bill / Ship To</div>
              <div style="font-size:13px; line-height:1.6;">
                <strong style="font-size:15px;">${c.name}</strong><br>
                ${c.street}<br>
                ${c.city}, ${c.prov} ${c.zip}<br>
                ${c.country}
              </div>
            </div>
          </div>

          ${currentDocType === 'INVOICE' ? `
          <div style="margin-bottom:14px; font-size:12px; border-left:2px solid #000; padding-left:15px;">
            <strong style="text-transform:uppercase; font-size:10px; color:#888;">Shipping Terms:</strong><br>${shipping}
            ${(shipping === 'Shipped via Freight' || shipping === 'Shipped via Parcel') ? (() => {
              const co  = document.getElementById('freight-company')?.value || '';
              const trk = document.getElementById('freight-tracking')?.value || '';
              const bol = document.getElementById('freight-bol')?.value || '';
              return `<div style="margin-top:6px;font-size:11px;color:#555;">
                ${co  ? `<div><strong>Freight Company:</strong> ${co}</div>`  : ''}
                ${trk ? `<div><strong>Tracking #:</strong> ${trk}</div>` : ''}
                ${bol ? `<div><strong>BOL #:</strong> ${bol}</div>`            : ''}
              </div>`;
            })() : ''}
          </div>
          ` : ''}

          <table style="width:100%; border-collapse:collapse; font-size:12px; margin-bottom:16px;">
            <thead>
              <tr style="background:#f9f9f9; text-transform:uppercase; font-size:10px; color:#666;">
                <th style="padding:8px 5px; text-align:left; border-bottom:2px solid #000;">#</th>
                <th style="padding:8px 5px; text-align:left; border-bottom:2px solid #000;">Item / Description</th>
                <th style="padding:8px 5px; text-align:left; border-bottom:2px solid #000;">Item ID</th>
                <th style="padding:8px 5px; text-align:center; border-bottom:2px solid #000;">Qty</th>
                <th style="padding:8px 5px; text-align:right; border-bottom:2px solid #000;">Price</th>
                <th style="padding:8px 5px; text-align:right; border-bottom:2px solid #000;">Total</th>
              </tr>
            </thead>
            <tbody>${rowsHtml}</tbody>
          </table>

          <div style="display:flex; justify-content:space-between; align-items:flex-start; gap: 24px;">
            <div style="width:55%;">
              <div style="font-size:10px; text-transform:uppercase; color:#999; margin-bottom:12px; letter-spacing:0.1em;">${currentDocType === 'DEPOSIT' ? 'Important Notice' : currentDocType === 'QUOTE' ? 'Quote Terms' : 'Engine Warranty & Terms'}</div>
              <div style="font-size:11px; color:#333; line-height:1.7; background:${currentDocType === 'DEPOSIT' ? '#fffdf0' : '#f9f9f9'}; padding:20px; border-radius:6px; white-space: pre-wrap; ${currentDocType === 'DEPOSIT' ? 'border:2px solid #b8860b;' : ''}">${currentDocType === 'DEPOSIT' ? `⚠ This document confirms a deposit has been received and must be presented in its original form when paying the remaining balance.\n\nUpon receipt of full payment, this deposit confirmation must be returned to Global JDM Auto Parts and will no longer be valid. Failure to present this document may result in delays.\n\nThis document is non-transferable.` : notes}</div>
            </div>
            <div style="width:35%;">
              <div style="display:flex; justify-content:space-between; padding:10px 0; border-bottom:1px solid #eeeeee; font-size:13px;">
                <span>Subtotal</span>
                <span>${document.getElementById('subtotal-val').innerText}</span>
              </div>
              ${isExport ? `
              <div style="display:flex; justify-content:space-between; padding:10px 0; border-bottom:1px solid #eeeeee; font-size:12px; color:#0a5fa3;">
                <span style="font-style:italic;">Zero-rated export sale (no GST/HST)</span>
                <span>—</span>
              </div>
              ` : `
              <div style="display:flex; justify-content:space-between; padding:10px 0; border-bottom:1px solid #eeeeee; font-size:13px;">
                <span>Tax</span>
                <span>${document.getElementById('tax-val').innerText}</span>
              </div>
              `}
              <div style="display:flex; justify-content:space-between; padding:20px 0; font-size:18px; font-weight:700;">
                <span>${currentDocType === 'INVOICE' ? (isPaid ? 'TOTAL PAID' : 'TOTAL DUE') : 'TOTAL'} (${curr})</span>
                <span style="color:#000;">${document.getElementById('grand-total-display').innerText}</span>
              </div>
              ${currentDocType === 'DEPOSIT' && depositAmt > 0 ? `
              <div style="display:flex; justify-content:space-between; padding:10px 0; font-size:14px; color:#1a7a45; border-top:1px solid #eee;">
                <span>Deposit Received</span>
                <span><strong>$${depositAmt.toLocaleString(undefined, {minimumFractionDigits:2})}</strong></span>
              </div>
              <div style="display:flex; justify-content:space-between; padding:16px 0 0 0; font-size:18px; font-weight:800; border-top:2px solid #000;">
                <span>BALANCE DUE (${curr})</span>
                <span style="color:#cc0000;">$${Math.max(0, grandTotal - depositAmt).toLocaleString(undefined, {minimumFractionDigits:2})}</span>
              </div>
              ` : ''}
            </div>
          </div>

          <div style="margin-top:20px; border-top: 1px solid #eeeeee; padding-top:12px; font-size:10px; color:#aaaaaa; text-align:center;">
            All performance items sold as-is for track use only. If otherwise stated on this invoice, different terms apply. Thank you for your business.
          </div>
        </div>
      `;

      const canvas = await html2canvas(renderZone, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        backgroundColor: '#ffffff',
        logging: false
      });

      const imgData = canvas.toDataURL('image/jpeg', 0.95);
      const { jsPDF } = window.jspdf;
      const pdf = new jsPDF('p', 'mm', 'a4');
      
      const pdfWidth = 210;
      const pdfHeight = 297;
      const imgWidth = pdfWidth;
      const imgHeight = (canvas.height * pdfWidth) / canvas.width;

      let heightLeft = imgHeight;
      let position = 0;
      let pageNum = 1;

      pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);
      heightLeft -= pdfHeight;

      // FIX 7: Count total pages for page numbers
      const totalMainPages = Math.ceil(imgHeight / pdfHeight);
      const totalPages = totalMainPages + photoList.length;

      // FIX 7: Add page number to first page
      addPageNumber(pdf, pageNum, totalPages);

      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pageNum++;
        pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);
        heightLeft -= pdfHeight;
        addPageNumber(pdf, pageNum, totalPages);
      }

      // PHOTO ATTACHMENT PAGES
      if (photoList.length > 0) {
        for (let photo of photoList) {
          pdf.addPage();
          pageNum++;
          pdf.setFontSize(12);
          pdf.setTextColor(0, 0, 0);
          pdf.text(`Attachment: ${photo.desc} - Condition Report`, 20, 50);

          const imgProps = pdf.getImageProperties(photo.base64);
          const pdfImgWidth = 190;
          const pdfImgHeight = (imgProps.height * pdfImgWidth) / imgProps.width;
          pdf.addImage(photo.base64, 'JPEG', 10, 70, pdfImgWidth, pdfImgHeight, undefined, 'FAST');
          addPageNumber(pdf, pageNum, totalPages);
        }
      }

      const filename = `${currentDocType}_${docId}_${c.name.replace(/\s+/g, '_')}.pdf`;
      return { pdf, filename };
    }

    // FIX 7: Page number helper
    function addPageNumber(pdf, current, total) {
      pdf.setFontSize(9);
      pdf.setTextColor(170, 170, 170);
      pdf.text(`Page ${current} of ${total}`, 105, 290, { align: 'center' });
    }

    async function exportPDF() {
      if (!can('downloadPDF')) return;
      // FIX 6: Validate first
      if (!validateBeforeExport()) return;

      const loader = document.getElementById('loader');
      loader.style.display = 'flex';

      try {
        const result = await buildPDF();
        result.pdf.save(result.filename);
        await saveDocument(false);
        localStorage.removeItem(draftKey); // Clear draft after successful save
        setAutosaveStatus('idle');
        db.ref('savedDocuments').once('value', (snap) => {
          document.getElementById('doc-id').value = getNextDocNumber(snap.val(), currentDocType);
        });
      } catch (err) {
        console.error('PDF Build Failure:', err);
        alert('Error generating PDF. Open browser console (F12) and tell me the exact error message.');
      }

      loader.style.display = 'none';
    }

    async function sharePDF() {
      if (!can('downloadPDF')) return;
      // FIX 6: Validate first
      if (!validateBeforeExport()) return;

      const loader = document.getElementById('loader');
      loader.style.display = 'flex';

      try {
        const result = await buildPDF();

        const blob = result.pdf.output('blob');
        const file = new File([blob], result.filename, { type: 'application/pdf' });

        const shareData = {
          files: [file],
          title: `Global JDM ${currentDocType} #${document.getElementById('doc-id').value}`,
          text: `Hello, here is your ${currentDocType} from Global JDM.`
        };

        if (navigator.canShare && navigator.canShare(shareData)) {
          await navigator.share(shareData);
        } else {
          alert('Share not supported on this device/browser.\n\nPDF has been generated — tap Download PDF instead.');
          result.pdf.save(result.filename);
        }

        await saveDocument(false);
        localStorage.removeItem(draftKey); // Clear draft after successful save
        setAutosaveStatus('idle');
      } catch (err) {
        console.error('Share/PDF Failure:', err);
        alert('Error preparing share. The file may still be too large.\n\nPlease use Download PDF instead.');
      }

      loader.style.display = 'none';
    }

    function toggleMobileMenu() {
  const menu = document.getElementById('mobile-more-menu');
  const overlay = document.getElementById('mobile-more-overlay');
  const isOpen = menu.style.display !== 'none';
  menu.style.display = isOpen ? 'none' : 'block';
  overlay.style.display = isOpen ? 'none' : 'block';
}

function togglePaidStatus() {
  if (!can('markPaid')) return;
  if (currentDocType !== 'INVOICE') return;
  if (!currentFirebaseKey) {
    alert('Save the document first before marking it as paid.');
    return;
  }
  // Read current status and flip it
  db.ref('savedDocuments/' + currentFirebaseKey + '/status').once('value', (snap) => {
    const current = snap.val() || 'unpaid';
    const next = current === 'paid' ? 'unpaid' : 'paid';
    db.ref('savedDocuments/' + currentFirebaseKey + '/status').set(next);
    updatePaidToggleUI(next);
  });
}

function updatePaidToggleUI(status) {
  const btn = document.getElementById('btn-paid-toggle');
  const mobileLabel = document.getElementById('mobile-paid-label');
  if (!btn) return;
  if (currentDocType !== 'INVOICE') {
    btn.style.display = 'none';
    if (mobileLabel) mobileLabel.textContent = 'Mark as Paid';
    return;
  }
  btn.style.display = 'flex';
  if (status === 'paid') {
    btn.textContent = '✓ Paid';
    btn.style.background = 'rgba(76,255,145,0.12)';
    btn.style.color = '#4cff91';
    btn.style.borderColor = '#4cff91';
    if (mobileLabel) mobileLabel.textContent = 'Mark as Unpaid';
  } else {
    btn.textContent = '$ Paid';
    btn.style.background = 'rgba(232,255,74,0.08)';
    btn.style.color = 'var(--accent)';
    btn.style.borderColor = 'var(--accent)';
    if (mobileLabel) mobileLabel.textContent = 'Mark as Paid';
  }
}

    function newDocument() {
  if (confirm('Start a new document? Unsaved changes will be lost.')) {
    localStorage.removeItem(draftKey);
    currentFirebaseKey = null;
    location.reload();
  }
}

function resetForm() {
  if (confirm('Wipe all data and start over?')) {
    localStorage.removeItem(draftKey);
    currentFirebaseKey = null;
    location.reload();
  }
}

    let currentFirebaseKey = null;

async function saveDocument(isAutosave = false) {
  if (!isAutosave) {
    if (currentFirebaseKey && !can('editDocuments')) return;
    if (!currentFirebaseKey && !can('createInvoices')) return;
  }
  if (!navigator.onLine) {
    if (!isAutosave) showToast('⚠ You are offline. Connect to save.');
    return;
  }
  const docData = getDocumentData();
  docData.timestamp = Date.now();
  if (currentFirebaseKey) {
    // Preserve the paid status — don't let autosave overwrite it
    const statusSnap = await db.ref('savedDocuments/' + currentFirebaseKey + '/status').once('value');
    if (statusSnap.exists()) docData.status = statusSnap.val();
    await db.ref('savedDocuments/' + currentFirebaseKey).set(docData);
  } else {
    const newRef = await db.ref('savedDocuments').push(docData);
    currentFirebaseKey = newRef.key;
  }
  // lastDocNumber no longer needed — doc number is calculated from saved documents on load
}

    // ====================== SAVED DOCUMENTS ======================
    let cachedDocsEntries = [];
    let activeDocTab = 'all';

    function setDocTab(tab) {
      activeDocTab = tab;
      ['all','invoice','quote'].forEach(t => {
        const btn = document.getElementById('tab-' + t);
        if (!btn) return;
        if (t === tab) {
          btn.style.background = 'var(--accent)';
          btn.style.color = '#000';
          btn.style.border = 'none';
        } else {
          btn.style.background = 'var(--surface-2)';
          btn.style.color = 'var(--text)';
          btn.style.border = '1px solid var(--border)';
        }
      });
      applyDocsFilter();
    }

    function applyDocsFilter() {
      const q = (document.getElementById('saved-search')?.value || '').toLowerCase().trim();
      let entries = cachedDocsEntries;

      if (activeDocTab === 'invoice') entries = entries.filter(([, doc]) => doc.type === 'INVOICE');
      if (activeDocTab === 'quote')   entries = entries.filter(([, doc]) => doc.type === 'QUOTE');

      if (q) {
        entries = entries.filter(([, doc]) => {
          const name     = (doc.customer?.name || '').toLowerCase();
          const id       = String(doc.id || '').toLowerCase();
          const date     = String(doc.date || '').toLowerCase();
          const products = (doc.lineItems || []).map(i => (i.desc || '').toLowerCase()).join(' ');
          return name.includes(q) || id.includes(q) || date.includes(q) || products.includes(q);
        });
      }

      const isFiltered = q || activeDocTab !== 'all';
      renderDocEntries(isFiltered ? entries : entries.slice(0, 3), !isFiltered && cachedDocsEntries.length > 3);
    }

    function renderSavedDocuments(docsObj) {
      const entries = Object.entries(docsObj || {});
      entries.sort((a, b) => (b[1].timestamp || 0) - (a[1].timestamp || 0));
      cachedDocsEntries = entries;
      applyDocsFilter();
    }

    function renderDocEntries(entries, showViewAll = false) {
      const container = document.getElementById('saved-list');
      container.innerHTML = '';

      if (entries.length === 0) {
        container.innerHTML = '<div style="padding:12px;color:var(--text-3);text-align:center;">No documents found</div>';
        return;
      }

      entries.forEach(([firebaseKey, doc]) => {
        const div = document.createElement('div');
        div.className = 'saved-item';

        let customerDisplay = 'Unknown';
        if (doc.customer) {
          customerDisplay = typeof doc.customer === 'string' ? doc.customer : (doc.customer.name || 'Unknown');
        }

        let ageStr = '';
        if (doc.timestamp) {
          const days = Math.floor((Date.now() - doc.timestamp) / 86400000);
          ageStr = days === 0 ? ' • today' : days === 1 ? ' • 1d ago' : ` • ${days}d ago`;
        }

        let badge = '';
        if (doc.type === 'QUOTE') {
          badge = '<span style="font-size:9px;padding:2px 6px;border-radius:4px;background:rgba(144,144,168,0.15);color:var(--text-2);margin-left:6px;vertical-align:middle;">QUOTE</span>';
        } else if (doc.type === 'DEPOSIT') {
          const dep = doc.depositAmount ? '$' + parseFloat(doc.depositAmount).toLocaleString(undefined, {minimumFractionDigits:2}) : '';
          badge = `<span style="font-size:9px;padding:2px 6px;border-radius:4px;background:rgba(232,255,74,0.12);color:var(--accent);margin-left:6px;vertical-align:middle;">DEPOSIT${dep ? ' ' + dep : ''}</span>`;
        } else if (doc.autoGenerated) {
          const isPaid = doc.status === 'paid';
          badge = (isPaid
            ? '<span style="font-size:9px;padding:2px 6px;border-radius:4px;background:rgba(76,255,145,0.12);color:#4cff91;margin-left:6px;vertical-align:middle;">PAID</span>'
            : '<span style="font-size:9px;padding:2px 6px;border-radius:4px;background:rgba(255,74,74,0.12);color:var(--red);margin-left:6px;vertical-align:middle;">UNPAID</span>')
            + '<span style="font-size:8px;padding:2px 5px;border-radius:4px;background:rgba(74,240,255,0.1);color:#4af0ff;margin-left:4px;vertical-align:middle;">AUTO</span>';
        } else {
          const isPaid = doc.status === 'paid';
          badge = isPaid
            ? '<span style="font-size:9px;padding:2px 6px;border-radius:4px;background:rgba(76,255,145,0.12);color:#4cff91;margin-left:6px;vertical-align:middle;">PAID</span>'
            : '<span style="font-size:9px;padding:2px 6px;border-radius:4px;background:rgba(255,74,74,0.12);color:var(--red);margin-left:6px;vertical-align:middle;">UNPAID</span>';
        }

        const textEl = document.createElement('div');
        textEl.className = 'saved-item-text';
        textEl.innerHTML = `<strong>${doc.type || 'DOC'} #${doc.id}${badge}</strong><br><small>${customerDisplay} • ${doc.total || '—'} • ${doc.date || '—'}${ageStr}</small>`;
        textEl.onclick = () => {
          currentFirebaseKey = firebaseKey;
          loadDocument(doc);
          const newBtn = document.getElementById('btn-new-doc');
          if (newBtn) newBtn.style.display = 'flex';
        };

        if (doc.type === 'QUOTE') {
          const convertBtn = document.createElement('button');
          convertBtn.className = 'saved-item-delete';
          convertBtn.textContent = '→ INV';
          convertBtn.title = 'Convert to Invoice';
          convertBtn.style.cssText = 'color:var(--accent);font-size:10px;font-family:var(--font-head);font-weight:700;min-width:48px;';
          convertBtn.onclick = async (e) => {
            e.stopPropagation();
            if (!confirm(`Convert QUOTE #${doc.id} to a new Invoice? The original quote will be kept.`)) return;
            const snap = await db.ref('savedDocuments').once('value');
            const data = snap.val();
            let newId = 1001;
            if (data) {
              const ids = Object.values(data).map(d => parseInt(d.id)).filter(n => !isNaN(n));
              if (ids.length > 0) newId = Math.max(...ids) + 1;
            }
            const newDoc = JSON.parse(JSON.stringify(doc));
            newDoc.type = 'INVOICE';
            newDoc.id = String(newId);
            newDoc.status = 'unpaid';
            newDoc.timestamp = Date.now();
            delete newDoc._firebaseKey;
            const newRef = await db.ref('savedDocuments').push(newDoc);
            currentFirebaseKey = newRef.key;
            loadDocument(newDoc);
            alert(`Invoice #${newId} created from Quote #${doc.id}.`);
          };
          div.appendChild(convertBtn);
        }

        // Only render edit/delete buttons if permitted
        if (can('editDocuments', true)) {
          const editBtn = document.createElement('button');
          editBtn.className = 'saved-item-delete';
          editBtn.textContent = '✏';
          editBtn.title = 'Edit this document';
          editBtn.style.cssText = 'color:var(--accent);font-size:13px;';
          editBtn.onclick = (e) => {
            e.stopPropagation();
            openEditModal(firebaseKey, doc);
          };
          div.appendChild(textEl);
          div.appendChild(editBtn);
        } else {
          div.appendChild(textEl);
        }

        if (can('deleteDocuments', true)) {
          const delBtn = document.createElement('button');
          delBtn.className = 'saved-item-delete';
          delBtn.textContent = '🗑';
          delBtn.title = 'Delete this document';
          delBtn.onclick = (e) => {
            e.stopPropagation();
            deleteDocument(firebaseKey, doc);
          };
          div.appendChild(delBtn);
        }
        container.appendChild(div);
      });

      if (showViewAll) {
        const footer = document.createElement('div');
        footer.style.cssText = 'padding:10px;text-align:center;border-top:1px solid var(--border);';
        footer.innerHTML = `<button onclick="openDocsModal()" style="background:none;border:none;color:var(--accent);font-family:var(--font-head);font-size:10px;font-weight:700;cursor:pointer;text-transform:uppercase;letter-spacing:0.1em;">View all ${cachedDocsEntries.length} documents →</button>`;
        container.appendChild(footer);
      }
    }

    // ====================== ALL DOCS MODAL ======================
    let modalActiveTab = 'all';

    function openDocsModal() {
      document.getElementById('docs-modal-overlay').style.display = 'block';
      document.getElementById('docs-modal').style.display = 'flex';
      document.getElementById('docs-modal-search').value = '';
      modalActiveTab = 'all';
      setModalTab('all');
    }

    function closeDocsModal() {
      document.getElementById('docs-modal-overlay').style.display = 'none';
      document.getElementById('docs-modal').style.display = 'none';
    }

    function setModalTab(tab) {
      modalActiveTab = tab;
      ['all','invoice','quote','deposit'].forEach(t => {
        const btn = document.getElementById('modal-tab-' + t);
        if (!btn) return;
        if (t === tab) {
          btn.style.background = 'var(--accent)';
          btn.style.color = '#000';
          btn.style.border = 'none';
        } else {
          btn.style.background = 'var(--surface-2)';
          btn.style.color = 'var(--text)';
          btn.style.border = '1px solid var(--border)';
        }
      });
      filterDocsModal(document.getElementById('docs-modal-search')?.value || '');
    }

    function filterDocsModal(query) {
      const q = query.toLowerCase().trim();
      let entries = cachedDocsEntries;

      if (modalActiveTab === 'invoice') entries = entries.filter(([, doc]) => doc.type === 'INVOICE');
      if (modalActiveTab === 'quote')   entries = entries.filter(([, doc]) => doc.type === 'QUOTE');
      if (modalActiveTab === 'deposit') entries = entries.filter(([, doc]) => doc.type === 'DEPOSIT');

      if (q) {
        entries = entries.filter(([, doc]) => {
          const name     = (doc.customer?.name || '').toLowerCase();
          const id       = String(doc.id || '').toLowerCase();
          const date     = String(doc.date || '').toLowerCase();
          const products = (doc.lineItems || []).map(i => (i.desc || '').toLowerCase()).join(' ');
          return name.includes(q) || id.includes(q) || date.includes(q) || products.includes(q);
        });
      }

      renderDocsModalList(entries);
    }

    function renderDocsModalList(entries) {
      const container = document.getElementById('docs-modal-list');
      container.innerHTML = '';

      if (entries.length === 0) {
        container.innerHTML = '<div style="padding:24px;text-align:center;color:var(--text-3);">No documents found</div>';
        return;
      }

      entries.forEach(([firebaseKey, doc]) => {
        let customerDisplay = 'Unknown';
        if (doc.customer) {
          customerDisplay = typeof doc.customer === 'string' ? doc.customer : (doc.customer.name || 'Unknown');
        }

        let ageStr = '';
        if (doc.timestamp) {
          const days = Math.floor((Date.now() - doc.timestamp) / 86400000);
          ageStr = days === 0 ? ' • today' : days === 1 ? ' • 1d ago' : ` • ${days}d ago`;
        }

        let badgeHtml = '';
        if (doc.type === 'QUOTE') {
          badgeHtml = '<span style="font-size:9px;padding:2px 6px;border-radius:4px;background:rgba(144,144,168,0.15);color:var(--text-2);margin-left:6px;">QUOTE</span>';
        } else if (doc.type === 'DEPOSIT') {
          const dep = doc.depositAmount ? '$' + parseFloat(doc.depositAmount).toLocaleString(undefined, {minimumFractionDigits:2}) : '';
          badgeHtml = `<span style="font-size:9px;padding:2px 6px;border-radius:4px;background:rgba(232,255,74,0.12);color:var(--accent);margin-left:6px;">DEPOSIT${dep ? ' ' + dep : ''}</span>`;
        } else if (doc.autoGenerated) {
          const isPaid = doc.status === 'paid';
          badgeHtml = (isPaid
            ? '<span style="font-size:9px;padding:2px 6px;border-radius:4px;background:rgba(76,255,145,0.12);color:#4cff91;margin-left:6px;">PAID</span>'
            : '<span style="font-size:9px;padding:2px 6px;border-radius:4px;background:rgba(255,74,74,0.12);color:var(--red);margin-left:6px;">UNPAID</span>')
            + '<span style="font-size:8px;padding:2px 5px;border-radius:4px;background:rgba(74,240,255,0.1);color:#4af0ff;margin-left:4px;">AUTO</span>';
        } else {
          const isPaid = doc.status === 'paid';
          badgeHtml = isPaid
            ? '<span style="font-size:9px;padding:2px 6px;border-radius:4px;background:rgba(76,255,145,0.12);color:#4cff91;margin-left:6px;">PAID</span>'
            : '<span style="font-size:9px;padding:2px 6px;border-radius:4px;background:rgba(255,74,74,0.12);color:var(--red);margin-left:6px;">UNPAID</span>';
        }

        const div = document.createElement('div');
        div.className = 'saved-item docs-modal-item';
        div.setAttribute('role', 'button');
        div.setAttribute('tabindex', '0');
        div.innerHTML = `
          <div class="saved-item-text">
            <strong class="docs-modal-doc-title">${doc.type || 'DOC'} #${doc.id}${badgeHtml}</strong>
            <small class="docs-modal-doc-meta">${customerDisplay} <span>•</span> ${doc.date || '—'}${ageStr}</small>
            <span class="docs-modal-total">${doc.total || '—'}</span>
          </div>
          <button type="button" class="btn-action btn-secondary docs-modal-open">Open</button>
        `;
        const openDocument = () => {
          currentFirebaseKey = firebaseKey;
          loadDocument(doc);
          const newBtn = document.getElementById('btn-new-doc');
          if (newBtn) newBtn.style.display = 'flex';
          const shareBtn = document.getElementById('btn-share-link');
          if (shareBtn) shareBtn.style.display = 'flex';
          closeDocsModal();
        };
        div.onclick = openDocument;
        div.onkeydown = (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            openDocument();
          }
        };
        div.querySelector('.docs-modal-open').onclick = (event) => {
          event.stopPropagation();
          openDocument();
        };
        container.appendChild(div);
      });
    }

    // ====================== EDIT DOCUMENT MODAL ======================
    let editingFirebaseKey = null;

    function openEditModal(firebaseKey, doc) {
      if (!can('editDocuments')) return;
      editingFirebaseKey = firebaseKey;

      // Populate all fields
      document.getElementById('edit-doc-type').value     = doc.type || 'INVOICE';
      document.getElementById('edit-doc-id').value       = doc.id || '';
      document.getElementById('edit-doc-date').value     = doc.date || '';
      document.getElementById('edit-doc-status').value   = doc.status || 'unpaid';
      document.getElementById('edit-doc-shipping').value = doc.shipping || '';
      document.getElementById('edit-doc-currency').value = doc.currency || 'CAD';
      document.getElementById('edit-doc-tax').value      = doc.taxRate ?? 13;
      document.getElementById('edit-doc-export').checked = doc.isExport === true;
      document.getElementById('edit-doc-discount').value = doc.discount ?? 0;
      document.getElementById('edit-doc-deposit').value  = doc.depositAmount ?? 0;
      document.getElementById('edit-cust-name').value    = doc.customer?.name || '';
      document.getElementById('edit-cust-email').value   = doc.customer?.email || '';
      document.getElementById('edit-cust-street').value  = doc.customer?.street || '';
      document.getElementById('edit-cust-city').value    = doc.customer?.city || '';
      document.getElementById('edit-cust-prov').value    = doc.customer?.prov || '';
      document.getElementById('edit-cust-postal').value  = doc.customer?.postal || '';
      document.getElementById('edit-cust-country').value = doc.customer?.country || '';
      document.getElementById('edit-doc-notes').value    = doc.notes || '';
      document.getElementById('edit-doc-memo').value     = doc.memo || '';

      // Populate line items
      const lineContainer = document.getElementById('edit-line-items');
      lineContainer.innerHTML = '';
      const items = (doc.lineItems && doc.lineItems.length > 0) ? doc.lineItems : [{ desc: '', sku: '', qty: 1, price: 0 }];
      items.forEach((item, i) => editModalRenderRow(item, i));

      document.getElementById('edit-doc-overlay').style.display = 'block';
      document.getElementById('edit-doc-modal').style.display = 'flex';
    }

    function closeEditModal() {
      document.getElementById('edit-doc-overlay').style.display = 'none';
      document.getElementById('edit-doc-modal').style.display = 'none';
      editingFirebaseKey = null;
    }

    function editModalRenderRow(item, index) {
      const container = document.getElementById('edit-line-items');
      const row = document.createElement('div');
      row.className = 'edit-line-row';
      row.dataset.index = index;
      row.style.cssText = 'background:var(--surface-2);border:1px solid var(--border);border-radius:var(--radius);padding:12px;display:flex;flex-direction:column;gap:8px;position:relative;';
      row.innerHTML = `
        <div style="display:flex;justify-content:space-between;align-items:center;">
          <span style="font-size:10px;color:var(--text-3);text-transform:uppercase;letter-spacing:0.1em;font-weight:600;">Item ${index + 1}</span>
          <button onclick="editModalRemoveRow(${index})" style="background:rgba(255,74,74,0.1);border:none;color:var(--red);border-radius:4px;width:26px;height:26px;cursor:pointer;font-size:13px;display:flex;align-items:center;justify-content:center;" title="Remove item">✕</button>
        </div>
        <div class="input-wrap">
          <label class="input-label">Description</label>
          <input type="text" class="ui-input edit-item-desc" list="inventory-list" placeholder="Product description..." value="${(item.desc || '').replace(/"/g, '&quot;')}" autocomplete="off">
        </div>
        <div style="display:grid;grid-template-columns:1fr 80px 100px;gap:8px;">
          <div class="input-wrap">
            <label class="input-label">SKU / Item ID</label>
            <input type="text" class="ui-input edit-item-sku" placeholder="Item-ID" value="${(item.sku || '').replace(/"/g, '&quot;')}">
          </div>
          <div class="input-wrap">
            <label class="input-label">Qty</label>
            <input type="number" class="ui-input edit-item-qty" value="${item.qty || 1}" min="1" inputmode="numeric">
          </div>
          <div class="input-wrap">
            <label class="input-label">Price ($)</label>
            <input type="number" class="ui-input edit-item-price" value="${item.price || ''}" step="0.01" inputmode="decimal" placeholder="0.00">
          </div>
        </div>
      `;
      container.appendChild(row);
    }

    function editModalAddRow() {
      const container = document.getElementById('edit-line-items');
      const index = container.querySelectorAll('.edit-line-row').length;
      editModalRenderRow({ desc: '', sku: '', qty: 1, price: '' }, index);
      // Scroll to new row
      document.getElementById('edit-doc-modal').querySelector('[style*="overflow-y"]').scrollTop = 99999;
    }

    function editModalRemoveRow(index) {
      const container = document.getElementById('edit-line-items');
      const rows = container.querySelectorAll('.edit-line-row');
      if (rows.length <= 1) { showToast('⚠️ At least one item is required.'); return; }
      rows[index].remove();
      // Re-number remaining rows
      container.querySelectorAll('.edit-line-row').forEach((row, i) => {
        row.dataset.index = i;
        row.querySelector('span').textContent = `Item ${i + 1}`;
        row.querySelector('button').setAttribute('onclick', `editModalRemoveRow(${i})`);
      });
    }

    async function saveEditModal() {
      if (!editingFirebaseKey) return;

      // Get current doc from cache to preserve fields we don't edit (lineItems, photos etc)
      const existing = cachedDocsEntries.find(([k]) => k === editingFirebaseKey)?.[1] || {};

      // Collect line items from modal
      const editedLineItems = [];
      document.querySelectorAll('#edit-line-items .edit-line-row').forEach(row => {
        editedLineItems.push({
          desc:   row.querySelector('.edit-item-desc').value.trim(),
          sku:    row.querySelector('.edit-item-sku').value.trim(),
          qty:    parseFloat(row.querySelector('.edit-item-qty').value) || 1,
          price:  parseFloat(row.querySelector('.edit-item-price').value) || 0,
          photos: [], // photos preserved from existing below
        });
      });

      // Preserve existing photos per line item index
      const existingItems = existing.lineItems || [];
      editedLineItems.forEach((item, i) => {
        if (existingItems[i]?.photos) item.photos = existingItems[i].photos;
      });

      const editIsExport = document.getElementById('edit-doc-export')?.checked || false;
      const updated = {
        ...existing,
        type:          document.getElementById('edit-doc-type').value,
        id:            document.getElementById('edit-doc-id').value,
        date:          document.getElementById('edit-doc-date').value,
        status:        document.getElementById('edit-doc-status').value,
        shipping:      document.getElementById('edit-doc-shipping').value,
        currency:      document.getElementById('edit-doc-currency').value,
        taxRate:       editIsExport ? 0 : (parseFloat(document.getElementById('edit-doc-tax').value) || 0),
        isExport:      editIsExport,
        discount:      parseFloat(document.getElementById('edit-doc-discount').value) || 0,
        depositAmount: parseFloat(document.getElementById('edit-doc-deposit').value) || 0,
        notes:         document.getElementById('edit-doc-notes').value,
        memo:          document.getElementById('edit-doc-memo').value,
        lineItems:     editedLineItems,
        customer: {
          ...(existing.customer || {}),
          name:    document.getElementById('edit-cust-name').value,
          email:   document.getElementById('edit-cust-email').value,
          street:  document.getElementById('edit-cust-street').value,
          city:    document.getElementById('edit-cust-city').value,
          prov:    document.getElementById('edit-cust-prov').value,
          postal:  document.getElementById('edit-cust-postal').value,
          country: document.getElementById('edit-cust-country').value,
        },
        timestamp: existing.timestamp || Date.now(),
      };

      // Recalculate total
      const lineItems = existing.lineItems || [];
      const sub = lineItems.reduce((acc, i) => acc + ((i.qty || 1) * (i.price || 0)), 0);
      const adjusted = sub - updated.discount;
      const tax = adjusted * (updated.taxRate / 100);
      updated.total = '$' + (adjusted + tax).toLocaleString(undefined, { minimumFractionDigits: 2 });

      try {
        await db.ref('savedDocuments/' + editingFirebaseKey).set(updated);
        closeEditModal();
        showToast('✓ Document updated successfully.');
      } catch(e) {
        console.error(e);
        showToast('⚠️ Save failed. Please try again.');
      }
    }
    
    function deleteDocument(firebaseKey, doc) {
      if (!can('deleteDocuments')) return;
      const label = `${doc.type || 'DOC'} #${doc.id}`;
      if (confirm(`Delete ${label}? This cannot be undone.`)) {
        db.ref('savedDocuments/' + firebaseKey).remove();
      }
    }

    function emailPDF() {
      const docId      = document.getElementById('doc-id').value || 'Unknown';
      const custName   = document.getElementById('cust-name').value || 'Customer';
      const custEmail  = document.getElementById('cust-email').value || '';
      const grandTotal = document.getElementById('grand-total-display').innerText || '$0.00';
      const docType    = currentDocType === 'INVOICE' ? 'Invoice' : 'Quote';

      const subject = `Global JDM Auto Parts — ${docType} #${docId}`;
      const body =
`Hello ${custName},

Please find attached your ${docType} from Global JDM Auto Parts.

${docType} #: ${docId}
Total Amount: ${grandTotal}

If you have any questions or would like to discuss payment options, please don't hesitate to reach out.

Thank you for your business!

Global JDM Auto Parts
11 Blair Drive, Brampton, Ontario
japan_jdm@hotmail.com`;

      // Populate preview modal
      document.getElementById('email-to').value      = custEmail;
      document.getElementById('email-subject').value = subject;
      document.getElementById('email-body').value    = body;
      document.getElementById('email-send-error').style.display = 'none';
      document.getElementById('email-modal-overlay').style.display = 'block';
      document.getElementById('email-modal').style.display        = 'block';
    }

    function openInOutlook() {
      const to      = document.getElementById('email-to').value.trim();
      const subject = encodeURIComponent(document.getElementById('email-subject').value.trim());
      const body    = encodeURIComponent(document.getElementById('email-body').value.trim());
      closeEmailModal();
      window.open(`https://outlook.live.com/mail/0/deeplink/compose?to=${to}&subject=${subject}&body=${body}`, '_blank');
    }

    function closeEmailModal() {
      document.getElementById('email-modal-overlay').style.display = 'none';
      document.getElementById('email-modal').style.display         = 'none';
    }

    function sendViaWhatsApp() {
      const docId = document.getElementById('doc-id').value || 'Unknown';
      const custName = document.getElementById('cust-name').value || 'Customer';
      const grandTotal = document.getElementById('grand-total-display').innerText || '$0.00';
      
      const message = `Hello ${encodeURIComponent(custName)},%0A%0AHere is your ${currentDocType} from Global JDM:%0A%0A*Invoice/Quote #:* ${docId}%0A*Total Amount:* ${grandTotal}%0A%0APlease reply for payment options or questions.%0A%0AThank you!`;
      
      window.open(`https://wa.me/?text=${message}`, '_blank');
    }

    // ===== LANDING PAGE =====
    const greetings = {
      morning:   ["Good morning. Let's have a great day.", "Morning. Time to get to work.", "Rise and grind. The terminal is ready.", "Good morning. Let's make some moves today."],
      afternoon: ["Good afternoon. Keep pushing.", "Afternoon. Stay focused.", "Good afternoon. You're doing great.", "Halfway through the day. Finish strong."],
      evening:   ["Good evening. Wrapping up?", "Evening. Great work today.", "Good evening. Almost done for the day.", "Evening hustle. Respect."],
      night:     ["Working late? Respect.", "Late night grind. Let's go.", "Burning the midnight oil. Stay sharp.", "Night shift mode. You got this."]
    };

    function getLandingGreeting() {
      const h = new Date().getHours();
      let bucket;
      if (h >= 5  && h < 12) bucket = 'morning';
      else if (h >= 12 && h < 17) bucket = 'afternoon';
      else if (h >= 17 && h < 21) bucket = 'evening';
      else bucket = 'night';
      const list = greetings[bucket];
      return list[Math.floor(Math.random() * list.length)];
    }

    function formatLandingDate() {
      const now = new Date();
      const days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
      const months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
      const h = now.getHours();
      const m = String(now.getMinutes()).padStart(2, '0');
      const ampm = h >= 12 ? 'PM' : 'AM';
      const h12 = ((h % 12) || 12);
      return `${days[now.getDay()]}, ${months[now.getMonth()]} ${now.getDate()}, ${now.getFullYear()} · ${h12}:${m} ${ampm}`;
    }

    const weatherIcons = {
      0:'☀️', 1:'🌤', 2:'⛅', 3:'☁️', 45:'🌫', 48:'🌫',
      51:'🌦', 53:'🌦', 55:'🌧', 61:'🌧', 63:'🌧', 65:'🌧',
      71:'❄️', 73:'❄️', 75:'❄️', 80:'🌦', 81:'🌧', 82:'⛈',
      95:'⛈', 96:'⛈', 99:'⛈'
    };
    const weatherDescs = {
      0:'Clear sky', 1:'Mainly clear', 2:'Partly cloudy', 3:'Overcast',
      45:'Foggy', 48:'Foggy', 51:'Light drizzle', 53:'Drizzle', 55:'Heavy drizzle',
      61:'Light rain', 63:'Rain', 65:'Heavy rain', 71:'Light snow', 73:'Snow',
      75:'Heavy snow', 80:'Showers', 81:'Heavy showers', 82:'Violent showers',
      95:'Thunderstorm', 96:'Thunderstorm', 99:'Thunderstorm'
    };

    async function loadLandingWeather() {
      try {
        const pos = await new Promise((res, rej) =>
          navigator.geolocation.getCurrentPosition(res, rej, { timeout: 8000 })
        );
        const { latitude: lat, longitude: lon } = pos.coords;

        const [weatherRes, geoRes] = await Promise.all([
          fetch(`https://api.open-meteo.com/v1/forecast?latitude=${lat}&longitude=${lon}&current_weather=true&temperature_unit=celsius`),
          fetch(`https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lon}&format=json`)
        ]);

        const weatherData = await weatherRes.json();
        const geoData     = await geoRes.json();

        const temp    = Math.round(weatherData.current_weather.temperature);
        const code    = weatherData.current_weather.weathercode;
        const city    = geoData.address?.city || geoData.address?.town || geoData.address?.village || 'Your area';
        const prov    = geoData.address?.state || '';

        document.getElementById('landing-weather-icon').textContent = weatherIcons[code] || '🌡';
        document.getElementById('landing-weather-temp').textContent = `${temp}°C`;
        document.getElementById('landing-weather-desc').textContent = weatherDescs[code] || '';
        document.getElementById('landing-weather-city').textContent = `${city}${prov ? ', ' + prov : ''}`;
      } catch(e) {
        document.getElementById('landing-weather-icon').textContent = '🌡';
        document.getElementById('landing-weather-temp').textContent = 'Weather unavailable';
        document.getElementById('landing-weather-desc').textContent = 'Enable location for weather';
        document.getElementById('landing-weather-city').textContent = '';
      }
    }

    const motivationalQuotes = [
      "Every deal closed is proof you showed up when others didn't.",
      "The grind doesn't care what time it is. Neither do you.",
      "One more call. One more deal. One more win.",
      "You built this from the ground up. Keep building.",
      "Success isn't loud. It's consistent.",
      "Move the metal. Stack the paper. Repeat.",
      "Every customer you take care of today tells two people tomorrow.",
      "The best time to close a deal was yesterday. The second best time is right now.",
      "Small wins stack into big numbers. Trust the process.",
      "No shortcuts. Just work that speaks for itself."
    ];

    function showLandingPage() {
      document.getElementById('landing-greeting').textContent   = getLandingGreeting();
      document.getElementById('landing-date').textContent       = formatLandingDate();
      const quote = motivationalQuotes[Math.floor(Math.random() * motivationalQuotes.length)];
      document.getElementById('landing-motivational').textContent = quote;
      document.getElementById('landing-page').classList.add('active');
      loadLandingWeather();
      // Show active reminders on landing page (loads after short delay to let Firebase sync)
      setTimeout(renderLandingReminders, 1500);
    }

    function enterTerminal() {
      document.getElementById('main-app').style.visibility = 'visible';
      document.getElementById('landing-page').classList.remove('active');
    }

    function signOutFromLanding() {
      firebase.auth().signOut();
      document.getElementById('landing-page').classList.remove('active');
    }

    // Splash Screen — zoom logo into landing page header
    document.getElementById('main-app').style.visibility = 'hidden';
    window.addEventListener('load', () => {
      const splash = document.getElementById('splash-screen');
      const logo   = splash.querySelector('.splash-logo');

      setTimeout(() => {
        logo.classList.add('zoom-to-top');
        setTimeout(() => {
          splash.style.opacity = '0';
          setTimeout(() => {
            splash.style.display = 'none';
            showLandingPage();
          }, 400);
        }, 700);
      }, 1200);
    });

    // Enter key support for login
    document.getElementById('gate-password').addEventListener('keydown', e => {
      if (e.key === 'Enter') loginWithEmail();
    });

    // ===== DARI TRANSLATION =====
    const dariTranslations = {
      // Header
      'Invoice & Quote Processor': 'پروسیسر فاکتور و قیمت',
      'Draft': 'پیش‌نویس',
      'Saving...': 'در حال ذخیره...',
      'Draft Saved': 'پیش‌نویس ذخیره شد',
      '+ New': '+ جدید',
      'Clear All': 'پاک کردن همه',
      'Download PDF': 'دانلود PDF',
      'Email': 'ایمیل',
      'Share PDF': 'اشتراک PDF',
      'ALL DOCS': 'همه اسناد',
      '$ Paid': '$ پرداخت شده',
      '✓ Paid': '✓ پرداخت شده',

      // Document type pills
      'Invoice': 'فاکتور',
      'Quote': 'قیمت',
      'Deposit': 'بیعانه',

      // Section labels
      'Document Settings': 'تنظیمات سند',
      'Customer Information': 'معلومات مشتری',
      'Financial Config': 'تنظیمات مالی',
      'Saved Documents (Live Sync)': 'اسناد ذخیره شده',
      'Internal Memo (Private)': 'یادداشت داخلی (خصوصی)',
      'Warranty & Engine Terms (Public)': 'شرایط موتور و ضمانت',
      'Quote Terms (Public)': 'شرایط قیمت',
      'Important Notice (Public)': 'اطلاعیه مهم',
      'Notes & Totals': 'یادداشت‌ها و مجموع',
      'Line Items': 'اقلام',
      'Settings': 'تنظیمات',

      // Input labels
      'Document Type': 'نوع سند',
      'Invoice #': 'شماره فاکتور',
      'Quote #': 'شماره قیمت',
      'Deposit #': 'شماره بیعانه',
      'Date': 'تاریخ',
      'Shipping Terms': 'شرایط ارسال',
      'Full Name': 'نام کامل',
      'Email Address': 'آدرس ایمیل',
      'Street Address': 'آدرس',
      'City': 'شهر',
      'Prov / State': 'استان / ایالت',
      'Postal / Zip': 'کد پستی',
      'Country': 'کشور',
      'Currency': 'واحد پول',
      'Tax Rate (%)': 'نرخ مالیات (%)',
      'Deposit Amount Received ($)': 'مبلغ بیعانه دریافتی ($)',
      'Warranty & Engine Terms (Public)': 'شرایط موتور و ضمانت',

      // Table headers
      'Product / Description': 'محصول / توضیحات',
      'Item ID': 'کد محصول',
      'Qty': 'تعداد',
      'Unit Price': 'قیمت واحد',
      'Total': 'مجموع',
      'Photo': 'عکس',

      // Totals
      'Subtotal': 'جمع جزء',
      'Adjustment / Discount': 'تخفیف',
      'TOTAL DUE': 'مجموع قابل پرداخت',
      'TOTAL PAID': 'مجموع پرداخت شده',
      'BALANCE DUE': 'مانده قابل پرداخت',
      'Deposit Received': 'بیعانه دریافت شده',

      // Buttons
      '+ Add New Product Line': '+ افزودن محصول جدید',
      'TAX INVOICE': 'فاکتور مالیاتی',
      'OFFICIAL QUOTE': 'قیمت رسمی',
      'DEPOSIT CONFIRMATION': 'تأییدیه بیعانه',
      'Internal Order Generation System': 'سیستم داخلی تولید سفارش',
      'Warranty & Engine Terms (Public)': 'شرایط موتور و ضمانت (عمومی)',

      // Saved list
      'All': 'همه',
      'Invoices': 'فاکتورها',
      'Quotes': 'قیمت‌ها',
      'Deposits': 'بیعانه‌ها',
      'No documents found': 'سندی یافت نشد',
      'No saved documents yet': 'هنوز سندی ذخیره نشده',
      'View all': 'مشاهده همه',
      'documents →': 'اسناد →',

      // Settings
      '☀️ Light Mode': '☀️ حالت روشن',
      '🇦🇫 دری': '🇦🇫 دری',
      '🚪 Sign Out': '🚪 خروج',
      'Sign Out': 'خروج',

      // Mobile menu
      'More Actions': 'اقدامات بیشتر',
      '💬 Send via WhatsApp': '💬 ارسال از طریق واتساپ',
      '💰 Mark as Paid': '💰 علامت‌گذاری به عنوان پرداخت شده',
      '💰 Mark as Unpaid': '💰 علامت‌گذاری به عنوان پرداخت نشده',
      '📄 New Document': '📄 سند جدید',
      '📦 Download All as ZIP': '📦 دانلود همه به صورت ZIP',
      '🗑 Clear All': '🗑 پاک کردن همه',

      // Placeholders
      'Search returning customer...': 'جستجوی مشتری...',
      'Client Name': 'نام مشتری',
      'customer@email.com': 'ایمیل مشتری',
      '123 Street Name': 'آدرس خیابان',
      'Postal Code': 'کد پستی',
      'e.g. Customer paid deposit, waiting on shipping quote...': 'مثال: مشتری بیعانه پرداخت کرد...',
      '🔍 Customer, #, product, date...': '🔍 مشتری، شماره، محصول، تاریخ...',

      // Tutorial
      'Step': 'مرحله',
      'Next →': 'بعدی →',
      '✓ Finish': '✓ پایان',
      '← Back': '← قبلی',
      'Document Type': 'نوع سند',
      'Customer Information': 'معلومات مشتری',
      'Financial Config': 'تنظیمات مالی',
      'Saved Documents': 'اسناد ذخیره شده',
      'Line Items': 'اقلام',
      'Notes & Totals': 'یادداشت‌ها و مجموع',
      'Header Actions': 'دکمه‌های بالا',
      'Auto-Save': 'ذخیره خودکار',
      'Settings': 'تنظیمات',
      'Mobile Actions': 'دکمه‌های موبایل',
      'Switch between Invoice, Quote, and Deposit Confirmation. Each type generates a different PDF with the appropriate content and terms.': 'بین فاکتور، قیمت و تأییدیه بیعانه جابجا شوید. هر نوع یک PDF متفاوت تولید می‌کند.',
      'Fill in your customer\'s details here. Use the search bar at the top to quickly load a returning customer\'s info without retyping.': 'اطلاعات مشتری را اینجا وارد کنید. از نوار جستجو برای بارگذاری سریع مشتری قبلی استفاده کنید.',
      'Set the currency, tax rate, and deposit amount here. These automatically calculate the totals at the bottom of the document.': 'واحد پول، نرخ مالیات و مبلغ بیعانه را اینجا تنظیم کنید. مجموع‌ها به صورت خودکار محاسبه می‌شوند.',
      'All your saved invoices, quotes and deposits appear here synced live from Firebase. Filter by type or search by customer name, date or product.': 'تمام فاکتورها، قیمت‌ها و بیعانه‌های ذخیره شده اینجا نمایش داده می‌شوند.',
      'Add your products here. Search your Shopify inventory by name or type manually. You can also attach condition photos to each line item.': 'محصولات خود را اینجا اضافه کنید. می‌توانید عکس وضعیت به هر قلم پیوست کنید.',
      'The notes section shows warranty terms, quote terms or deposit notice depending on your document type. Totals calculate automatically.': 'بخش یادداشت‌ها شرایط ضمانت، قیمت یا بیعانه را نشان می‌دهد. مجموع‌ها خودکار محاسبه می‌شوند.',
      'Download PDF, Email, Share Link and more. On mobile these are accessible from the ⋯ menu at the bottom right.': 'دانلود PDF، ایمیل، لینک اشتراک‌گذاری و بیشتر. در موبایل از منوی ⋯ در پایین سمت راست.',
      'The app automatically saves your work as you type. The dot indicator shows Saving, Saved or Draft status in real time.': 'برنامه به صورت خودکار کار شما را ذخیره می‌کند. نقطه نشانگر وضعیت ذخیره را نشان می‌دهد.',
      'Access Light Mode, Font Size, Dari language toggle, Tutorial and Sign Out from here.': 'حالت روشن، اندازه فونت، زبان دری، آموزش و خروج را از اینجا تنظیم کنید.',
      'On mobile, Download PDF and Share PDF are always visible. Tap ⋯ for all other actions including WhatsApp, Email and more.': 'در موبایل، دانلود و اشتراک PDF همیشه نمایش داده می‌شوند. برای سایر اقدامات روی ⋯ ضربه بزنید.',

      // Tutorial button
      '❓ Tutorial': '❓ آموزش',
      'Start': 'شروع',
    };

    let isDari = false;

    function applyLanguage(enabled) {
      isDari = enabled;
      localStorage.setItem('gjdm_dari', enabled ? '1' : '0');
      if (enabled) {
        document.body.setAttribute('dir', 'rtl');
        translateUI();
      } else {
        document.body.removeAttribute('dir');
        location.reload(); // easiest way to restore English
      }
    }

    function translateUI() {
      if (!isDari) return;

      // Translate all elements with data-en attribute or matching text
      function translateEl(el) {
        if (!el) return;
        const original = el.getAttribute('data-en') || el.textContent?.trim();
        if (original && dariTranslations[original]) {
          el.setAttribute('data-en', original);
          el.textContent = dariTranslations[original];
        }
      }

      function translatePlaceholder(el) {
        if (!el) return;
        const original = el.getAttribute('data-en-ph') || el.placeholder;
        if (original && dariTranslations[original]) {
          el.setAttribute('data-en-ph', original);
          el.placeholder = dariTranslations[original];
        }
      }

      // Section labels
      document.querySelectorAll('.section-label, .input-label, .accordion .section-label').forEach(translateEl);

      // Buttons
      document.querySelectorAll('.btn-action, .toggle-pill, .btn-add-row, .saved-item-delete, .settings-row-label, .settings-row button').forEach(translateEl);

      // Specific IDs
      ['autosave-label', 'canvas-title', 'doc-id-label', 'notes-label',
       'tab-all', 'tab-invoice', 'tab-quote', 'tab-deposit',
       'modal-tab-all', 'modal-tab-invoice', 'modal-tab-quote', 'modal-tab-deposit',
       'btn-new-doc', 'btn-paid-toggle', 'btn-share-link'
      ].forEach(id => translateEl(document.getElementById(id)));

      // Table headers
      document.querySelectorAll('.items-table th').forEach(translateEl);

      // Totals
      document.querySelectorAll('.total-row span:first-child').forEach(translateEl);

      // Placeholders
      document.querySelectorAll('input, textarea').forEach(translatePlaceholder);

      // Brand text
      translateEl(document.querySelector('.brand-text'));
    }

    // Restore language preference on load
    (function() {
      const saved = localStorage.getItem('gjdm_dari');
      if (saved === '1') {
        isDari = true;
        document.body.setAttribute('dir', 'rtl');
        window.addEventListener('DOMContentLoaded', () => {
          const toggle = document.getElementById('toggle-dari');
          if (toggle) toggle.checked = true;
          translateUI();
        });
      }
    })();

    // ===== FONT SIZE =====
    function applyFontSize(size) {
      document.documentElement.style.setProperty('--app-font-size', size + 'px');
      localStorage.setItem('gjdm_font_size', size);
      const label = document.getElementById('font-size-label');
      if (label) label.textContent = size + 'px';
      const slider = document.getElementById('font-size-slider');
      if (slider) slider.value = size;
    }

    // Restore font size preference on load
    (function() {
      const saved = localStorage.getItem('gjdm_font_size');
      if (saved) {
        applyFontSize(saved);
        window.addEventListener('DOMContentLoaded', () => {
          const slider = document.getElementById('font-size-slider');
          if (slider) slider.value = saved;
          const label = document.getElementById('font-size-label');
          if (label) label.textContent = saved + 'px';
        });
      }
    })();

    // ===== OFFLINE MODE =====
    function updateOnlineStatus() {
      const isOnline = navigator.onLine;
      const banner = document.getElementById('offline-banner');
      if (isOnline) {
        banner.classList.remove('visible');
        document.body.classList.remove('offline');
      } else {
        banner.classList.add('visible');
        document.body.classList.add('offline');
      }
    }
    window.addEventListener('online', updateOnlineStatus);
    window.addEventListener('offline', updateOnlineStatus);
    updateOnlineStatus();

    // ===== TUTORIAL =====
    const tutorialSteps = [
      {
        selector: '.toggle-pill-group',
        title: 'Document Type',
        desc: 'Switch between Invoice, Quote, and Deposit. Each type generates a different PDF — Invoice includes warranty terms, Quote shows pricing terms, Deposit shows a payment confirmation notice.',
        openAccordion: null,
        scrollTo: 'sidebar'
      },
      {
        selector: '#accordion-customer',
        title: 'Customer Information',
        desc: 'Fill in your customer\'s full name, address and email. Use the 🔍 search bar at the top of this section to instantly load a returning customer\'s details without retyping anything.',
        openAccordion: 'accordion-customer',
        scrollTo: 'sidebar'
      },
      {
        selector: '#accordion-financial',
        title: 'Financial Config',
        desc: 'Set currency (CAD or USD), tax rate, and deposit amount. These feed directly into the totals card and are printed on the PDF.',
        openAccordion: 'accordion-financial',
        scrollTo: 'sidebar'
      },
      {
        selector: '#accordion-saved',
        title: 'Saved Documents',
        desc: 'Every saved invoice, quote and deposit appears here, synced live. Filter by type using the tabs, or search by customer name, doc number, or product.',
        openAccordion: 'accordion-saved',
        scrollTo: 'sidebar'
      },
      {
        selector: '#accordion-items',
        title: 'Line Items',
        desc: 'Add products here — search your Shopify inventory or type manually. On mobile, each row becomes a card. Tap 📸 to attach condition photos to any line item.',
        openAccordion: 'accordion-items',
        scrollTo: 'canvas'
      },
      {
        selector: '#accordion-totals',
        title: 'Notes & Totals',
        desc: 'The notes box auto-fills with the right terms based on your document type (Warranty, Quote Terms, or Deposit Notice). Adjust the discount, and all totals recalculate instantly.',
        openAccordion: 'accordion-totals',
        scrollTo: 'canvas'
      },
      {
        selector: '#accordion-dashboard',
        title: '📊 Dashboard',
        desc: 'See your revenue, collected payments, outstanding invoices, and top customers at a glance. Use the dropdown to filter by time period — this month, last 3 months, all time, and more.',
        openAccordion: 'accordion-dashboard',
        scrollTo: 'canvas'
      },
      {
        selector: '#accordion-calendar',
        title: '📅 Delivery Calendar',
        desc: 'Track pickups and deliveries on a live calendar. Switch between Grid view (monthly overview) and List view (all events sorted by date). Tap any day to see its events or add a new one.',
        openAccordion: 'accordion-calendar',
        scrollTo: 'canvas'
      },
      {
        selector: '#btn-cal-grid',
        title: 'Calendar Views',
        desc: 'Grid view shows a full month at a glance with colour-coded event pills. List view shows every upcoming pickup and delivery in a clean sorted list — great on mobile.',
        openAccordion: 'accordion-calendar',
        scrollTo: 'canvas'
      },
      {
        selector: '#autosave-dot',
        title: 'Auto-Save',
        desc: 'The app saves your work automatically as you type. The dot turns yellow while saving, green when saved, and shows "Draft" when idle. Your draft survives page refreshes.',
        openAccordion: null,
        scrollTo: 'top',
        mobileSelector: '.mobile-bottom-bar'
      },
      {
        selector: '#settings-fab',
        title: 'Settings',
        desc: 'Access Light Mode, Font Size, Dari language, Tutorial and Sign Out here. Light Mode works great in bright environments. Font Size helps on smaller screens.',
        openAccordion: null,
        scrollTo: 'sidebar'
      },
      {
        selector: '.header-actions',
        title: 'Actions',
        desc: 'Download PDF, Email, WhatsApp, Share — all here. On mobile, Download PDF and Share are pinned to the bottom bar. Tap ⋯ for WhatsApp, Email, New Doc, and more.',
        openAccordion: null,
        scrollTo: 'top',
        mobileSelector: '.mobile-bottom-bar'
      }
    ];

    let tutorialIndex = 0;

    function startTutorial() {
      tutorialIndex = 0;
      document.getElementById('tutorial-overlay').classList.add('active');
      showTutorialStep(tutorialIndex);
    }

    function closeTutorial() {
      document.getElementById('tutorial-overlay').classList.remove('active');
      document.getElementById('tutorial-highlight').style.opacity = '0';
    }

    function tutorialNext() {
      if (tutorialIndex < tutorialSteps.length - 1) {
        tutorialIndex++;
        showTutorialStep(tutorialIndex);
      } else {
        closeTutorial();
      }
    }

    function tutorialPrev() {
      if (tutorialIndex > 0) {
        tutorialIndex--;
        showTutorialStep(tutorialIndex);
      }
    }

    function showTutorialStep(index) {
      const step    = tutorialSteps[index];
      const total   = tutorialSteps.length;
      const isMobile = window.innerWidth <= 768;

      // Open accordion if needed
      if (step.openAccordion) {
        const acc = document.getElementById(step.openAccordion);
        if (acc && !acc.hasAttribute('open')) acc.setAttribute('open', '');
      }

      // Pick the right element to highlight
      const selectorToUse = (isMobile && step.mobileSelector) ? step.mobileSelector : step.selector;
      let el = document.querySelector(selectorToUse);
      if (!el || el.offsetParent === null) {
        if (step.mobileSelector) el = document.querySelector(step.mobileSelector);
      }
      if (!el || el.offsetParent === null) {
        el = document.querySelector(step.selector);
      }

      const highlight = document.getElementById('tutorial-highlight');
      const tooltip   = document.getElementById('tutorial-tooltip');

      // Update text
      const t = (str) => (isDari && dariTranslations[str]) ? dariTranslations[str] : str;
      document.getElementById('tutorial-step-label').textContent = isDari
        ? `مرحله ${index + 1} از ${total}`
        : `Step ${index + 1} of ${total}`;
      document.getElementById('tutorial-title').textContent = step.title;
      document.getElementById('tutorial-desc').textContent  = step.desc;
      document.getElementById('tutorial-progress').textContent = `${index + 1} / ${total}`;
      document.getElementById('tutorial-back').style.display = index === 0 ? 'none' : 'flex';
      document.getElementById('tutorial-next').textContent = index === total - 1 ? t('✓ Finish') : t('Next →');
      document.getElementById('tutorial-back').textContent = t('← Back');

      // If element is not visible at all, just center the tooltip
      if (!el || el.offsetParent === null) {
        highlight.style.opacity = '0';
        const vw = window.innerWidth;
        const vh = window.innerHeight;
        const tw = Math.min(340, vw - 32);
        tooltip.style.width = tw + 'px';
        tooltip.style.left  = ((vw - tw) / 2) + 'px';
        tooltip.style.top   = ((vh - 260) / 2) + 'px';
        return;
      }

      // Scroll element into view
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });

      setTimeout(() => {
        const rect    = el.getBoundingClientRect();
        const pad     = 8;
        const vw      = window.innerWidth;
        const vh      = window.innerHeight;
        const tooltipW = Math.min(320, vw - 32);

        // Measure tooltip height accurately
        tooltip.style.width      = tooltipW + 'px';
        tooltip.style.visibility = 'hidden';
        tooltip.style.top        = '-9999px';
        tooltip.style.left       = '-9999px';
        const tooltipH = tooltip.offsetHeight || 260;
        tooltip.style.visibility = '';

        // Draw highlight around element
        highlight.style.opacity = '1';
        highlight.style.top     = (rect.top    - pad) + 'px';
        highlight.style.left    = (rect.left   - pad) + 'px';
        highlight.style.width   = (rect.width  + pad * 2) + 'px';
        highlight.style.height  = (rect.height + pad * 2) + 'px';

        let tooltipTop, tooltipLeft;

        if (isMobile) {
          // On mobile the tooltip is a CSS bottom drawer — no JS positioning needed.
          // Just ensure the highlight is scrolled into view with enough room above the drawer.
          // We only need to make sure the highlighted element isn't hidden behind the drawer.
          const drawerH = Math.min(vh * 0.44, 260);
          const elementBottom = rect.bottom + pad;
          const availableTop  = vh - drawerH - 16;

          // If the element bottom edge is too close to the drawer, scroll it up a bit more
          if (elementBottom > availableTop) {
            const extra = elementBottom - availableTop + 20;
            window.scrollBy({ top: extra, behavior: 'smooth' });
          }
          // CSS handles all positioning — skip JS top/left assignment
          return;

        } else {
          // ─── DESKTOP: pick the quadrant with most space ───
          const spaceAbove  = rect.top - 72;         // above element (72px = header)
          const spaceBelow  = vh - rect.bottom - 20; // below element
          const spaceLeft   = rect.left - 20;        // left of element
          const spaceRight  = vw - rect.right - 20;  // right of element

          const best = Math.max(spaceAbove, spaceBelow, spaceLeft, spaceRight);

          if (best === spaceBelow && spaceBelow >= tooltipH + 12) {
            // Place below
            tooltipTop  = rect.bottom + 12;
            tooltipLeft = rect.left;
          } else if (best === spaceAbove && spaceAbove >= tooltipH + 12) {
            // Place above
            tooltipTop  = rect.top - tooltipH - 12;
            tooltipLeft = rect.left;
          } else if (best === spaceRight && spaceRight >= tooltipW + 12) {
            // Place to the right
            tooltipLeft = rect.right + 12;
            tooltipTop  = rect.top + (rect.height / 2) - (tooltipH / 2);
          } else if (best === spaceLeft && spaceLeft >= tooltipW + 12) {
            // Place to the left
            tooltipLeft = rect.left - tooltipW - 12;
            tooltipTop  = rect.top + (rect.height / 2) - (tooltipH / 2);
          } else {
            // Last resort: center on screen away from element
            tooltipTop  = (vh - tooltipH) / 2;
            tooltipLeft = (vw - tooltipW) / 2;
          }

          // Clamp horizontal to screen
          if (tooltipLeft + tooltipW > vw - 16) tooltipLeft = vw - tooltipW - 16;
          if (tooltipLeft < 16) tooltipLeft = 16;

          // Clamp vertical to screen (respect header + bottom bar)
          tooltipTop = Math.max(72, Math.min(tooltipTop, vh - tooltipH - 20));

          tooltip.style.width = tooltipW + 'px';
        }

        tooltip.style.top  = tooltipTop  + 'px';
        tooltip.style.left = tooltipLeft + 'px';

      }, 500);
    }

    // ===== LOCAL DELIVERY CONTROL =====
    const LOCAL_DELIVERY_WORKER_URL = 'https://shopify-draft-order-worker.clashofclansgamer973.workers.dev';
    const LOCAL_DELIVERY_SETTINGS_PATH = 'systemSettings/localDelivery';
    let localDeliveryControlRef = null;
    let localDeliveryControlRecord = null;
    let localDeliveryControlBusy = false;

    function isTerminalAdmin() {
      return String(currentUserProfile?.role || '').toLowerCase() === 'admin';
    }

    function setLocalDeliveryControlStatus(message, state) {
      const status = document.getElementById('local-delivery-setting-status');
      if (!status) return;
      status.textContent = message;
      status.classList.remove('is-on', 'is-off', 'is-warning');
      if (state) status.classList.add('is-' + state);
    }

    function setLocalDeliveryControlBusy(busy) {
      localDeliveryControlBusy = busy;
      const row = document.getElementById('local-delivery-setting-row');
      const toggle = document.getElementById('toggle-local-delivery');
      if (row) row.classList.toggle('is-busy', busy);
      if (toggle) toggle.disabled = busy || !isTerminalAdmin();
    }

    async function getLiveLocalDeliveryStatus() {
      const response = await fetch(LOCAL_DELIVERY_WORKER_URL, {
        method: 'POST',
        cache: 'no-store',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'local-delivery-status', fresh: true, requestedAt: Date.now() })
      });
      if (!response.ok) throw new Error('Worker returned HTTP ' + response.status);
      const data = await response.json();
      if (!data?.localDelivery || typeof data.localDelivery.enabled !== 'boolean') {
        throw new Error('Worker returned an invalid status response');
      }
      return data.localDelivery;
    }

    async function refreshLocalDeliveryControl() {
      const toggle = document.getElementById('toggle-local-delivery');
      if (!toggle || !isTerminalAdmin()) return;

      const savedEnabled = typeof localDeliveryControlRecord?.enabled === 'boolean'
        ? localDeliveryControlRecord.enabled
        : null;
      if (savedEnabled !== null) toggle.checked = savedEnabled;

      setLocalDeliveryControlBusy(true);
      setLocalDeliveryControlStatus('Checking live Worker status…');
      try {
        const live = await getLiveLocalDeliveryStatus();
        const desired = savedEnabled === null ? live.enabled : savedEnabled;
        toggle.checked = desired;

        if (live.enabled === desired) {
          setLocalDeliveryControlStatus(
            desired
              ? 'ON · customers can request local delivery'
              : 'OFF · new delivery quotes and orders are blocked',
            desired ? 'on' : 'off'
          );
        } else if (live.hardDisabled) {
          setLocalDeliveryControlStatus('Saved ON · blocked by the Cloudflare master lock', 'warning');
        } else if (desired && live.configured === false) {
          setLocalDeliveryControlStatus('Saved ON · Geoapify is not configured in the Worker', 'warning');
        } else {
          setLocalDeliveryControlStatus(
            'Saved ' + (desired ? 'ON' : 'OFF') + ' · publish the updated Worker to apply it',
            'warning'
          );
        }
      } catch (error) {
        setLocalDeliveryControlStatus(
          savedEnabled === null
            ? 'Status unavailable · check the Worker connection'
            : 'Saved ' + (savedEnabled ? 'ON' : 'OFF') + ' · live status unavailable',
          'warning'
        );
        console.warn('Local delivery status check failed:', error);
      } finally {
        setLocalDeliveryControlBusy(false);
      }
    }

    function initLocalDeliveryControl() {
      const row = document.getElementById('local-delivery-setting-row');
      const toggle = document.getElementById('toggle-local-delivery');
      if (!row || !toggle) return;

      if (!isTerminalAdmin()) {
        row.style.display = 'none';
        toggle.disabled = true;
        return;
      }

      row.style.display = 'flex';
      toggle.disabled = true;
      if (localDeliveryControlRef) localDeliveryControlRef.off();
      localDeliveryControlRef = db.ref(LOCAL_DELIVERY_SETTINGS_PATH);
      localDeliveryControlRef.on('value', (snapshot) => {
        localDeliveryControlRecord = snapshot.val() || null;
        refreshLocalDeliveryControl();
      }, (error) => {
        setLocalDeliveryControlStatus('Could not read the saved delivery setting', 'warning');
        setLocalDeliveryControlBusy(false);
        console.warn('Local delivery setting listener failed:', error);
      });
    }

    async function setLocalDeliveryEnabled(enabled) {
      const toggle = document.getElementById('toggle-local-delivery');
      const previous = typeof localDeliveryControlRecord?.enabled === 'boolean'
        ? localDeliveryControlRecord.enabled
        : !enabled;

      if (!isTerminalAdmin() || localDeliveryControlBusy) {
        if (toggle) toggle.checked = previous;
        return;
      }

      const prompt = enabled
        ? 'Turn local delivery ON? Customers will be able to request and pay for eligible local delivery orders.'
        : 'Turn local delivery OFF? New local-delivery quotes and orders will be blocked immediately.';
      if (!confirm(prompt)) {
        if (toggle) toggle.checked = previous;
        return;
      }

      setLocalDeliveryControlBusy(true);
      setLocalDeliveryControlStatus('Saving ' + (enabled ? 'ON' : 'OFF') + '…');
      try {
        const user = firebase.auth().currentUser;
        await db.ref(LOCAL_DELIVERY_SETTINGS_PATH).set({
          enabled: Boolean(enabled),
          updatedAt: firebase.database.ServerValue.TIMESTAMP,
          updatedBy: currentUserProfile?.name || user?.email || 'Admin',
          updatedByUid: user?.uid || null
        });
        localDeliveryControlRecord = { enabled: Boolean(enabled) };
        if (toggle) toggle.checked = Boolean(enabled);
        showToast('Local delivery turned ' + (enabled ? 'ON' : 'OFF') + '.');
        await refreshLocalDeliveryControl();
      } catch (error) {
        if (toggle) toggle.checked = previous;
        setLocalDeliveryControlStatus('Could not save · previous setting kept', 'warning');
        showToast('⚠ Could not update local delivery.');
        console.error('Local delivery setting update failed:', error);
      } finally {
        setLocalDeliveryControlBusy(false);
      }
    }

    // ===== SETTINGS PANEL =====
    function toggleSettingsPanel() {
      const panel = document.getElementById('settings-panel');
      panel.classList.toggle('open');
    }

    // Close settings panel when clicking outside
    document.addEventListener('click', (e) => {
      const panel = document.getElementById('settings-panel');
      const fab   = document.getElementById('settings-fab');
      if (panel && fab && !panel.contains(e.target) && !fab.contains(e.target)) {
        panel.classList.remove('open');
      }
    });

    function signOut() {
      if (confirm('Sign out of Global Jdm?')) {
        localStorage.removeItem(draftKey);
        auth.signOut();
      }
    }

    function applyLightMode(enabled) {
      document.body.classList.toggle('light-mode', enabled);
      localStorage.setItem('gjdm_light_mode', enabled ? '1' : '0');
    }

    // Restore preference on load
    (function() {
      const saved = localStorage.getItem('gjdm_light_mode');
      if (saved === '1') {
        document.body.classList.add('light-mode');
        // Sync the toggle once DOM is ready
        window.addEventListener('DOMContentLoaded', () => {
          const toggle = document.getElementById('toggle-light-mode');
          if (toggle) toggle.checked = true;
        });
      }
    })();

    // ===== SETTINGS PANEL =====
    function toggleSettingsPanel() {
      document.getElementById('settings-panel').classList.toggle('open');
    }

    document.addEventListener('click', (e) => {
      const panel = document.getElementById('settings-panel');
      const fab   = document.getElementById('settings-fab');
      if (panel && fab && !panel.contains(e.target) && !fab.contains(e.target)) {
        panel.classList.remove('open');
      }
    });

    function applyLightMode(enabled) {
      document.body.classList.toggle('light-mode', enabled);
      localStorage.setItem('gjdm_light_mode', enabled ? '1' : '0');
    }

    // Restore preference on load
    (function() {
      const saved = localStorage.getItem('gjdm_light_mode');
      if (saved === '1') {
        document.body.classList.add('light-mode');
        window.addEventListener('DOMContentLoaded', () => {
          const toggle = document.getElementById('toggle-light-mode');
          if (toggle) toggle.checked = true;
        });
      }
    })();

    // Collapse financial config and saved docs on mobile by default
    if (window.innerWidth <= 768) {
      const fin = document.getElementById('accordion-financial');
      if (fin) fin.removeAttribute('open');
      const saved = document.getElementById('accordion-saved');
      if (saved) saved.removeAttribute('open');
    }

    let dashTab = 'invoices';

    function setDashTab(tab) {
      dashTab = tab;
      const invBtn  = document.getElementById('dash-tab-invoices');
      const cashBtn = document.getElementById('dash-tab-cash');
      if (invBtn && cashBtn) {
        invBtn.style.background  = tab === 'invoices' ? 'var(--accent)' : 'transparent';
        invBtn.style.color       = tab === 'invoices' ? '#000' : 'var(--text-3)';
        cashBtn.style.background = tab === 'cash' ? 'var(--accent)' : 'transparent';
        cashBtn.style.color      = tab === 'cash' ? '#000' : 'var(--text-3)';
      }
      loadDashboard();
    }

    // ===== DASHBOARD =====
    function loadDashboard() {
      const period = document.getElementById('dashboard-period')?.value || 'this_month';
      const container = document.getElementById('dashboard-content');
      if (!container) return;
      if (!can('viewDashboard', true)) {
        container.innerHTML = '<div style="text-align:center;padding:32px;color:var(--text-3);"><div style="font-size:32px;margin-bottom:12px;">🚫</div><div style="font-family:var(--font-head);font-weight:700;">Access Restricted</div><div style="font-size:12px;margin-top:6px;">Dashboard access has been disabled for your account.</div></div>';
        return;
      }
      container.innerHTML = '<div style="text-align:center;color:var(--text-3);padding:24px;">Loading...</div>';

      db.ref('calendarEvents').once('value', (calSnap) => {
      const calData = calSnap.val() || {};
      let calRevenue = 0;
      let calCount = 0;
      Object.values(calData).forEach((dayEvents) => {
        if (typeof dayEvents !== 'object' || dayEvents === null) return;
        Object.values(dayEvents).forEach((ev) => {
          if (typeof ev !== 'object' || ev === null) return;
          const p = parseFloat(ev.price || 0);
          if (p > 0) { calRevenue += p; calCount++; }
        });
      });

      db.ref('savedDocuments').once('value', (snap) => {
        const data = snap.val();
        if (!data) {
          container.innerHTML = `<div class="dash-no-data"><span>📭</span>No documents yet.</div>`;
          return;
        }

        const now = new Date();
        const entries = Object.entries(data);

        // Get date range
        function getRange(period) {
          const start = new Date();
          const end   = new Date();
          end.setHours(23, 59, 59, 999);
          if (period === 'this_month') {
            start.setDate(1); start.setHours(0,0,0,0);
          } else if (period === 'last_month') {
            start.setMonth(start.getMonth() - 1, 1); start.setHours(0,0,0,0);
            end.setDate(0); end.setHours(23,59,59,999);
          } else if (period === 'last_3') {
            start.setMonth(start.getMonth() - 3, 1); start.setHours(0,0,0,0);
          } else if (period === 'last_6') {
            start.setMonth(start.getMonth() - 6, 1); start.setHours(0,0,0,0);
          } else if (period === 'this_year') {
            start.setMonth(0, 1); start.setHours(0,0,0,0);
          } else {
            return null; // all time
          }
          return { start, end };
        }

        const range = getRange(period);

        // Filter docs by period
        const filtered = entries.filter(([, doc]) => {
          if (!range) return true;
          const ts = doc.timestamp || 0;
          return ts >= range.start.getTime() && ts <= range.end.getTime();
        });

        if (filtered.length === 0 && dashTab === 'invoices') {
          container.innerHTML = `
            <div class="dash-no-data"><span>📭</span>No invoice data for this period.</div>
          `;
          return;
        }

        // Calculate stats
        function parseTotal(str) {
          if (!str) return 0;
          return parseFloat(String(str).replace(/[$,]/g, '')) || 0;
        }

        const invoices  = filtered.filter(([, d]) => d.type === 'INVOICE');
        const quotes    = filtered.filter(([, d]) => d.type === 'QUOTE');
        const deposits  = filtered.filter(([, d]) => d.type === 'DEPOSIT');
        const paid      = invoices.filter(([, d]) => d.status === 'paid');
        const unpaid    = invoices.filter(([, d]) => d.status !== 'paid');

        const totalInvoiced  = invoices.reduce((sum, [, d]) => sum + parseTotal(d.total), 0);
        const totalCollected = paid.reduce((sum, [, d]) => sum + parseTotal(d.total), 0);
        const totalDeposits  = deposits.reduce((sum, [, d]) => sum + parseFloat(d.depositAmount || 0), 0);
        const totalOutstanding = unpaid.reduce((sum, [, d]) => sum + parseTotal(d.total), 0);

        function fmtMoney(n) {
          return '$' + n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }

        // Top customers by invoice value
        const customerMap = {};
        invoices.forEach(([, d]) => {
          const name = d.customer?.name || 'Unknown';
          if (!customerMap[name]) customerMap[name] = 0;
          customerMap[name] += parseTotal(d.total);
        });
        const topCustomers = Object.entries(customerMap)
          .sort((a, b) => b[1] - a[1])
          .slice(0, 3);

        // Most recent unpaid invoices
        const recentUnpaid = unpaid
          .sort((a, b) => (b[1].timestamp || 0) - (a[1].timestamp || 0))
          .slice(0, 3);

        // Period label
        const periodLabels = {
          this_month: 'This Month',
          last_month: 'Last Month',
          last_3: 'Last 3 Months',
          last_6: 'Last 6 Months',
          this_year: 'This Year',
          all_time: 'All Time'
        };

        container.innerHTML = dashTab === 'invoices' ? `
          <div class="dash-grid">
            <div class="dash-card accent">
              <div class="dash-card-label">Total Invoiced</div>
              <div class="dash-card-value">${fmtMoney(totalInvoiced)}</div>
              <div class="dash-card-sub">${invoices.length} invoice${invoices.length !== 1 ? 's' : ''}</div>
            </div>
            <div class="dash-card green">
              <div class="dash-card-label">Collected</div>
              <div class="dash-card-value">${fmtMoney(totalCollected)}</div>
              <div class="dash-card-sub">${paid.length} paid</div>
            </div>
            <div class="dash-card red">
              <div class="dash-card-label">Outstanding</div>
              <div class="dash-card-value">${fmtMoney(totalOutstanding)}</div>
              <div class="dash-card-sub">${unpaid.length} unpaid</div>
            </div>
            <div class="dash-card yellow">
              <div class="dash-card-label">Deposits</div>
              <div class="dash-card-value">${fmtMoney(totalDeposits)}</div>
              <div class="dash-card-sub">${deposits.length} deposit${deposits.length !== 1 ? 's' : ''}</div>
            </div>
          </div>
          <div class="dash-grid" style="grid-template-columns:repeat(3,1fr);min-width:0;word-break:break-word;">
            <div class="dash-card">
              <div class="dash-card-label">Quotes</div>
              <div class="dash-card-value" style="font-size:28px;">${quotes.length}</div>
            </div>
            <div class="dash-card">
              <div class="dash-card-label">Converted</div>
              <div class="dash-card-value" style="font-size:28px;">${paid.length}</div>
            </div>
            <div class="dash-card">
              <div class="dash-card-label">Total Docs</div>
              <div class="dash-card-value" style="font-size:28px;">${filtered.length}</div>
            </div>
          </div>
          ${topCustomers.length > 0 ? `
          <div class="dash-section-label">Top Customers</div>
          ${topCustomers.map(([name, total], i) => `
            <div class="dash-doc-row">
              <span>${['🥇','🥈','🥉'][i]} ${name}</span>
              <span style="font-family:var(--font-head);font-weight:700;color:var(--accent);">${fmtMoney(total)}</span>
            </div>
          `).join('')}
          ` : ''}
          ${recentUnpaid.length > 0 ? `
          <div class="dash-section-label">Unpaid Invoices</div>
          ${recentUnpaid.map(([key, doc]) => `
            <div class="dash-doc-row" onclick="currentFirebaseKey='${key}';loadDocument(${JSON.stringify(doc).replace(/'/g, "\\'")})">
              <span style="color:var(--red);">⚠ INV #${doc.id} — ${doc.customer?.name || 'Unknown'}</span>
              <span style="font-weight:700;">${doc.total || '—'}</span>
            </div>
          `).join('')}
          ` : ''}
          <div style="text-align:right;margin-top:12px;font-size:10px;color:var(--text-3);">
            ${periodLabels[period]} · Updated just now
          </div>
        ` : `
          <div class="dash-grid">
            <div class="dash-card green">
              <div class="dash-card-label">Total Cash Collected</div>
              <div class="dash-card-value">${fmtMoney(calRevenue)}</div>
              <div class="dash-card-sub">${calCount} cash event${calCount !== 1 ? 's' : ''}</div>
            </div>
            <div class="dash-card accent">
              <div class="dash-card-label">Combined Revenue</div>
              <div class="dash-card-value">${fmtMoney(totalCollected + calRevenue)}</div>
              <div class="dash-card-sub">Invoices + cash sales</div>
            </div>
          </div>
          ${calCount > 0 ? (() => {
            const allEvents = Object.entries(calData).sort((a,b) => b[0].localeCompare(a[0])).flatMap(([dateKey, dayEvents]) =>
              Object.values(dayEvents).filter(ev => parseFloat(ev.price||0) > 0).map(ev => `
                <div class="dash-doc-row">
                  <span>💵 ${ev.customer} · ${ev.product || '—'}</span>
                  <span style="font-family:var(--font-head);font-weight:700;color:#4cff91;">$${parseFloat(ev.price).toLocaleString(undefined,{minimumFractionDigits:2,maximumFractionDigits:2})}</span>
                </div>
              `)
            );
            const visible = allEvents.slice(0, 5).join('');
            const hidden  = allEvents.slice(5).join('');
            return `
              <div class="dash-section-label">Cash Sale Events</div>
              ${visible}
              ${hidden.length > 0 ? `
                <div id="dash-cash-extra" style="display:none;">${hidden}</div>
                <button onclick="const el=document.getElementById('dash-cash-extra');const btn=this;if(el.style.display==='none'){el.style.display='block';btn.textContent='Show Less ▲';}else{el.style.display='none';btn.textContent='Show All ${allEvents.length} ▼';}" style="width:100%;margin-top:6px;padding:10px;background:var(--surface-2);border:1px solid var(--border);border-radius:var(--radius);color:var(--text-2);font-family:var(--font-head);font-weight:700;font-size:11px;text-transform:uppercase;cursor:pointer;min-height:40px;">Show All ${allEvents.length} ▼</button>
              ` : ''}
            `;
          })() : '<div class="dash-no-data"><span>💵</span>No cash sales logged yet.</div>'}
          <div style="text-align:right;margin-top:12px;font-size:10px;color:var(--text-3);">
            ${periodLabels[period]} · Updated just now
          </div>
        `;
      });
      });
    }

    // ===== CALENDAR =====
    let calView = 'grid'; // 'grid' or 'list'

    function setCalView(view) {
      calView = view;
      document.getElementById('btn-cal-grid').style.cssText += ';background:' + (view === 'grid' ? 'var(--accent);color:#000;border:none' : 'var(--surface-2);color:var(--text);border:1px solid var(--border)');
      document.getElementById('btn-cal-list').style.cssText += ';background:' + (view === 'list' ? 'var(--accent);color:#000;border:none' : 'var(--surface-2);color:var(--text);border:1px solid var(--border)');
      renderCalendar();
    }

    let calYear  = new Date().getFullYear();
    let calMonth = new Date().getMonth();
    let calEvents = {}; // { 'YYYY-MM-DD': [ {type, customer, notes, invoiceKey, id} ] }
    let calSelectedDate = null;
    let calEditingId = null;
    let calIsFullscreen = false;

    const CAL_MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
    const CAL_DAYS   = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];

    // Load all calendar events from Firebase
    function initCalendar() {
      db.ref('calendarEvents').on('value', (snap) => {
        calEvents = snap.val() || {};
        renderCalendar();
      });

      // Also pull saved invoices/quotes/deposits onto calendar by date
      db.ref('savedDocuments').on('value', (snap) => {
        const data = snap.val() || {};
        // Build a map of doc events by date
        window._docEvents = {};
        Object.entries(data).forEach(([key, doc]) => {
          if (!doc.date) return;
          const dateKey = doc.date;
          if (!window._docEvents[dateKey]) window._docEvents[dateKey] = [];
          window._docEvents[dateKey].push({ ...doc, _firebaseKey: key });
        });
        renderCalendar();
      });
    }

    function getDateKey(y, m, d) {
      return `${y}-${String(m+1).padStart(2,'0')}-${String(d).padStart(2,'0')}`;
    }

    function renderCalendar() {
      if (calView === 'list') {
        renderCalendarList('calendar-inner');
      } else {
        renderCalendarInto('calendar-inner');
      }
      if (calIsFullscreen) renderCalendarInto('calendar-fullscreen-inner');
    }

    function renderCalendarList(containerId) {
      const container = document.getElementById(containerId);
      if (!container) return;

      // Gather all events (custom + docs) into a flat sorted list
      const allEvents = [];

      // Custom events (pickups/deliveries)
      Object.entries(calEvents).forEach(([dateKey, dayEvents]) => {
        Object.entries(dayEvents).forEach(([id, ev]) => {
          allEvents.push({ dateKey, id, source: 'custom', ev });
        });
      });

      // Doc events
      Object.entries(window._docEvents || {}).forEach(([dateKey, docs]) => {
        docs.forEach(doc => {
          allEvents.push({ dateKey, source: 'doc', doc });
        });
      });

      // Sort by date ascending
      allEvents.sort((a, b) => a.dateKey.localeCompare(b.dateKey));

      if (allEvents.length === 0) {
        container.innerHTML = `<div style="text-align:center;color:var(--text-3);padding:32px;">No events found.</div>`;
        return;
      }

      // Group by date
      const grouped = {};
      allEvents.forEach(item => {
        if (!grouped[item.dateKey]) grouped[item.dateKey] = [];
        grouped[item.dateKey].push(item);
      });

      const today = new Date().toISOString().split('T')[0];
      let html = `<div style="display:flex;flex-direction:column;gap:0;">`;

      Object.entries(grouped).forEach(([dateKey, items]) => {
        const [y, m, d] = dateKey.split('-');
        const label = `${CAL_MONTHS[parseInt(m)-1]} ${parseInt(d)}, ${y}`;
        const isToday = dateKey === today;
        const isPast  = dateKey < today;

        html += `
          <div style="margin-bottom:12px;">
            <div style="font-size:11px;font-family:var(--font-head);font-weight:700;text-transform:uppercase;letter-spacing:0.08em;color:${isToday ? 'var(--accent)' : isPast ? 'var(--text-3)' : 'var(--text-2)'};padding:6px 0;border-bottom:1px solid var(--border);margin-bottom:8px;">
              ${isToday ? '📍 Today — ' : ''}${label}
            </div>`;

        items.forEach(item => {
          if (item.source === 'custom') {
            const ev = item.ev;
            const color = ev.type === 'pickup' ? 'var(--accent)' : '#a855f7';
            const icon  = ev.type === 'pickup' ? '🟡' : '🟣';
            const typeLabel = ev.type === 'pickup' ? 'Customer Pickup' : 'Delivery';
            html += `
              <div style="background:var(--surface);border:1px solid var(--border);border-radius:6px;padding:10px 14px;margin-bottom:6px;display:flex;justify-content:space-between;align-items:flex-start;gap:8px;">
                <div style="flex:1;min-width:0;">
                  <div style="font-size:12px;font-weight:700;color:${color};">${icon} ${typeLabel}</div>
                  <div style="font-size:12px;color:var(--text);margin-top:2px;">${ev.customer}</div>
                  ${ev.address ? `<div style="font-size:11px;color:var(--text-3);margin-top:2px;">📍 ${ev.address}</div>` : ''}
                  ${ev.notes ? `<div style="font-size:11px;color:var(--text-3);margin-top:2px;">${ev.notes}</div>` : ''}
                  ${ev.invoiceKey ? `<div style="font-size:10px;color:var(--accent);margin-top:3px;">🔗 Linked doc</div>` : ''}
                </div>
                <div style="display:flex;gap:5px;flex-shrink:0;">
                  <button onclick="editCalendarEvent('${item.dateKey}','${item.id}')" class="btn-action btn-secondary" style="min-height:30px;padding:4px 8px;font-size:10px;">✏</button>
                  <button onclick="deleteCalendarEvent('${item.dateKey}','${item.id}')" class="btn-action" style="min-height:30px;padding:4px 8px;font-size:10px;background:rgba(255,74,74,0.1);color:var(--red);border:none;">🗑</button>
                </div>
              </div>`;
          } else {
            const doc = item.doc;
            const custName = doc.customer?.name || 'Unknown';
            const color = doc.status === 'paid' ? '#4cff91' : doc.type === 'INVOICE' ? 'var(--red)' : '#4285F4';
            const typeLabel = doc.type === 'INVOICE' ? `Invoice #${doc.id}` : doc.type === 'QUOTE' ? `Quote #${doc.id}` : `Deposit #${doc.id}`;
            html += `
              <div style="background:var(--surface);border:1px solid var(--border);border-radius:6px;padding:10px 14px;margin-bottom:6px;display:flex;justify-content:space-between;align-items:center;gap:8px;cursor:pointer;" onclick="currentFirebaseKey='${doc._firebaseKey}';loadDocument(${JSON.stringify(doc).replace(/"/g,'&quot;')});document.getElementById('accordion-items')?.setAttribute('open','');">
                <div>
                  <div style="font-size:12px;font-weight:700;color:${color};">${typeLabel}</div>
                  <div style="font-size:11px;color:var(--text-2);">${custName} · ${doc.total || '—'}</div>
                </div>
                <div style="font-size:10px;padding:3px 8px;border-radius:4px;background:${doc.status === 'paid' ? 'rgba(76,255,145,0.15)' : 'rgba(255,74,74,0.12)'};color:${doc.status === 'paid' ? '#4cff91' : 'var(--red)'};">${doc.status === 'paid' ? 'PAID' : 'UNPAID'}</div>
              </div>`;
          }
        });

        html += `</div>`;
      });

      html += `</div>`;
      container.innerHTML = html;
    }

    function renderCalendarInto(containerId) {
      const container = document.getElementById(containerId);
      if (!container) return;

      const firstDay = new Date(calYear, calMonth, 1).getDay();
      const daysInMonth = new Date(calYear, calMonth + 1, 0).getDate();
      const today = new Date();
      const todayKey = getDateKey(today.getFullYear(), today.getMonth(), today.getDate());

      let html = `
        <div class="cal-header">
          <button class="cal-nav" onclick="calPrev()">‹</button>
          <div class="cal-month-label">${CAL_MONTHS[calMonth]} ${calYear}</div>
          <button class="cal-nav" onclick="calNext()">›</button>
        </div>
        <div class="cal-grid">
          ${CAL_DAYS.map(d => `<div class="cal-day-header">${d}</div>`).join('')}
      `;

      // Empty cells before first day
      for (let i = 0; i < firstDay; i++) {
        html += `<div class="cal-day empty"></div>`;
      }

      for (let day = 1; day <= daysInMonth; day++) {
        const dateKey = getDateKey(calYear, calMonth, day);
        const isToday = dateKey === todayKey;
        const customEvents = calEvents[dateKey] || {};
        const docEvents    = (window._docEvents || {})[dateKey] || [];

        // Build event pills
        let pills = '';

        // Doc events (invoices, quotes, deposits)
        docEvents.forEach(doc => {
          let cls = 'invoice-unpaid';
          let label = '';
          const custName = doc.customer?.name || 'Unknown';
          const shortName = custName.split(' ')[0];
          if (doc.type === 'INVOICE') {
            cls = doc.status === 'paid' ? 'invoice-paid' : 'invoice-unpaid';
            label = `INV #${doc.id} · ${shortName}`;
          } else if (doc.type === 'QUOTE') {
            cls = 'deposit';
            label = `QUO #${doc.id} · ${shortName}`;
          } else if (doc.type === 'DEPOSIT') {
            cls = 'deposit';
            label = `DEP #${doc.id} · ${shortName}`;
          }
          pills += `<div class="cal-event ${cls}" title="${custName}">${label}</div>`;
        });

        // Custom events (pickup/delivery)
        Object.entries(customEvents).forEach(([id, ev]) => {
          const cls = ev.type === 'pickup' ? 'pickup' : 'delivery';
          const label = ev.type === 'pickup' ? `🟡 ${ev.customer}` : `🟣 ${ev.customer}`;
          pills += `<div class="cal-event ${cls}" title="${ev.notes || ''}">${label}</div>`;
        });

        html += `
          <div class="cal-day${isToday ? ' today' : ''}" onclick="openDayModal('${dateKey}')">
            <div class="cal-day-num">${day}</div>
            ${pills}
          </div>
        `;
      }

      html += `</div>`;
      container.innerHTML = html;
    }

    function calPrev() {
      calMonth--;
      if (calMonth < 0) { calMonth = 11; calYear--; }
      renderCalendar();
    }

    function calNext() {
      calMonth++;
      if (calMonth > 11) { calMonth = 0; calYear++; }
      renderCalendar();
    }

    function toggleCalFullscreen() {
      calIsFullscreen = !calIsFullscreen;
      const fs = document.getElementById('cal-fullscreen');
      fs.classList.toggle('active', calIsFullscreen);
      if (calIsFullscreen) renderCalendarInto('calendar-fullscreen-inner');
    }

    // ===== DAY DETAIL MODAL =====
    function openDayModal(dateKey) {
      calSelectedDate = dateKey;
      const modal   = document.getElementById('cal-day-modal');
      const overlay = document.getElementById('cal-day-overlay');
      const content = document.getElementById('cal-day-modal-content');
      const title   = document.getElementById('cal-day-modal-title');

      // Format title
      const [y, m, d] = dateKey.split('-');
      title.textContent = `${CAL_MONTHS[parseInt(m)-1]} ${parseInt(d)}, ${y}`;

      const customEvents = calEvents[dateKey] || {};
      const docEvents    = (window._docEvents || {})[dateKey] || [];

      let html = '';

      // Doc events
      if (docEvents.length > 0) {
        html += `<div style="font-size:10px;text-transform:uppercase;letter-spacing:0.1em;color:var(--text-3);margin-bottom:10px;">Documents</div>`;
        docEvents.forEach(doc => {
          const custName = doc.customer?.name || 'Unknown';
          let color = doc.status === 'paid' ? '#4cff91' : doc.type === 'INVOICE' ? 'var(--red)' : '#4285F4';
          let typeLabel = doc.type === 'INVOICE' ? `Invoice #${doc.id}` : doc.type === 'QUOTE' ? `Quote #${doc.id}` : `Deposit #${doc.id}`;
          html += `
            <div style="background:var(--surface-2);border:1px solid var(--border);border-radius:6px;padding:12px 16px;margin-bottom:8px;display:flex;justify-content:space-between;align-items:center;">
              <div>
                <div style="font-weight:600;font-size:13px;color:${color};">${typeLabel}</div>
                <div style="font-size:12px;color:var(--text-2);">${custName} · ${doc.total || '—'}</div>
              </div>
              <button onclick="currentFirebaseKey='${doc._firebaseKey}';loadDocument(${JSON.stringify(doc).replace(/"/g, '&quot;')});closeDayModal();" class="btn-action btn-secondary" style="min-height:32px;padding:4px 10px;font-size:10px;">Open</button>
            </div>
          `;
        });
      }

      // Custom events
      const customArr = Object.entries(customEvents);
      if (customArr.length > 0) {
        html += `<div style="font-size:10px;text-transform:uppercase;letter-spacing:0.1em;color:var(--text-3);margin:16px 0 10px 0;">Pickup & Delivery</div>`;
        customArr.forEach(([id, ev]) => {
          const color = ev.type === 'pickup' ? 'var(--accent)' : '#a855f7';
          const icon  = ev.type === 'pickup' ? '🟡' : '🟣';
          html += `
            <div style="background:var(--surface-2);border:1px solid var(--border);border-radius:6px;padding:12px 16px;margin-bottom:8px;">
              <div style="display:flex;justify-content:space-between;align-items:flex-start;">
                <div>
                  <div style="font-weight:600;font-size:13px;color:${color};">${icon} ${ev.type === 'pickup' ? 'Customer Pickup' : 'Delivery'}</div>
                  <div style="font-size:12px;color:var(--text-2);margin-top:2px;">${ev.customer}</div>
                  ${ev.address ? `<div style="font-size:11px;color:var(--text-3);margin-top:3px;">📍 ${ev.address}</div>` : ''}
                  ${ev.product ? `<div style="font-size:11px;color:var(--text-2);margin-top:3px;">📦 ${ev.product}</div>` : ''}
                  ${ev.price || ev.payment ? `<div style="font-size:11px;color:var(--accent);margin-top:3px;font-family:var(--font-head);font-weight:700;">${ev.price ? '$' + parseFloat(ev.price).toLocaleString(undefined,{minimumFractionDigits:2}) : ''}${ev.price && ev.payment ? ' · ' : ''}${ev.payment || ''}</div>` : ''}
                  ${ev.notes ? `<div style="font-size:11px;color:var(--text-3);margin-top:4px;">${ev.notes}</div>` : ''}
                  ${ev.invoiceKey ? `<div style="font-size:11px;color:var(--accent);margin-top:4px;">Linked doc attached</div>` : ''}
                </div>
                <div style="display:flex;gap:6px;flex-shrink:0;">
                  <button onclick="editCalendarEvent('${dateKey}','${id}')" class="btn-action btn-secondary" style="min-height:30px;padding:4px 8px;font-size:10px;">✏</button>
                  <button onclick="deleteCalendarEvent('${dateKey}','${id}')" class="btn-action" style="min-height:30px;padding:4px 8px;font-size:10px;background:rgba(255,74,74,0.1);color:var(--red);border:none;">🗑</button>
                </div>
              </div>
            </div>
          `;
        });
      }

      if (!html) {
        html = `<div style="text-align:center;color:var(--text-3);padding:24px;">No events on this day.</div>`;
      }

      content.innerHTML = html;
      modal.classList.add('open');
      overlay.classList.add('open');
    }

    function closeDayModal() {
      document.getElementById('cal-day-modal').classList.remove('open');
      document.getElementById('cal-day-overlay').classList.remove('open');
    }

    // ===== ADD / EDIT EVENT MODAL =====
    function openAddEventModal(dateKey) {
      if (!can('manageCalendar')) return;
      calEditingId = null;
      closeDayModal();

      // Pre-fill date
      const dateInput = document.getElementById('cal-event-date');
      if (dateKey) {
        dateInput.value = dateKey;
      } else {
        dateInput.value = new Date().toISOString().split('T')[0];
      }

      // Clear fields
      document.getElementById('cal-event-customer').value = '';
      document.getElementById('cal-event-address').value  = '';
      document.getElementById('cal-event-product').value  = '';
      document.getElementById('cal-event-price').value    = '';
      document.getElementById('cal-event-payment').value  = '';
      document.getElementById('cal-event-notes').value    = '';
      document.getElementById('cal-event-type').value     = 'pickup';
      document.getElementById('cal-add-error').style.display = 'none';

      // Populate invoice dropdown
      populateInvoiceDropdown();

      document.getElementById('cal-add-modal').classList.add('open');
      document.getElementById('cal-add-overlay').classList.add('open');
    }

    function editCalendarEvent(dateKey, id) {
      calEditingId = id;
      const ev = calEvents[dateKey]?.[id];
      if (!ev) return;

      closeDayModal();
      document.getElementById('cal-event-type').value     = ev.type || 'pickup';
      document.getElementById('cal-event-date').value     = dateKey;
      document.getElementById('cal-event-customer').value = ev.customer || '';
      document.getElementById('cal-event-address').value  = ev.address || '';
      document.getElementById('cal-event-product').value  = ev.product || '';
      document.getElementById('cal-event-price').value    = ev.price || '';
      document.getElementById('cal-event-payment').value  = ev.payment || '';
      document.getElementById('cal-event-notes').value    = ev.notes || '';
      document.getElementById('cal-add-error').style.display = 'none';

      populateInvoiceDropdown(ev.invoiceKey);

      document.getElementById('cal-add-modal').classList.add('open');
      document.getElementById('cal-add-overlay').classList.add('open');
    }

    function closeAddEventModal() {
      document.getElementById('cal-add-modal').classList.remove('open');
      document.getElementById('cal-add-overlay').classList.remove('open');
      calEditingId = null;
    }

    function populateInvoiceDropdown(selectedKey) {
      const select = document.getElementById('cal-event-invoice');
      select.innerHTML = '<option value="">— None —</option>';
      db.ref('savedDocuments').once('value', (snap) => {
        const data = snap.val() || {};
        Object.entries(data)
          .sort((a, b) => (b[1].timestamp || 0) - (a[1].timestamp || 0))
          .forEach(([key, doc]) => {
            const custName = doc.customer?.name || 'Unknown';
            const opt = document.createElement('option');
            opt.value = key;
            opt.textContent = `${doc.type} #${doc.id} — ${custName}`;
            if (key === selectedKey) opt.selected = true;
            select.appendChild(opt);
          });
      });
    }

    async function saveCalendarEvent() {
      const type       = document.getElementById('cal-event-type').value;
      const dateKey    = document.getElementById('cal-event-date').value;
      const customer   = document.getElementById('cal-event-customer').value.trim();
      const address    = document.getElementById('cal-event-address').value.trim();
      const product    = document.getElementById('cal-event-product').value.trim();
      const price      = document.getElementById('cal-event-price').value.trim();
      const payment    = document.getElementById('cal-event-payment').value;
      const notes      = document.getElementById('cal-event-notes').value.trim();
      const invoiceKey = document.getElementById('cal-event-invoice').value;
      const errEl      = document.getElementById('cal-add-error');

      if (!dateKey) { errEl.textContent = 'Please select a date.'; errEl.style.display = 'block'; return; }
      if (!customer) { errEl.textContent = 'Please enter a customer name.'; errEl.style.display = 'block'; return; }

      const eventData = { type, customer, address, product, price, payment, notes, invoiceKey, createdAt: Date.now() };

      if (calEditingId) {
        await db.ref(`calendarEvents/${dateKey}/${calEditingId}`).set(eventData);
      } else {
        await db.ref(`calendarEvents/${dateKey}`).push(eventData);
      }

      closeAddEventModal();
      showToast('✓ Event saved!');
    }

    async function deleteCalendarEvent(dateKey, id) {
      if (!can('manageCalendar')) return;
      if (!confirm('Delete this event?')) return;
      await db.ref(`calendarEvents/${dateKey}/${id}`).remove();
      closeDayModal();
      showToast('Event deleted.');
    }

    // Keyboard shortcuts
    document.addEventListener('keydown', (e) => {
      // Only fire if not typing in an input/textarea
      const tag = document.activeElement?.tagName;
      const isTyping = tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT';

      if (e.ctrlKey && e.key === 's') {
        e.preventDefault();
        saveDraft();
        showToast('✓ Saved');
      }
      if (e.ctrlKey && e.key === 'p') {
        e.preventDefault();
        exportPDF();
      }
    });

    async function downloadAllAsZip() {
  if (!can('downloadAllZip')) return;
  if (!confirm('This will generate a PDF for every saved document. It may take a while. Continue?')) return;
  const loader = document.getElementById('loader');
  loader.querySelector('div').textContent = 'Building ZIP...';
  loader.style.display = 'flex';
  try {
    const snap = await db.ref('savedDocuments').once('value');
    const data = snap.val();
    if (!data) { alert('No saved documents found.'); loader.style.display = 'none'; return; }
    const zip = new JSZip();
    const entries = Object.values(data);
    for (let i = 0; i < entries.length; i++) {
      const doc = entries[i];
      loader.querySelector('div').textContent = `Building ${i + 1} of ${entries.length}...`;
      loadDocument(doc);
      await new Promise(r => setTimeout(r, 300));
      const result = await buildPDF();
      const pdfBlob = result.pdf.output('blob');
      zip.file(result.filename, pdfBlob);
    }
    const zipBlob = await zip.generateAsync({ type: 'blob' });
    const url = URL.createObjectURL(zipBlob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `GlobalJDM_AllDocuments_${new Date().toISOString().split('T')[0]}.zip`;
    a.click();
    URL.revokeObjectURL(url);
  } catch(err) {
    console.error('ZIP failed:', err);
    alert('Something went wrong generating the ZIP.');
  }
  loader.querySelector('div').textContent = 'Generating PDF...';
  loader.style.display = 'none';
}
// ====================== PART REQUEST WAITLIST ======================
  let waitlistData = {};
  let waitlistFilter = 'all';

  let waitlistPrevCount = null;
  function initWaitlistListener() {
    db.ref('partWaitlist').on('value', (snap) => {
      waitlistData = snap.val() || {};

      // Notify on new waitlist entry — but not on first load
      const newCount = Object.keys(waitlistData).length;
      if (waitlistPrevCount !== null && newCount > waitlistPrevCount) {
        const entries = Object.values(waitlistData).sort((a,b) => (b.submittedAt||0)-(a.submittedAt||0));
        const newest = entries[0] || {};
        sendNtfy(
          '🔔 New Part Waitlist — ' + (newest.partName || newest.sku || 'Unknown part'),
          (newest.name || 'Customer') + ' · ' + (newest.phone || newest.email || '') + '\n' + (newest.partName || newest.sku || '') + (newest.country ? ' · ' + newest.country : ''),
          'default'
        );
      }
      waitlistPrevCount = newCount;

      renderWaitlist();
      updateWaitlistBadge();
    });
  }

  function updateWaitlistBadge() {
    const n = Object.values(waitlistData).filter(r => r.status === 'new').length;
    const badge = document.getElementById('waitlist-accordion-badge');
    if (badge) {
      badge.textContent = n > 0 ? n + ' new' : '';
      badge.style.display = n > 0 ? 'inline' : 'none';
    }
  }

  function renderWaitlist() {
    const container = document.getElementById('waitlist-list');
    if (!container) return;
    let entries = Object.entries(waitlistData)
      .sort((a, b) => (b[1].submittedAt || 0) - (a[1].submittedAt || 0));
    if (waitlistFilter === 'new')    entries = entries.filter(([,r]) => r.status === 'new');
    if (waitlistFilter === 'canada') entries = entries.filter(([,r]) => r.country === 'Canada');
    if (waitlistFilter === 'usa')    entries = entries.filter(([,r]) => r.country === 'USA');
    if (waitlistFilter === 'done')   entries = entries.filter(([,r]) => r.status === 'done');
    if (!entries.length) {
      container.innerHTML = `<div style="text-align:center;color:var(--text-3);padding:24px;font-size:12px;">No requests yet.</div>`;
      return;
    }
    container.innerHTML = entries.map(([key, r]) => {
      const vehicle = r.vehicle ? `${r.vehicle.year||''} ${r.vehicle.make||''} ${r.vehicle.model||''}`.trim() : '—';
      const age = r.submittedAt ? formatWaitlistAge(r.submittedAt) : '—';
      const isNew = r.status === 'new';
      const isUS  = r.country === 'USA';
      return `
        <div style="background:var(--surface-2);border:1px solid ${isNew ? 'rgba(232,255,74,0.3)' : 'var(--border)'};border-radius:var(--radius);margin-bottom:8px;overflow:hidden;">
          <div onclick="toggleWaitlistCard('${key}')" style="padding:12px 14px;cursor:pointer;display:flex;justify-content:space-between;align-items:flex-start;gap:10px;">
            <div style="flex:1;min-width:0;">
              <div style="font-family:var(--font-head);font-weight:700;font-size:13px;color:var(--text);display:flex;align-items:center;gap:6px;flex-wrap:wrap;">
                ${escI(r.name||'—')}
                ${isNew ? '<span style="background:var(--accent);color:#000;font-size:9px;font-weight:800;padding:2px 6px;border-radius:3px;">NEW</span>' : ''}
                ${isUS ? '<span style="background:rgba(255,165,0,0.15);color:#ffa500;font-size:9px;font-weight:700;padding:2px 6px;border-radius:3px;">🇺🇸 USA</span>' : '<span style="background:rgba(232,255,74,0.1);color:var(--accent);font-size:9px;font-weight:700;padding:2px 6px;border-radius:3px;">🇨🇦 CA</span>'}
              </div>
              <div style="font-size:11px;color:var(--text-3);margin-top:3px;">${escI(vehicle)} — ${escI(r.part||'—')}</div>
              <div style="font-size:10px;color:var(--text-3);margin-top:2px;">${age} · ${escI(r.urgency||'—')}</div>
            </div>
            <span style="color:var(--text-3);font-size:14px;flex-shrink:0;">▾</span>
          </div>
          <div id="wlcard-${key}" style="display:none;padding:12px 14px 14px;border-top:1px solid var(--border);">
            <div style="display:grid;grid-template-columns:1fr 1fr;gap:8px 16px;margin-bottom:12px;font-size:11px;">
              <div><span style="color:var(--text-3);">Phone</span><br><strong>${escI(r.phone||'—')}</strong></div>
              <div><span style="color:var(--text-3);">Email</span><br><strong>${escI(r.email||'—')}</strong></div>
              <div><span style="color:var(--text-3);">Region</span><br><strong>${escI(r.region||'—')}</strong></div>
              <div><span style="color:var(--text-3);">Condition</span><br><strong>${escI(r.condition||'—')}</strong></div>
              <div><span style="color:var(--text-3);">Budget</span><br><strong>${escI(r.budget||'Not specified')}</strong></div>
              <div><span style="color:var(--text-3);">Engine</span><br><strong>${escI(r.vehicle?.engine||'—')}</strong></div>
              ${r.vehicle?.trim ? `<div><span style="color:var(--text-3);">Trim</span><br><strong>${escI(r.vehicle.trim)}</strong></div>` : ''}
              <div><span style="color:var(--text-3);">Ref</span><br><strong style="color:var(--accent);">${escI(r.ref||'—')}</strong></div>
            </div>
            ${r.notes ? `<div style="background:var(--surface-3);border-radius:4px;padding:10px 12px;font-size:11px;color:var(--text-2);margin-bottom:12px;line-height:1.6;"><span style="color:var(--text-3);display:block;margin-bottom:4px;font-size:10px;text-transform:uppercase;letter-spacing:0.08em;">Notes</span>${escI(r.notes)}</div>` : ''}
            <div style="display:flex;gap:6px;flex-wrap:wrap;">
              ${r.phone ? `<button onclick="window.open('https://wa.me/${r.phone.replace(/\D/g,'')}?text=${encodeURIComponent('Hi '+(r.name||'')+', this is Global JDM Auto Parts following up on your part request (Ref: '+(r.ref||'')+') for a '+vehicle+'. ')}','_blank')" style="background:#25D366;color:#fff;border:none;border-radius:4px;padding:6px 12px;font-family:var(--font-head);font-weight:700;font-size:10px;cursor:pointer;min-height:32px;">💬 WhatsApp</button>` : ''}
              ${r.status !== 'done'
                ? `<button onclick="setWaitlistStatus('${key}','done')" style="background:rgba(76,255,145,0.1);color:#4cff91;border:1px solid rgba(76,255,145,0.2);border-radius:4px;padding:6px 12px;font-family:var(--font-head);font-weight:700;font-size:10px;cursor:pointer;min-height:32px;">✓ Mark Done</button>`
                : `<button onclick="setWaitlistStatus('${key}','new')" style="background:var(--surface-3);color:var(--text-2);border:1px solid var(--border);border-radius:4px;padding:6px 12px;font-family:var(--font-head);font-weight:700;font-size:10px;cursor:pointer;min-height:32px;">↩ Reopen</button>`
              }
              <button onclick="deleteWaitlistEntry('${key}')" style="background:rgba(255,74,74,0.1);color:var(--red);border:none;border-radius:4px;padding:6px 12px;font-family:var(--font-head);font-weight:700;font-size:10px;cursor:pointer;min-height:32px;">🗑 Delete</button>
            </div>
          </div>
        </div>
      `;
    }).join('');
  }

  function toggleWaitlistCard(key) {
    const card = document.getElementById('wlcard-' + key);
    if (!card) return;
    const isOpen = card.style.display === 'block';
    card.style.display = isOpen ? 'none' : 'block';
    if (!isOpen && waitlistData[key]?.status === 'new') {
      setWaitlistStatus(key, 'reviewed', true);
    }
  }

  async function setWaitlistStatus(key, status, silent = false) {
    await db.ref('partWaitlist/' + key + '/status').set(status);
    if (!silent) showToast('✓ Marked as ' + status);
  }

  async function deleteWaitlistEntry(key) {
    if (!can('manageWaitlist')) return;
    if (!confirm('Delete this waitlist request? This cannot be undone.')) return;
    await db.ref('partWaitlist/' + key).remove();
    showToast('Request deleted.');
  }

  function setWaitlistFilter(filter, btn) {
    waitlistFilter = filter;
    document.querySelectorAll('.wl-filter-btn').forEach(b => {
      b.style.background = 'var(--surface-2)';
      b.style.color = 'var(--text-3)';
      b.style.border = '1px solid var(--border)';
    });
    if (btn) { btn.style.background = 'var(--accent)'; btn.style.color = '#000'; btn.style.border = 'none'; }
    renderWaitlist();
  }

  function formatWaitlistAge(ts) {
    const diff = Date.now() - ts;
    const mins = Math.floor(diff / 60000);
    const hours = Math.floor(diff / 3600000);
    const days = Math.floor(diff / 86400000);
    if (mins < 2) return 'Just now';
    if (mins < 60) return mins + 'm ago';
    if (hours < 24) return hours + 'h ago';
    if (days < 7) return days + 'd ago';
    return new Date(ts).toLocaleDateString('en-CA', { month: 'short', day: 'numeric' });
  }

/* ═══════════════════════════════════════════════════════════
   FAMILY CHAT ROOM — Full Feature Set
═══════════════════════════════════════════════════════════ */

let chatOpen            = false;
let chatUnread          = 0;
let chatLastSeen        = Date.now();
let currentUserProfile  = null;
let presenceRef         = null;
let typingTimer         = null;
let selectedColor       = null;
let chatProfiles        = {};
let pinnedMessageKey    = null;
let chatSearchResults   = [];
let chatSearchIndex     = 0;
let chatSearchActive    = false;
let emojiPickerOpenKey  = null;
let chatAllMessages     = {};

const EMOJI_OPTIONS = ['👍','❤️','😂','😮','😢','🔥'];
const WALLPAPER_SOLID_BG = {
  'solid-1': '#0d1117', 'solid-2': '#0f1923',
  'solid-3': '#1a0a2e', 'solid-4': '#0a1a0a', 'solid-5': '#1a0a0a'
};

/* ══════════════════════════════════════
   INIT
══════════════════════════════════════ */
async function initChat() {
  const user = firebase.auth().currentUser;
  if (!user) return;
  // Permission check happens after profile loads below

  const snap = await db.ref('users/' + user.uid).once('value');
  const profile = snap.val();
  if (!profile) return;
  currentUserProfile = { uid: user.uid, ...profile };

  // The local-delivery switch is intentionally admin-only. Its value is
  // stored in Firebase so the Cloudflare Worker can enforce the same live
  // state before calculating a quote or creating an order.
  initLocalDeliveryControl();

  // Live permissions listener — fires instantly when admin changes permissions
  db.ref('users/' + user.uid + '/permissions').on('value', (permSnap) => {
    const newPerms = permSnap.val() || {};
    if (currentUserProfile) {
      currentUserProfile.permissions = newPerms;
      applyLivePermissions();
    }
  });

  // Hide chat FAB if no chat access
  if (!can('accessChat', true)) {
    const fab = document.getElementById('chat-fab');
    if (fab) fab.style.display = 'none';
    return;
  }

  // Restore local prefs
  restoreChatPrefs();

  // Presence
  presenceRef = db.ref('presence/' + user.uid);
  const presenceData = {
    name:     currentUserProfile.name,
    color:    currentUserProfile.color  || '#e8ff4a',
    avatar:   currentUserProfile.avatar || null,
    status:   currentUserProfile.status || '',
    online:   true,
    lastSeen: Date.now(),
    showLastSeen: currentUserProfile.showLastSeen !== false
  };
  presenceRef.set(presenceData);
  presenceRef.onDisconnect().update({ online: false, lastSeen: Date.now() });

  // Listeners
  db.ref('presence').on('value', snap => {
    const data = snap.val() || {};
    Object.entries(data).forEach(([uid, p]) => { chatProfiles[uid] = p; });
    renderPresence(snap);
  });

  db.ref('chatTyping').on('value', renderTypingIndicator);
  db.ref('chatPinned').on('value', snap => {
    const data = snap.val();
    if (data && data.key) {
      pinnedMessageKey = data.key;
      showPinBar(data.text || '📌 Pinned message');
    } else {
      pinnedMessageKey = null;
      hidePinBar();
    }
  });

  db.ref('familyChat').limitToLast(100).on('value', snap => {
    chatAllMessages = snap.val() || {};
    renderChatMessages(chatAllMessages);
    if (chatSearchActive) handleChatSearch(document.getElementById('chat-search-input')?.value || '');
  });

  renderQuickReplies();
}

/* ══════════════════════════════════════
   LOCAL PREFS RESTORE
══════════════════════════════════════ */
function restoreChatPrefs() {
  // Font size
  const fs = localStorage.getItem('chat_font_size');
  if (fs) applyChatFontSize(fs, true);

  // Wallpaper
  const wp = localStorage.getItem('chat_wallpaper');
  if (wp) applyChatWallpaper(wp, true);

  // Sound
  const sound = localStorage.getItem('chat_sound');
  // DND
  const dnd = localStorage.getItem('chat_dnd');
}

/* ══════════════════════════════════════
   TOGGLE PANEL
══════════════════════════════════════ */
function toggleChat() {
  chatOpen = !chatOpen;
  document.getElementById('chat-panel').classList.toggle('open', chatOpen);
  document.getElementById('chat-overlay').classList.toggle('open', chatOpen);

  if (chatOpen) {
    chatUnread   = 0;
    chatLastSeen = Date.now();
    const badge  = document.getElementById('chat-fab-badge');
    badge.textContent = '';
    badge.classList.remove('visible');
    closeEmojiPicker();
    setTimeout(() => {
      const msgs = document.getElementById('chat-messages');
      if (msgs) msgs.scrollTop = msgs.scrollHeight;
    }, 80);
  } else {
    if (presenceRef && currentUserProfile) {
      db.ref('chatTyping/' + currentUserProfile.uid).remove();
    }
    closeChatSearch();
  }
}

/* ══════════════════════════════════════
   PRESENCE
══════════════════════════════════════ */
let _typingUids = {}; // uid → true, updated by chatTyping listener

function renderPresence(snap) {
  const data = snap.val() || {};
  const row  = document.getElementById('chat-presence-row');
  if (!row) return;

  row.innerHTML = Object.entries(data).map(([uid, p]) => {
    const isOnline  = p.online;
    const isTyping  = !!_typingUids[uid] && uid !== currentUserProfile?.uid;
    const showLS    = p.showLastSeen !== false;
    let subText     = '';

    if (!isOnline && showLS && p.lastSeen) {
      const diff  = Date.now() - p.lastSeen;
      const mins  = Math.floor(diff / 60000);
      const hours = Math.floor(diff / 3600000);
      const days  = Math.floor(diff / 86400000);
      if (mins < 2)        subText = 'Just now';
      else if (mins < 60)  subText = `${mins}m ago`;
      else if (hours < 24) subText = `${hours}h ago`;
      else                 subText = `${days}d ago`;
    }

    const color = p.color || '#4cff91';
    const typingHtml = isTyping ? `
      <div style="display:flex;align-items:center;gap:3px;margin-top:2px;">
        <span style="font-size:10px;color:${color};font-style:italic;">typing</span>
        <span style="display:flex;gap:2px;align-items:center;">
          <span style="width:4px;height:4px;border-radius:50%;background:${color};display:inline-block;animation:typing-bounce 1.2s infinite;"></span>
          <span style="width:4px;height:4px;border-radius:50%;background:${color};display:inline-block;animation:typing-bounce 1.2s infinite;animation-delay:0.2s;"></span>
          <span style="width:4px;height:4px;border-radius:50%;background:${color};display:inline-block;animation:typing-bounce 1.2s infinite;animation-delay:0.4s;"></span>
        </span>
      </div>` : '';

    const statusLine   = (!isTyping && p.status)  ? `<div class="presence-status-text">${escI(p.status)}</div>` : '';
    const lastSeenLine = (!isTyping && subText)    ? `<div class="presence-status-text">${subText}</div>` : '';

    return `
      <div class="presence-dot ${isOnline ? 'online' : ''}">
        <div class="dot" style="${isOnline ? 'background:' + color : ''}"></div>
        <div>
          <span style="${isOnline ? 'color:' + color : ''}">${escI(p.name || '?')}</span>
          ${typingHtml}
          ${statusLine}
          ${lastSeenLine}
        </div>
      </div>`;
  }).join('');
}

/* ══════════════════════════════════════
   TYPING INDICATOR
══════════════════════════════════════ */
function handleChatTyping() {
  if (!currentUserProfile) return;
  db.ref('chatTyping/' + currentUserProfile.uid).set({
    name: currentUserProfile.name, ts: Date.now()
  });
  clearTimeout(typingTimer);
  typingTimer = setTimeout(() => {
    db.ref('chatTyping/' + currentUserProfile.uid).remove();
  }, 3000);
}

function renderTypingIndicator(snap) {
  const data      = snap.val() || {};
  const indicator = document.getElementById('chat-typing-indicator');
  const textEl    = document.getElementById('chat-typing-text');

  // Update the typing UIDs cache so presence row can show dots
  _typingUids = {};
  Object.entries(data).forEach(([uid, v]) => { _typingUids[uid] = true; });

  // Re-render presence row to show/hide typing dots
  db.ref('presence').once('value', renderPresence);

  if (!indicator || !textEl) return;
  const others = Object.entries(data)
    .filter(([uid]) => uid !== currentUserProfile?.uid)
    .map(([, v]) => v.name);
  if (!others.length) {
    indicator.classList.remove('visible');
  } else {
    textEl.textContent = others.length === 1
      ? `${others[0]} is typing...`
      : `${others.join(' & ')} are typing...`;
    indicator.classList.add('visible');
  }
}

/* ══════════════════════════════════════
   AUTO-GROW TEXTAREA
══════════════════════════════════════ */
function autogrowChatInput(el) {
  el.style.height = 'auto';
  el.style.height = Math.min(el.scrollHeight, 110) + 'px';
}

/* ══════════════════════════════════════
   DATE HELPERS
══════════════════════════════════════ */
function getChatDateLabel(ts) {
  const d         = new Date(ts);
  const today     = new Date();
  const yesterday = new Date();
  yesterday.setDate(today.getDate() - 1);
  const same = (a, b) =>
    a.getFullYear() === b.getFullYear() &&
    a.getMonth()    === b.getMonth()    &&
    a.getDate()     === b.getDate();
  if (same(d, today))     return 'Today';
  if (same(d, yesterday)) return 'Yesterday';
  return d.toLocaleDateString('en-CA', { month: 'long', day: 'numeric', year: 'numeric' });
}

/* ══════════════════════════════════════
   AVATAR HELPER
══════════════════════════════════════ */
function buildAvatarHtml(uid, name, color, avatarUrl) {
  const initial = (name || '?')[0].toUpperCase();
  const bg      = color || '#e8ff4a';
  if (avatarUrl) {
    return `<div class="chat-avatar"><img src="${avatarUrl}" alt="${escI(name)}"></div>`;
  }
  return `<div class="chat-avatar" style="background:${bg};color:#000;">${initial}</div>`;
}

/* ══════════════════════════════════════
   FILE HELPERS
══════════════════════════════════════ */
function getFileIcon(fileName) {
  const ext = (fileName || '').split('.').pop().toLowerCase();
  if (ext === 'pdf')                               return '📄';
  if (['jpg','jpeg','png','gif','webp'].includes(ext)) return '🖼';
  if (['xlsx','xls','csv'].includes(ext))          return '📊';
  if (['docx','doc'].includes(ext))                return '📝';
  if (['zip','rar'].includes(ext))                 return '🗜';
  return '📎';
}

function formatFileSize(base64) {
  const bytes = Math.round(base64.length * 0.75);
  if (bytes < 1024)    return bytes + ' B';
  if (bytes < 1048576) return (bytes / 1024).toFixed(1) + ' KB';
  return (bytes / 1048576).toFixed(1) + ' MB';
}

/* ══════════════════════════════════════
   RENDER MESSAGES
══════════════════════════════════════ */
function renderChatMessages(data) {
  const container = document.getElementById('chat-messages');
  if (!container) return;

  const entries = Object.entries(data).sort((a, b) => (a[1].ts || 0) - (b[1].ts || 0));

  if (!entries.length) {
    container.innerHTML = `<div style="text-align:center;color:var(--text-3);font-size:12px;padding:40px 16px;">No messages yet.<br>Say hi! 👋</div>`;
    return;
  }

  const wasAtBottom = container.scrollHeight - container.scrollTop - container.clientHeight < 80;
  const myUid       = currentUserProfile?.uid;
  const isAdmin     = currentUserProfile?.role === 'admin';
  const fs          = localStorage.getItem('chat_font_size') || '13';

  let html           = '';
  let lastDateLabel  = '';
  let unreadInserted = false;

  entries.forEach(([key, m]) => {
    const mine      = m.uid === myUid;
    const profile   = chatProfiles[m.uid] || {};
    const avatarUrl = profile.avatar || m.avatar || null;
    const color     = m.color || profile.color || '#e8ff4a';
    const name      = m.name  || profile.name  || '?';
    const time      = m.ts
      ? new Date(m.ts).toLocaleTimeString('en-CA', { hour: '2-digit', minute: '2-digit' })
      : '';

    // Date divider
    const dateLabel = m.ts ? getChatDateLabel(m.ts) : '';
    if (dateLabel && dateLabel !== lastDateLabel) {
      html += `<div class="chat-date-divider">${dateLabel}</div>`;
      lastDateLabel = dateLabel;
    }

    // Unread divider
    if (!unreadInserted && !mine && m.ts && m.ts > chatLastSeen && !chatOpen) {
      html += `<div class="chat-unread-divider">New Messages</div>`;
      unreadInserted = true;
    }

    // File / image
    let fileHtml = '';
    if (m.fileUrl) {
      const ext     = (m.fileName || '').split('.').pop().toLowerCase();
      const isImage = ['jpg','jpeg','png','gif','webp'].includes(ext)
        || m.fileUrl.startsWith('data:image');

      if (isImage) {
        fileHtml = `
          <img src="${m.fileUrl}"
            alt="${escI(m.fileName || 'Image')}"
            onclick="openChatImageViewer(this.src)"
            style="max-width:210px;max-height:240px;width:100%;object-fit:cover;border-radius:12px;border:1px solid var(--border);display:block;margin-top:4px;cursor:zoom-in;transition:opacity 0.2s;"
            onmouseover="this.style.opacity='0.85'"
            onmouseout="this.style.opacity='1'">`;
      } else {
        const icon     = getFileIcon(m.fileName);
        const size     = formatFileSize(m.fileUrl);
        const safeUrl  = encodeURIComponent(m.fileUrl);
        const safeName = encodeURIComponent(m.fileName || 'Attachment');
        fileHtml = `
          <div class="chat-file-card" onclick="openChatFileViewer('${safeUrl}','${safeName}')">
            <div class="chat-file-icon">${icon}</div>
            <div class="chat-file-info">
              <div class="chat-file-name">${escI(m.fileName || 'Attachment')}</div>
              <div class="chat-file-size">${size} — tap to view</div>
            </div>
          </div>`;
      }
    }

    // Reactions
    const reactions  = m.reactions || {};
    let reactionsHtml = '';
    if (Object.keys(reactions).length) {
      const totals = {};
      const myReacts = {};
      Object.entries(reactions).forEach(([uid, emoji]) => {
        totals[emoji] = (totals[emoji] || 0) + 1;
        if (uid === myUid) myReacts[emoji] = true;
      });
      reactionsHtml = `<div class="chat-reactions">` +
        Object.entries(totals).map(([emoji, count]) => `
          <div class="chat-reaction-pill ${myReacts[emoji] ? 'mine' : ''}"
            onclick="toggleReaction('${key}','${emoji}')">
            ${emoji}<span class="chat-reaction-count">${count}</span>
          </div>`).join('') +
        `</div>`;
    }

    const avatarHtml  = buildAvatarHtml(m.uid, name, color, avatarUrl);
    const isPinned    = key === pinnedMessageKey;

    html += `
      <div class="chat-msg-row ${mine ? 'mine' : 'theirs'}" id="cmsg-${key}"
        data-key="${key}"
        oncontextmenu="openEmojiPicker(event,'${key}');return false;"
        ontouchstart="handleMsgTouchStart(event,'${key}')"
        ontouchend="handleMsgTouchEnd()"
        style="${isPinned ? 'outline:1px solid rgba(232,255,74,0.4);border-radius:12px;' : ''}">
        ${avatarHtml}
        <div class="chat-msg" style="font-size:${fs}px;">
          ${!mine ? `<div class="chat-msg-name" style="color:${color};">${escI(name)}</div>` : ''}
          ${m.text ? `<div class="chat-msg-bubble">${escI(m.text)}</div>` : ''}
          ${fileHtml}
          ${reactionsHtml}
          <div class="chat-msg-footer">
            <div class="chat-msg-time">${time}</div>
            <button class="chat-pin-msg-btn"
              onclick="pinMessage('${key}','${escI(m.text || 'Attachment')}')"
              title="Pin">📌</button>
            ${isAdmin ? `<button class="chat-delete-btn" onclick="deleteChatMessage('${key}')" title="Delete">🗑</button>` : ''}
          </div>
        </div>
      </div>`;
  });

  container.innerHTML = html;

  // Unread badge
  if (!chatOpen) {
    const newOnes = entries.filter(([, m]) => m.uid !== myUid && m.ts > chatLastSeen);
    if (newOnes.length) {
      chatUnread = newOnes.length;
      const badge = document.getElementById('chat-fab-badge');
      badge.textContent = chatUnread > 9 ? '9+' : String(chatUnread);
      badge.classList.add('visible');
      playChatSound();
    }
  }

  if (wasAtBottom || chatOpen) container.scrollTop = container.scrollHeight;
}

/* ══════════════════════════════════════
   SEND MESSAGE
══════════════════════════════════════ */
async function sendChatMessage() {
  if (!currentUserProfile) return;
  const input = document.getElementById('chat-input');
  const text  = input.value.trim();
  if (!text) return;
  input.value = '';
  input.style.height = '';
  db.ref('chatTyping/' + currentUserProfile.uid).remove();
  clearTimeout(typingTimer);

  await db.ref('familyChat').push({
    uid:    currentUserProfile.uid,
    name:   currentUserProfile.name,
    color:  currentUserProfile.color  || null,
    avatar: currentUserProfile.avatar || null,
    text,
    ts:     Date.now()
  });
}

/* ══════════════════════════════════════
   FILE ATTACHMENT
══════════════════════════════════════ */
async function handleChatFile(input) {
  if (!input.files.length || !currentUserProfile) return;
  const file   = input.files[0];
  input.value  = '';
  const reader = new FileReader();
  reader.onload = async (e) => {
    await db.ref('familyChat').push({
      uid:      currentUserProfile.uid,
      name:     currentUserProfile.name,
      color:    currentUserProfile.color  || null,
      avatar:   currentUserProfile.avatar || null,
      text:     '',
      fileUrl:  e.target.result,
      fileName: file.name,
      ts:       Date.now()
    });
    showToast('📎 File sent!');
  };
  reader.readAsDataURL(file);
}

/* ══════════════════════════════════════
   EMOJI REACTIONS
══════════════════════════════════════ */
let longPressTimer = null;

function handleMsgTouchStart(e, key) {
  longPressTimer = setTimeout(() => openEmojiPicker(e, key), 550);
}
function handleMsgTouchEnd() {
  clearTimeout(longPressTimer);
}

function openEmojiPicker(e, key) {
  if (typeof e.preventDefault === 'function') e.preventDefault();
  closeEmojiPicker();
  emojiPickerOpenKey = key;

  const row = document.getElementById('cmsg-' + key);
  if (!row) return;

  const picker = document.createElement('div');
  picker.className = 'chat-emoji-picker';
  picker.id = 'active-emoji-picker';
  picker.innerHTML = EMOJI_OPTIONS.map(em =>
    `<div class="chat-emoji-option" onclick="toggleReaction('${key}','${em}');closeEmojiPicker();">${em}</div>`
  ).join('');

  row.style.position = 'relative';
  row.appendChild(picker);

  setTimeout(() => {
    document.addEventListener('click', closeEmojiPickerOutside);
  }, 50);
}

function closeEmojiPickerOutside(e) {
  const picker = document.getElementById('active-emoji-picker');
  if (picker && !picker.contains(e.target)) closeEmojiPicker();
}

function closeEmojiPicker() {
  const picker = document.getElementById('active-emoji-picker');
  if (picker) picker.remove();
  emojiPickerOpenKey = null;
  document.removeEventListener('click', closeEmojiPickerOutside);
}

async function toggleReaction(key, emoji) {
  if (!currentUserProfile) return;
  const uid     = currentUserProfile.uid;
  const ref     = db.ref(`familyChat/${key}/reactions/${uid}`);
  const snap    = await ref.once('value');
  const current = snap.val();
  if (current === emoji) {
    await ref.remove();
  } else {
    await ref.set(emoji);
  }
}

/* ══════════════════════════════════════
   PIN MESSAGE
══════════════════════════════════════ */
async function pinMessage(key, text) {
  pinnedMessageKey = key; // set immediately so next render picks it up
  await db.ref('chatPinned').set({ key, text, pinnedBy: currentUserProfile?.uid, ts: Date.now() });
  showToast('📌 Pinned — tap the bar to jump to it.');
  // Scroll to it right away
  setTimeout(() => scrollToPinnedMessage(), 200);
}

async function unpinMessage() {
  await db.ref('chatPinned').remove();
  showToast('📌 Message unpinned.');
}

function showPinBar(text) {
  const bar  = document.getElementById('chat-pin-bar');
  const textEl = document.getElementById('chat-pin-text');
  if (bar) bar.classList.add('visible');
  if (textEl) textEl.textContent = text;
}

function hidePinBar() {
  const bar = document.getElementById('chat-pin-bar');
  if (bar) bar.classList.remove('visible');
}

function scrollToPinnedMessage() {
  if (!pinnedMessageKey) return;
  const el = document.getElementById('cmsg-' + pinnedMessageKey);
  if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
}

/* ══════════════════════════════════════
   MESSAGE SEARCH
══════════════════════════════════════ */
function toggleChatSearch() {
  const bar = document.getElementById('chat-search-bar');
  const btn = document.getElementById('chat-search-toggle-btn');
  chatSearchActive = !chatSearchActive;
  bar.classList.toggle('open', chatSearchActive);
  btn.classList.toggle('active', chatSearchActive);
  if (chatSearchActive) {
    document.getElementById('chat-search-input')?.focus();
  } else {
    closeChatSearch();
  }
}

function closeChatSearch() {
  chatSearchActive = false;
  chatSearchResults = [];
  chatSearchIndex   = 0;
  const bar = document.getElementById('chat-search-bar');
  const btn = document.getElementById('chat-search-toggle-btn');
  if (bar) bar.classList.remove('open');
  if (btn) btn.classList.remove('active');
  // Remove highlights
  document.querySelectorAll('.chat-msg-row.search-match').forEach(el => {
    el.classList.remove('search-match');
  });
  document.querySelectorAll('.chat-search-highlight').forEach(el => {
    const parent = el.parentNode;
    parent.replaceChild(document.createTextNode(el.textContent), el);
    parent.normalize();
  });
}

function handleChatSearch(query) {
  const q = (query || '').trim().toLowerCase();
  const countEl = document.getElementById('chat-search-count');

  document.querySelectorAll('.chat-msg-row.search-match').forEach(el => el.classList.remove('search-match'));

  if (!q) {
    chatSearchResults = [];
    if (countEl) countEl.textContent = '0/0';
    return;
  }

  // Sort messages by timestamp so results are in order
  chatSearchResults = Object.entries(chatAllMessages)
    .sort((a, b) => (a[1].ts || 0) - (b[1].ts || 0))
    .filter(([, m]) => (m.text || '').toLowerCase().includes(q))
    .map(([key]) => key);

  chatSearchIndex = 0;
  if (countEl) countEl.textContent = chatSearchResults.length
    ? `1/${chatSearchResults.length}`
    : '0/0';

  if (chatSearchResults.length) highlightSearchResult(0);
}

function chatSearchNav(dir) {
  if (!chatSearchResults.length) return;
  chatSearchIndex = (chatSearchIndex + dir + chatSearchResults.length) % chatSearchResults.length;
  const countEl = document.getElementById('chat-search-count');
  if (countEl) countEl.textContent = `${chatSearchIndex + 1}/${chatSearchResults.length}`;
  highlightSearchResult(chatSearchIndex);
}

function highlightSearchResult(idx) {
  document.querySelectorAll('.chat-msg-row.search-match').forEach(el => el.classList.remove('search-match'));
  const key = chatSearchResults[idx];
  if (!key) return;
  const el = document.getElementById('cmsg-' + key);
  if (el) {
    el.classList.add('search-match');
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}

/* ══════════════════════════════════════
   NOTIFICATION SOUND (Web Audio API)
══════════════════════════════════════ */
function playChatSound() {
  const prefs = JSON.parse(localStorage.getItem('chat_sound') || '{}');
  if (!prefs.enabled) return;
  if (isDndActive()) return;

  try {
    const ctx  = new (window.AudioContext || window.webkitAudioContext)();
    const tone = prefs.tone || 'ping';
    const osc  = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.connect(gain);
    gain.connect(ctx.destination);

    const tones = {
      ping:  [{ f: 880, t: 0, d: 0.15 }],
      chime: [{ f: 523, t: 0, d: 0.2 }, { f: 659, t: 0.1, d: 0.2 }, { f: 784, t: 0.2, d: 0.3 }],
      pop:   [{ f: 300, t: 0, d: 0.08 }],
      bell:  [{ f: 440, t: 0, d: 0.1 }, { f: 880, t: 0.08, d: 0.4 }]
    };

    const notes = tones[tone] || tones.ping;
    notes.forEach(({ f, t, d }) => {
      const o2  = ctx.createOscillator();
      const g2  = ctx.createGain();
      o2.connect(g2);
      g2.connect(ctx.destination);
      o2.frequency.value = f;
      o2.type = tone === 'pop' ? 'sine' : 'sine';
      g2.gain.setValueAtTime(0.3, ctx.currentTime + t);
      g2.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + t + d);
      o2.start(ctx.currentTime + t);
      o2.stop(ctx.currentTime + t + d + 0.05);
    });
  } catch (e) {
    console.warn('Audio play failed:', e);
  }
}

function previewTone(tone) {
  const prefs = JSON.parse(localStorage.getItem('chat_sound') || '{}');
  prefs.tone = tone;
  localStorage.setItem('chat_sound', JSON.stringify(prefs));
  // Play preview regardless of enabled state so user can hear the tone
  try {
    const ctx   = new (window.AudioContext || window.webkitAudioContext)();
    const tones = {
      ping:  [{ f: 880, t: 0, d: 0.15 }],
      chime: [{ f: 523, t: 0, d: 0.2 }, { f: 659, t: 0.1, d: 0.2 }, { f: 784, t: 0.2, d: 0.3 }],
      pop:   [{ f: 300, t: 0, d: 0.08 }],
      bell:  [{ f: 440, t: 0, d: 0.1 }, { f: 880, t: 0.08, d: 0.4 }]
    };
    (tones[tone] || tones.ping).forEach(({ f, t, d }) => {
      const o = ctx.createOscillator();
      const g = ctx.createGain();
      o.connect(g); g.connect(ctx.destination);
      o.frequency.value = f;
      g.gain.setValueAtTime(0.3, ctx.currentTime + t);
      g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + t + d);
      o.start(ctx.currentTime + t);
      o.stop(ctx.currentTime + t + d + 0.05);
    });
  } catch(e) { console.warn('Preview tone failed:', e); }
}

function saveNotifSettings() {
  const enabled   = document.getElementById('toggle-sound')?.checked;
  const tone      = document.getElementById('sound-tone-select')?.value || 'ping';
  localStorage.setItem('chat_sound', JSON.stringify({ enabled, tone }));
  const pickerRow = document.getElementById('sound-picker-row');
  if (pickerRow) pickerRow.style.display = enabled ? 'flex' : 'none';
  // Play a preview immediately on toggle so the user confirms it works
  // and the AudioContext gets unlocked by this gesture
  if (enabled) previewTone(tone);
}

/* ══════════════════════════════════════
   DO NOT DISTURB
══════════════════════════════════════ */
function isDndActive() {
  const dnd = JSON.parse(localStorage.getItem('chat_dnd') || '{}');
  if (!dnd.enabled) return false;
  const now   = new Date();
  const cur   = now.getHours() * 60 + now.getMinutes();
  const [sh, sm] = (dnd.start || '22:00').split(':').map(Number);
  const [eh, em] = (dnd.end   || '08:00').split(':').map(Number);
  const start = sh * 60 + sm;
  const end   = eh * 60 + em;
  if (start > end) return cur >= start || cur < end;
  return cur >= start && cur < end;
}

function saveDndSettings() {
  const enabled = document.getElementById('toggle-dnd')?.checked;
  const start   = document.getElementById('dnd-start')?.value || '22:00';
  const end     = document.getElementById('dnd-end')?.value   || '08:00';
  localStorage.setItem('chat_dnd', JSON.stringify({ enabled, start, end }));
  const row = document.getElementById('dnd-time-row');
  if (row) row.style.display = enabled ? 'flex' : 'none';
}

/* ══════════════════════════════════════
   PRIVACY
══════════════════════════════════════ */
function savePrivacySettings() {
  const show = document.getElementById('toggle-lastseen')?.checked;
  if (!currentUserProfile) return;
  currentUserProfile.showLastSeen = show;
  db.ref('users/' + currentUserProfile.uid).update({ showLastSeen: show });
  if (presenceRef) presenceRef.update({ showLastSeen: show });
}

/* ══════════════════════════════════════
   FONT SIZE
══════════════════════════════════════ */
function applyChatFontSize(size, silent = false) {
  size = String(size);
  localStorage.setItem('chat_font_size', size);
  const label  = document.getElementById('font-size-chat-label');
  const slider = document.getElementById('chat-font-slider');
  if (label)  label.textContent = size + 'px';
  if (slider) slider.value      = size;
  // Apply to all bubbles live
  document.querySelectorAll('.chat-msg').forEach(el => {
    el.style.fontSize = size + 'px';
  });
  // Also set on the messages container as a CSS var fallback
  const msgs = document.getElementById('chat-messages');
  if (msgs) msgs.style.setProperty('--chat-fs', size + 'px');
}

/* ══════════════════════════════════════
   WALLPAPER
══════════════════════════════════════ */
function selectWallpaper(el, wp) {
  document.querySelectorAll('.wallpaper-option').forEach(o => o.classList.remove('selected'));
  el.classList.add('selected');
  applyChatWallpaper(wp);
}

function applyChatWallpaper(wp, silent = false) {
  localStorage.setItem('chat_wallpaper', wp);
  const msgs = document.getElementById('chat-messages');
  if (!msgs) return;

  msgs.className = 'chat-messages';
  msgs.style.background = '';

  if (wp === 'none') return;
  if (wp.startsWith('solid-')) {
    msgs.style.background = WALLPAPER_SOLID_BG[wp] || '';
  } else {
    msgs.classList.add('wp-' + wp);
  }

  if (!silent) {
    const opt = document.querySelector(`.wallpaper-option[data-wp="${wp}"]`);
    if (opt) {
      document.querySelectorAll('.wallpaper-option').forEach(o => o.classList.remove('selected'));
      opt.classList.add('selected');
    }
  }
}

/* ══════════════════════════════════════
   QUICK REPLIES
══════════════════════════════════════ */
function getQuickReplies() {
  return JSON.parse(localStorage.getItem('chat_quick_replies') || '[]');
}

function saveQuickReplies(list) {
  localStorage.setItem('chat_quick_replies', JSON.stringify(list));
  renderQuickReplies();
  renderQuickReplyList();
}

function renderQuickReplies() {
  const bar     = document.getElementById('chat-quick-replies');
  if (!bar) return;
  const replies = getQuickReplies().filter(r => r.trim());
  if (!replies.length) { bar.classList.remove('visible'); return; }
  bar.classList.add('visible');
  bar.innerHTML = replies.map(r => `
    <div class="quick-reply-pill" onclick="useQuickReply('${escI(r)}')">${escI(r)}</div>
  `).join('');
}

function useQuickReply(text) {
  const input = document.getElementById('chat-input');
  if (input) { input.value = text; input.focus(); }
}

function renderQuickReplyList() {
  const container = document.getElementById('quick-reply-list');
  if (!container) return;
  const replies = getQuickReplies();
  container.innerHTML = replies.map((r, i) => `
    <div class="quick-reply-item">
      <input type="text" value="${escI(r)}" placeholder="Quick reply text..."
        oninput="updateQuickReply(${i}, this.value)">
      <button class="quick-reply-del" onclick="removeQuickReply(${i})">✕</button>
    </div>
  `).join('');
}

function addQuickReply() {
  const list = getQuickReplies();
  if (list.length >= 6) { showToast('Max 6 quick replies.'); return; }
  list.push('');
  saveQuickReplies(list);
}

function updateQuickReply(i, val) {
  const list = getQuickReplies();
  list[i] = val;
  localStorage.setItem('chat_quick_replies', JSON.stringify(list));
  renderQuickReplies();
}

function removeQuickReply(i) {
  const list = getQuickReplies();
  list.splice(i, 1);
  saveQuickReplies(list);
}

/* ══════════════════════════════════════
   ADMIN: DELETE ALL HISTORY
══════════════════════════════════════ */
async function clearChatHistory() {
  if (!can('clearChatHistory')) return;
  if (currentUserProfile?.role !== 'admin') {
    showToast('⚠️ Admin only.');
    return;
  }
  if (!confirm('Delete ALL chat history? This cannot be undone.')) return;
  if (!confirm('Are you sure? Every message will be permanently deleted.')) return;
  await db.ref('familyChat').remove();
  await db.ref('chatPinned').remove();
  showToast('🗑 Chat history cleared.');
}

/* ══════════════════════════════════════
   ADMIN: DELETE ONE MESSAGE
══════════════════════════════════════ */
async function deleteChatMessage(key) {
  if (!can('deleteChatMessages')) return;
  if (!confirm('Delete this message?')) return;
  await db.ref('familyChat/' + key).remove();
  showToast('Message deleted.');
}

/* ══════════════════════════════════════
   CHANGE PASSWORD
══════════════════════════════════════ */
async function changePassword() {
  const current  = document.getElementById('pw-current')?.value.trim();
  const newPw    = document.getElementById('pw-new')?.value.trim();
  const confirm  = document.getElementById('pw-confirm')?.value.trim();

  if (!current || !newPw || !confirm) {
    showToast('⚠️ Fill in all password fields.');
    return;
  }
  if (newPw !== confirm) {
    showToast('⚠️ New passwords do not match.');
    return;
  }
  if (newPw.length < 6) {
    showToast('⚠️ Password must be at least 6 characters.');
    return;
  }

  try {
    const user       = firebase.auth().currentUser;
    const credential = firebase.auth.EmailAuthProvider.credential(user.email, current);
    await firebase.auth().currentUser.reauthenticateWithCredential(credential);
    await firebase.auth().currentUser.updatePassword(newPw);
    document.getElementById('pw-current').value = '';
    document.getElementById('pw-new').value     = '';
    document.getElementById('pw-confirm').value = '';
    showToast('✓ Password updated successfully.');
  } catch (e) {
    console.error(e);
    if (e.code === 'auth/wrong-password') {
      showToast('⚠️ Current password is incorrect.');
    } else {
      showToast('⚠️ Password update failed. Try again.');
    }
  }
}

/* ══════════════════════════════════════
   CHAT STATISTICS
══════════════════════════════════════ */
async function loadChatStats() {
  const snap  = await db.ref('familyChat').once('value');
  const data  = snap.val() || {};
  const msgs  = Object.values(data);
  const myUid = currentUserProfile?.uid;

  const total  = msgs.length;
  const mine   = msgs.filter(m => m.uid === myUid).length;
  const files  = msgs.filter(m => m.fileUrl).length;

  const days = new Set(
    msgs.filter(m => m.ts).map(m => new Date(m.ts).toDateString())
  ).size;

  const firstTs   = msgs.reduce((min, m) => m.ts && m.ts < min ? m.ts : min, Infinity);
  const firstDate = isFinite(firstTs)
    ? new Date(firstTs).toLocaleDateString('en-CA', { month: 'long', day: 'numeric', year: 'numeric' })
    : '—';

  document.getElementById('stat-total').textContent = total;
  document.getElementById('stat-mine').textContent  = mine;
  document.getElementById('stat-files').textContent = files;
  document.getElementById('stat-days').textContent  = days;
  document.getElementById('stat-first-msg').textContent = firstTs
    ? `First message: ${firstDate}`
    : '';
}

/* ══════════════════════════════════════
   PROFILE PANEL OPEN / CLOSE
══════════════════════════════════════ */
function openProfileModal() {
  document.getElementById('profile-modal').style.display = 'flex';
  document.getElementById('profile-modal-overlay').style.display = 'block';
  if (!currentUserProfile) return;

  // Populate fields
  document.getElementById('modal-name-input').value   = currentUserProfile.name   || '';
  document.getElementById('profile-status-input').value = currentUserProfile.status || '';

  const badge = document.getElementById('profile-role-badge');
  badge.textContent = currentUserProfile.role === 'admin' ? 'Admin' : 'Staff';
  badge.className   = 'profile-role-badge ' + (currentUserProfile.role === 'admin' ? 'admin' : 'staff');

  refreshProfileAvatar();

  selectedColor = currentUserProfile.color || '#e8ff4a';
  document.querySelectorAll('.color-swatch').forEach(s => {
    s.classList.toggle('selected', s.dataset.color === selectedColor);
  });

  const sound     = JSON.parse(localStorage.getItem('chat_sound') || '{}');
  const soundEl   = document.getElementById('toggle-sound');
  const toneEl    = document.getElementById('sound-tone-select');
  const soundRow  = document.getElementById('sound-picker-row');
  if (soundEl)  soundEl.checked  = !!sound.enabled;
  if (toneEl && sound.tone) toneEl.value = sound.tone;
  if (soundRow) soundRow.style.display = sound.enabled ? 'flex' : 'none';

  const dnd      = JSON.parse(localStorage.getItem('chat_dnd') || '{}');
  const dndEl    = document.getElementById('toggle-dnd');
  const dndRow   = document.getElementById('dnd-time-row');
  const dndStart = document.getElementById('dnd-start');
  const dndEnd   = document.getElementById('dnd-end');
  if (dndEl)    dndEl.checked = !!dnd.enabled;
  if (dndRow)   dndRow.style.display = dnd.enabled ? 'flex' : 'none';
  if (dndStart && dnd.start) dndStart.value = dnd.start;
  if (dndEnd   && dnd.end)   dndEnd.value   = dnd.end;

  const lsEl = document.getElementById('toggle-lastseen');
  if (lsEl) lsEl.checked = currentUserProfile.showLastSeen !== false;

  const fs     = localStorage.getItem('chat_font_size') || '13';
  const slider = document.getElementById('chat-font-slider');
  const label  = document.getElementById('font-size-chat-label');
  if (slider) slider.value      = fs;
  if (label)  label.textContent = fs + 'px';

  const wp  = localStorage.getItem('chat_wallpaper') || 'none';
  document.querySelectorAll('.wallpaper-option').forEach(o => o.classList.remove('selected'));
  const wpOpt = document.querySelector(`.wallpaper-option[data-wp="${wp}"]`);
  if (wpOpt) wpOpt.classList.add('selected');

  renderQuickReplyList();

  const danger = document.getElementById('danger-zone-card');
  if (danger) danger.style.display = currentUserProfile.role === 'admin' ? 'block' : 'none';

  // Show/hide staff management section
  const staffSection = document.getElementById('staff-management-section');
  if (staffSection) {
    staffSection.style.display = currentUserProfile.role === 'admin' ? 'block' : 'none';
    if (currentUserProfile.role === 'admin') loadStaffManagement();
  }

  loadChatStats();
}

function closeProfileModal() {
  document.getElementById('profile-modal').style.display = 'none';
  document.getElementById('profile-modal-overlay').style.display = 'none';
}

function openChatProfile() {
  if (!currentUserProfile) return;
  document.getElementById('chat-profile-view').classList.add('open');

  // Populate fields
  document.getElementById('modal-name-input').value   = currentUserProfile.name   || '';
  document.getElementById('profile-status-input').value = currentUserProfile.status || '';

  const badge = document.getElementById('profile-role-badge');
  badge.textContent = currentUserProfile.role === 'admin' ? 'Admin' : 'Staff';
  badge.className   = 'profile-role-badge ' + (currentUserProfile.role === 'admin' ? 'admin' : 'staff');

  refreshProfileAvatar();

  // Color swatches
  selectedColor = currentUserProfile.color || '#e8ff4a';
  document.querySelectorAll('.color-swatch').forEach(s => {
    s.classList.toggle('selected', s.dataset.color === selectedColor);
  });

  // Restore notification toggles
  const sound = JSON.parse(localStorage.getItem('chat_sound') || '{}');
  const soundToggle = document.getElementById('toggle-sound');
  const toneSelect  = document.getElementById('sound-tone-select');
  const soundRow    = document.getElementById('sound-picker-row');
  if (soundToggle) soundToggle.checked = !!sound.enabled;
  if (toneSelect && sound.tone) toneSelect.value = sound.tone;
  if (soundRow) soundRow.style.display = sound.enabled ? 'flex' : 'none';

  // DND
  const dnd = JSON.parse(localStorage.getItem('chat_dnd') || '{}');
  const dndToggle = document.getElementById('toggle-dnd');
  const dndRow    = document.getElementById('dnd-time-row');
  const dndStart  = document.getElementById('dnd-start');
  const dndEnd    = document.getElementById('dnd-end');
  if (dndToggle) dndToggle.checked = !!dnd.enabled;
  if (dndRow)    dndRow.style.display = dnd.enabled ? 'flex' : 'none';
  if (dndStart && dnd.start) dndStart.value = dnd.start;
  if (dndEnd   && dnd.end)   dndEnd.value   = dnd.end;

  // Last seen
  const lsToggle = document.getElementById('toggle-lastseen');
  if (lsToggle) lsToggle.checked = currentUserProfile.showLastSeen !== false;

  // Font size
  const fs     = localStorage.getItem('chat_font_size') || '13';
  const slider = document.getElementById('chat-font-slider');
  const label  = document.getElementById('font-size-chat-label');
  if (slider) slider.value      = fs;
  if (label)  label.textContent = fs + 'px';

  // Wallpaper
  const wp  = localStorage.getItem('chat_wallpaper') || 'none';
  const opt = document.querySelector(`.wallpaper-option[data-wp="${wp}"]`);
  if (opt) {
    document.querySelectorAll('.wallpaper-option').forEach(o => o.classList.remove('selected'));
    opt.classList.add('selected');
  }

  // Quick replies
  renderQuickReplyList();

  // Admin danger zone
  const danger = document.getElementById('danger-zone-card');
  if (danger) danger.style.display = (currentUserProfile?.role === 'admin') ? 'block' : 'none';
  console.log('Role check:', currentUserProfile?.role); // remove after confirming

  // Stats
  loadChatStats();
}

function closeChatProfile() {
  document.getElementById('chat-profile-view').classList.remove('open');
}

/* ══════════════════════════════════════
   AVATAR
══════════════════════════════════════ */
function refreshProfileAvatar() {
  // Update modal avatar elements
  const el      = document.getElementById('modal-avatar-large') || document.getElementById('profile-avatar-large');
  const initial = document.getElementById('modal-avatar-initial') || document.getElementById('profile-avatar-initial');
  const color   = currentUserProfile.color || '#e8ff4a';
  if (currentUserProfile.avatar) {
    el.style.background   = 'transparent';
    el.style.borderColor  = color;
    initial.innerHTML     = `<img src="${currentUserProfile.avatar}"
      style="width:100%;height:100%;object-fit:cover;border-radius:50%;">`;
  } else {
    el.style.background  = color;
    el.style.borderColor = color;
    initial.textContent  = (currentUserProfile.name || '?')[0].toUpperCase();
    initial.style.color  = '#000';
  }
}

function selectColor(el) {
  selectedColor = el.dataset.color;
  document.querySelectorAll('.color-swatch').forEach(s => s.classList.remove('selected'));
  el.classList.add('selected');
}

async function handleAvatarUpload(input) {
  if (!input.files.length) return;
  const reader = new FileReader();
  reader.onload = async (e) => {
    const compressed = await resizeImage(e.target.result, 200, 0.85);
    currentUserProfile.avatar = compressed;
    refreshProfileAvatar();
  };
  reader.readAsDataURL(input.files[0]);
}

/* ══════════════════════════════════════
   SAVE PROFILE
══════════════════════════════════════ */
async function saveProfile() {
  if (!currentUserProfile) return;
  const newName   = (document.getElementById('modal-name-input') || document.getElementById('profile-name-input'))?.value.trim();
  const newStatus = document.getElementById('profile-status-input')?.value.trim() || '';
  if (!newName) { showToast('⚠️ Name cannot be empty.'); return; }

  currentUserProfile.name   = newName;
  currentUserProfile.color  = selectedColor || currentUserProfile.color;
  currentUserProfile.status = newStatus;

  const update = {
    name:   currentUserProfile.name,
    color:  currentUserProfile.color,
    role:   currentUserProfile.role,
    status: currentUserProfile.status,
    showLastSeen: currentUserProfile.showLastSeen !== false
  };
  if (currentUserProfile.avatar) update.avatar = currentUserProfile.avatar;

  await db.ref('users/' + currentUserProfile.uid).update(update);
  if (presenceRef) presenceRef.update({
    name:   currentUserProfile.name,
    color:  currentUserProfile.color,
    avatar: currentUserProfile.avatar || null,
    status: currentUserProfile.status
  });

  showToast('✓ Profile saved!');
  closeChatProfile();
}

/* ══════════════════════════════════════
   IMAGE VIEWER
══════════════════════════════════════ */
function openChatImageViewer(src) {
  const viewer = document.getElementById('chat-image-viewer');
  const img    = document.getElementById('chat-image-viewer-img');
  if (!viewer || !img) return;
  img.src = src;
  viewer.style.display = 'flex';
  document.body.style.overflow = 'hidden';
}

function closeChatImageViewer() {
  const viewer = document.getElementById('chat-image-viewer');
  const img    = document.getElementById('chat-image-viewer-img');
  if (viewer) viewer.style.display = 'none';
  if (img)    img.src = '';
  document.body.style.overflow = '';
}

/* ══════════════════════════════════════
   FILE VIEWER
══════════════════════════════════════ */
function openChatFileViewer(safeUrl, safeName) {
  const url      = decodeURIComponent(safeUrl);
  const fileName = decodeURIComponent(safeName);
  const ext      = fileName.split('.').pop().toLowerCase();
  const viewer   = document.getElementById('chat-file-viewer');
  const body     = document.getElementById('chat-file-viewer-body');
  const nameEl   = document.getElementById('chat-file-viewer-name');
  const dlBtn    = document.getElementById('chat-file-download-btn');
  if (!viewer || !body) return;

  nameEl.textContent   = fileName;
  viewer.style.display = 'flex';
  document.body.style.overflow = 'hidden';

  dlBtn.onclick = () => {
    const a      = document.createElement('a');
    a.href       = url;
    a.download   = fileName;
    a.click();
  };

  if (ext === 'pdf') {
    body.innerHTML = `<iframe src="${url}" style="width:100%;height:100%;border:none;" type="application/pdf"></iframe>`;
  } else if (['xlsx','xls','csv','doc','docx'].includes(ext)) {
    body.innerHTML = `
      <div style="text-align:center;color:#fff;padding:40px 24px;">
        <div style="font-size:48px;margin-bottom:16px;">📊</div>
        <div style="font-family:var(--font-head);font-weight:700;font-size:16px;margin-bottom:8px;">${fileName}</div>
        <div style="font-size:13px;color:rgba(255,255,255,0.5);">Use the Download button above to open this file.</div>
      </div>`;
  } else {
    body.innerHTML = `
      <div style="text-align:center;color:#fff;padding:40px 24px;">
        <div style="font-size:48px;margin-bottom:16px;">📎</div>
        <div style="font-family:var(--font-head);font-weight:700;font-size:16px;margin-bottom:8px;">${fileName}</div>
        <div style="font-size:13px;color:rgba(255,255,255,0.5);">Use the Download button above to open this file.</div>
      </div>`;
  }
}

function closeChatFileViewer() {
  const viewer = document.getElementById('chat-file-viewer');
  const body   = document.getElementById('chat-file-viewer-body');
  if (viewer) viewer.style.display = 'none';
  if (body)   body.innerHTML = '';
  document.body.style.overflow = '';
}


/* ══════════════════════════════════════
   LIVE PERMISSION ENFORCEMENT
   Called instantly when admin changes a staff member's permissions
══════════════════════════════════════ */
function applyLivePermissions() {
  if (!currentUserProfile) return;
  const isAdmin = currentUserProfile.role === 'admin';
  if (isAdmin) return; // admins are never affected

  // ── Chat access ──
  const chatFab   = document.getElementById('chat-fab');
  const chatPanel = document.getElementById('chat-panel');
  const chatOverlay = document.getElementById('chat-overlay');
  const hasChat = can('accessChat', true);
  if (chatFab) chatFab.style.display = hasChat ? '' : 'none';
  if (!hasChat && chatPanel && chatPanel.classList.contains('open')) {
    // Kick them out of the chat panel immediately
    chatPanel.classList.remove('open');
    if (chatOverlay) chatOverlay.classList.remove('open');
    chatOpen = false;
    showToast('🚫 Chat access has been disabled for your account.');
  }

  // ── Dashboard ──
  const dashContainer = document.getElementById('dashboard-content');
  if (dashContainer && !can('viewDashboard', true)) {
    dashContainer.innerHTML = '<div style="text-align:center;padding:32px;color:var(--text-3);"><div style="font-size:32px;margin-bottom:12px;">🚫</div><div style="font-family:var(--font-head);font-weight:700;">Access Restricted</div><div style="font-size:12px;margin-top:6px;">Dashboard access has been disabled for your account.</div></div>';
  }

  // ── PDF buttons ──
  const pdfBtn   = document.querySelector('button[onclick="exportPDF()"]');
  const shareBtn = document.querySelector('button[onclick="sharePDF()"]');
  const zipBtn   = document.querySelector('button[onclick="downloadAllAsZip()"]');
  const canPDF   = can('downloadPDF', true);
  const canZip   = can('downloadAllZip', true);
  if (pdfBtn)   { pdfBtn.style.opacity   = canPDF ? '' : '0.35'; pdfBtn.title   = canPDF ? '' : 'Access restricted'; }
  if (shareBtn) { shareBtn.style.opacity = canPDF ? '' : '0.35'; shareBtn.title = canPDF ? '' : 'Access restricted'; }
  if (zipBtn)   { zipBtn.style.opacity   = canZip ? '' : '0.35'; zipBtn.title   = canZip ? '' : 'Access restricted'; }

  // ── Paid toggle ──
  const paidBtn = document.getElementById('btn-paid-toggle');
  if (paidBtn) {
    const canPaid = can('markPaid', true);
    paidBtn.style.opacity = canPaid ? '' : '0.35';
    paidBtn.title = canPaid ? '' : 'Access restricted';
  }

  // ── Intake badge/button ──
  const intakeBtn = document.querySelector('button[onclick="openIntakeModal()"]');
  if (intakeBtn) {
    const canIntake = can('viewIntake', true);
    intakeBtn.style.opacity = canIntake ? '' : '0.35';
    intakeBtn.title = canIntake ? '' : 'Access restricted';
  }

  // ── Close intake modal if open and access removed ──
  if (!can('viewIntake', true)) {
    const intakeModal = document.getElementById('intake-modal');
    if (intakeModal && intakeModal.classList.contains('open')) {
      closeIntakeModal();
      showToast('🚫 Intake access has been disabled for your account.');
    }
  }

  // Re-render the saved documents list so edit/delete buttons appear/disappear live
  if (cachedDocsEntries.length) {
    applyDocsFilter();
  }
}

/* ═══════════════════════════════════════════════════════════
   PERMISSIONS SYSTEM
   Permissions stored in Firebase: users/{uid}/permissions
   Defaults: all true for admin, configurable for staff
═══════════════════════════════════════════════════════════ */

/* ═══════════════════════════════════════════════════════════
   DELIVERY MAP
═══════════════════════════════════════════════════════════ */
let deliveryMapInstance = null;
let deliveryMapFilter = 'alltime';
let deliveryMapPins = [];
let geocodeCache = {};

function setMapFilter(filter) {
  deliveryMapFilter = filter;
  document.getElementById('map-filter-alltime').style.background = filter === 'alltime' ? 'var(--accent)' : 'transparent';
  document.getElementById('map-filter-alltime').style.color = filter === 'alltime' ? '#000' : 'var(--text-3)';
  document.getElementById('map-filter-month').style.background = filter === 'month' ? 'var(--accent)' : 'transparent';
  document.getElementById('map-filter-month').style.color = filter === 'month' ? '#000' : 'var(--text-3)';
  renderDeliveryMapPins();
}

function shippingPinColor(shipping) {
  if (!shipping) return '#aaaaaa';
  const s = shipping.toLowerCase();
  if (s.includes('pickup'))  return '#4af0ff';
  if (s.includes('freight')) return '#ff6b4a';
  if (s.includes('parcel'))  return '#4aff8f';
  if (s.includes('ddu') || s.includes('usa')) return '#b44aff';
  if (s.includes('dap') || s.includes('delivered')) return '#e8ff4a';
  return '#aaaaaa';
}

function makeLeafletIcon(color) {
  return L.divIcon({
    className: '',
    html: `<div style="
      width:14px;height:14px;border-radius:50%;
      background:${color};
      border:2px solid rgba(0,0,0,0.4);
      box-shadow:0 0 6px ${color}88;
    "></div>`,
    iconSize: [14, 14],
    iconAnchor: [7, 7],
    popupAnchor: [0, -10]
  });
}

async function geocodeAddress(addressStr) {
  if (geocodeCache[addressStr]) return geocodeCache[addressStr];
  try {
    const res = await fetch(
      `https://nominatim.openstreetmap.org/search?format=json&limit=1&q=${encodeURIComponent(addressStr)}`,
      { headers: { 'Accept-Language': 'en' } }
    );
    const results = await res.json();
    if (results && results.length > 0) {
      const coords = { lat: parseFloat(results[0].lat), lng: parseFloat(results[0].lon) };
      geocodeCache[addressStr] = coords;
      return coords;
    }
  } catch(e) {}
  return null;
}

async function loadDeliveryMap() {
  const mapEl = document.getElementById('delivery-map');
  const pinList = document.getElementById('map-pin-list');
  const statsStrip = document.getElementById('map-stats-strip');
  if (!mapEl) return;

  // Init map once
  if (!deliveryMapInstance) {
    deliveryMapInstance = L.map('delivery-map', {
      center: [51.2538, -85.3232],
      zoom: 6
    });
    L.tileLayer('https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png', {
      attribution: '© OpenStreetMap contributors © CARTO',
      maxZoom: 19
    }).addTo(deliveryMapInstance);
  }

  pinList.innerHTML = '<div style="color:var(--text-3);font-size:12px;padding:8px 0;">Loading pins...</div>';
  statsStrip.innerHTML = '';
  deliveryMapPins = [];

  // Load from saved invoices
  const docsSnap = await db.ref('savedDocuments').once('value');
  const docs = docsSnap.val() || {};

  Object.entries(docs).forEach(([key, doc]) => {
    const cust = doc.customer || {};
    const addrParts = [cust.street, cust.city, cust.prov, cust.postal, cust.country].filter(Boolean);
    if (!addrParts.length || !cust.name) return;

    const shipping = doc.shipping || '';
    // Skip truly local pickups from invoice pins — they have no delivery address
    // but still include them if they have a real street address entered
    const addrStr = addrParts.join(', ');

    deliveryMapPins.push({
      source: 'invoice',
      key,
      name: cust.name,
      address: addrStr,
      invoiceId: doc.id || key,
      amount: doc.total || '',
      date: doc.date || '',
      shipping: shipping,
      color: shippingPinColor(shipping),
      coords: null
    });
  });

  // Load from calendar delivery events
  const calSnap = await db.ref('calendarEvents').once('value');
  const calByDate = calSnap.val() || {};

  Object.entries(calByDate).forEach(([dateKey, dayEvents]) => {
    if (!dayEvents || typeof dayEvents !== 'object') return;
    Object.entries(dayEvents).forEach(([eventId, evt]) => {
      if (!evt || !evt.type || !evt.type.toLowerCase().includes('delivery')) return;
      const addrStr = evt.address || '';
      if (!addrStr) return;

      deliveryMapPins.push({
        source: 'calendar',
        key: eventId,
        name: evt.customer || 'Delivery',
        address: addrStr,
        invoiceId: '—',
        amount: evt.price ? '$' + evt.price : '—',
        date: dateKey,
        shipping: 'DAP - Delivered at Place',
        color: shippingPinColor('dap'),
        coords: null
      });
    });
  });

  // Geocode all pins in parallel batches of 4
  const batchSize = 4;
  for (let i = 0; i < deliveryMapPins.length; i += batchSize) {
    const batch = deliveryMapPins.slice(i, i + batchSize);
    await Promise.all(batch.map(async (pin) => {
      pin.coords = await geocodeAddress(pin.address);
    }));
    renderDeliveryMapPins(); // render after each batch so pins appear progressively
    if (i + batchSize < deliveryMapPins.length) {
      await new Promise(r => setTimeout(r, 300)); // small pause between batches to respect Nominatim
    }
  }

  renderDeliveryMapPins();
}

function renderDeliveryMapPins() {
  const mapEl = document.getElementById('delivery-map');
  const pinList = document.getElementById('map-pin-list');
  const statsStrip = document.getElementById('map-stats-strip');
  if (!deliveryMapInstance || !pinList) return;

  // Clear existing markers
  deliveryMapInstance.eachLayer(layer => {
    if (layer instanceof L.Marker) deliveryMapInstance.removeLayer(layer);
  });

  const now = new Date();
  const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);

  const filtered = deliveryMapPins.filter(pin => {
    if (deliveryMapFilter === 'month') {
      const d = pin.date ? new Date(pin.date) : null;
      if (!d || d < monthStart) return false;
    }
    return pin.coords !== null;
  });

  // Stats
  const total = filtered.length;
  const byMethod = {};
  filtered.forEach(p => {
    const s = p.shipping || 'Other';
    byMethod[s] = (byMethod[s] || 0) + 1;
  });

  statsStrip.innerHTML = `
    <div style="background:var(--surface-2);border:1px solid var(--border);border-radius:var(--radius);padding:8px 14px;font-size:12px;">
      <span style="font-family:var(--font-head);font-weight:800;color:var(--accent);font-size:16px;">${total}</span>
      <span style="color:var(--text-3);margin-left:4px;">total pins</span>
    </div>
    ${Object.entries(byMethod).map(([method, count]) => `
      <div style="background:var(--surface-2);border:1px solid var(--border);border-radius:var(--radius);padding:8px 14px;font-size:12px;">
        <span style="font-family:var(--font-head);font-weight:800;color:${shippingPinColor(method)};font-size:14px;">${count}</span>
        <span style="color:var(--text-3);margin-left:4px;">${method.split(' - ')[0] || method}</span>
      </div>
    `).join('')}
  `;

  // Add markers
  filtered.forEach(pin => {
    const marker = L.marker([pin.coords.lat, pin.coords.lng], {
      icon: makeLeafletIcon(pin.color)
    });

    marker.bindPopup(`
      <div style="font-family:Arial,sans-serif;min-width:180px;">
        <div style="font-weight:800;font-size:13px;margin-bottom:4px;">${pin.name}</div>
        <div style="font-size:11px;color:#555;margin-bottom:6px;">${pin.address}</div>
        <div style="display:flex;flex-direction:column;gap:3px;font-size:11px;">
          ${pin.invoiceId !== '—' ? `<div>📄 <strong>${pin.invoiceId}</strong></div>` : ''}
          ${pin.amount && pin.amount !== '—' ? `<div>💰 ${pin.amount}</div>` : ''}
          ${pin.date ? `<div>📅 ${pin.date}</div>` : ''}
          <div>🚚 ${pin.shipping || 'Unknown'}</div>
          <div style="margin-top:4px;font-size:10px;color:#999;text-transform:uppercase;">${pin.source === 'calendar' ? '📆 From Calendar' : '🧾 From Invoice'}</div>
        </div>
      </div>
    `);

    marker.addTo(deliveryMapInstance);
  });

  // Fit map to markers if any
  if (filtered.length > 0) {
    const group = L.featureGroup(
      filtered.map(p => L.marker([p.coords.lat, p.coords.lng]))
    );
    deliveryMapInstance.fitBounds(group.getBounds().pad(0.2));
  } else {
    // Default to Ontario
    deliveryMapInstance.setView([51.2538, -85.3232], 6);
  }

  // Pin list below map
  if (!filtered.length) {
    pinList.innerHTML = '<div style="color:var(--text-3);font-size:12px;padding:8px 0;">No pins for this period.</div>';
    return;
  }

  pinList.innerHTML = filtered.map(pin => `
    <div onclick="deliveryMapInstance.setView([${pin.coords.lat},${pin.coords.lng}], 12); deliveryMapInstance.openPopup;" 
         style="background:var(--surface-2);border:1px solid var(--border);border-radius:var(--radius);padding:10px 14px;display:flex;align-items:center;gap:12px;cursor:pointer;transition:border-color 0.15s;"
         onmouseover="this.style.borderColor='var(--accent)'" onmouseout="this.style.borderColor='var(--border)'">
      <div style="width:12px;height:12px;border-radius:50%;background:${pin.color};flex-shrink:0;box-shadow:0 0 6px ${pin.color}88;"></div>
      <div style="flex:1;min-width:0;">
        <div style="font-family:var(--font-head);font-weight:700;font-size:13px;color:var(--text);">${pin.name}</div>
        <div style="font-size:11px;color:var(--text-3);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">${pin.address}</div>
      </div>
      <div style="text-align:right;flex-shrink:0;">
        ${pin.amount && pin.amount !== '—' ? `<div style="font-family:var(--font-head);font-weight:700;font-size:12px;color:var(--accent);">${pin.amount}</div>` : ''}
        ${pin.date ? `<div style="font-size:10px;color:var(--text-3);">${pin.date}</div>` : ''}
      </div>
    </div>
  `).join('');
}

/* ═══════════════════════════════════════════════════════════
   ACTIVE WARRANTIES
═══════════════════════════════════════════════════════════ */
let warrantyAllItems   = [];   // fully merged + sorted list
let warrantyPage       = 1;
let warrantySearchQuery = '';
const WARRANTY_PER_PAGE = 10;
let warrantyTimerIds   = [];

function warrantyTimeRemaining(expiryStr) {
  const expiry = new Date(expiryStr);
  if (isNaN(expiry.getTime())) return null;
  const diff = expiry.getTime() - Date.now();
  if (diff <= 0) return null; // expired
  return diff;
}

function warrantyFormatCountdown(ms) {
  const d = Math.floor(ms / 86400000);
  const h = Math.floor((ms % 86400000) / 3600000);
  const m = Math.floor((ms % 3600000) / 60000);
  const s = Math.floor((ms % 60000) / 1000);
  return { d, h, m, s, str: `${d}d ${h}h ${m}m ${s}s` };
}

function warrantyUrgencyColor(ms) {
  const days = ms / 86400000;
  if (days <= 3)  return '#ff6b4a';
  if (days <= 7)  return '#e8ff4a';
  return '#4af0ff';
}

async function loadWarrantyList() {
  const listEl  = document.getElementById('warranty-list');
  const stripEl = document.getElementById('warranty-expiring-strip');
  const badgeEl = document.getElementById('warranty-count-badge');
  if (!listEl) return;

  listEl.innerHTML = '<div style="color:var(--text-3);font-size:12px;padding:8px 0;">Loading warranties...</div>';
  warrantyAllItems = [];
  warrantyTimerIds.forEach(id => clearInterval(id));
  warrantyTimerIds = [];

  // 1. Pull Firebase invoices to build a customer/invoice lookup by engine code + SKU
  const docsSnap = await db.ref('savedDocuments').once('value');
  const docs = docsSnap.val() || {};
  const invoiceLookup = {}; // key: enginecode or sku lowercase → { invoiceId, customer }

  Object.values(docs).forEach(doc => {
    if (!doc.lineItems) return;
    doc.lineItems.forEach(item => {
      if (!item.desc) return;
      // Match engine codes like K24A, RB26, SR20 from description
      const codes = item.desc.match(/\b([A-Z]{1,3}\d{1,2}[A-Z0-9]*)\b/g) || [];
      codes.forEach(code => {
        const k = code.toLowerCase();
        if (!invoiceLookup[k]) invoiceLookup[k] = [];
        invoiceLookup[k].push({ invoiceId: doc.id || '—', customer: doc.customer?.name || '—' });
      });
      if (item.sku) {
        const k = item.sku.toLowerCase();
        if (!invoiceLookup[k]) invoiceLookup[k] = [];
        invoiceLookup[k].push({ invoiceId: doc.id || '—', customer: doc.customer?.name || '—' });
      }
    });
  });

  // 2. Use Shopify metafield data as the source of truth
  const shopifyItems = window.shopifyWarrantyData || [];

  if (!shopifyItems.length) {
    listEl.innerHTML = '<div style="color:var(--text-3);font-size:12px;padding:8px 0;">No warranty metafield data found on Shopify products.</div>';
    return;
  }

  shopifyItems.forEach(item => {
    const msLeft = warrantyTimeRemaining(item.expiry);
    const isExpired = !msLeft;

    const purchaseDateObj = item.purchase && item.purchase !== ''
      ? new Date(item.purchase)
      : (() => { const d = new Date(item.expiry); d.setDate(d.getDate() - 30); return d; })();

    const purchaseDisplay = purchaseDateObj.toLocaleDateString('en-CA', { month: 'short', day: 'numeric', year: 'numeric' });
    const expiryDisplay   = new Date(item.expiry).toLocaleDateString('en-CA', { month: 'short', day: 'numeric', year: 'numeric' });

    // Try to match to an invoice
    const codeKey   = (item.code || '').toLowerCase();
    const vendorKey = (item.vendor || '').toLowerCase();
    const matched   = invoiceLookup[codeKey] || invoiceLookup[vendorKey] || [];
    const invoiceId = matched.length ? matched[0].invoiceId : '—';
    const customer  = matched.length ? matched[0].customer  : '—';

    warrantyAllItems.push({
      title:        item.title,
      code:         item.code || 'N/A',
      customer,
      invoiceId,
      purchaseDate: purchaseDisplay,
      expiryDisplay,
      expiryStr:    item.expiry,
      msLeft:       msLeft || 0,
      expired:      isExpired,
      color:        isExpired ? '#666666' : warrantyUrgencyColor(msLeft)
    });
  });

  // Active first (most time remaining), then expired (most recently expired first)
  warrantyAllItems.sort((a, b) => {
    if (!a.expired && !b.expired) return b.msLeft - a.msLeft;
    if (a.expired && b.expired) return new Date(b.expiryStr) - new Date(a.expiryStr);
    return a.expired ? 1 : -1;
  });

  const total = warrantyAllItems.length;
  if (badgeEl) {
    badgeEl.textContent = total;
    badgeEl.style.display = total > 0 ? 'inline' : 'none';
  }

  const expiringSoon = warrantyAllItems.filter(w => w.msLeft / 86400000 <= 7);
  if (stripEl) {
    if (expiringSoon.length > 0) {
      stripEl.style.display = 'block';
      stripEl.textContent = `⚠️ ${expiringSoon.length} warranty${expiringSoon.length > 1 ? 'ies' : 'y'} expiring within 7 days`;
    } else {
      stripEl.style.display = 'none';
    }
  }

  warrantyPage = 1;
  renderWarrantyPage();
}

function renderWarrantyPage() {
  const listEl      = document.getElementById('warranty-list');
  const pageLabel   = document.getElementById('warranty-page-label');
  const paginationEl = document.getElementById('warranty-pagination');
  const prevBtn     = document.getElementById('warranty-prev-btn');
  const nextBtn     = document.getElementById('warranty-next-btn');
  if (!listEl) return;

  // Clear running timers
  warrantyTimerIds.forEach(id => clearInterval(id));
  warrantyTimerIds = [];

  const filtered = warrantySearchQuery
    ? warrantyAllItems.filter(w =>
        w.code.toLowerCase().includes(warrantySearchQuery) ||
        w.customer.toLowerCase().includes(warrantySearchQuery) ||
        w.title.toLowerCase().includes(warrantySearchQuery)
      )
    : warrantyAllItems;

  const total      = filtered.length;
  const totalPages = Math.ceil(total / WARRANTY_PER_PAGE);
  const start      = (warrantyPage - 1) * WARRANTY_PER_PAGE;
  const pageItems  = filtered.slice(start, start + WARRANTY_PER_PAGE);

  if (!pageItems.length) {
    listEl.innerHTML = '<div style="color:var(--text-3);font-size:12px;padding:8px 0;">No active warranties found.</div>';
    if (paginationEl) paginationEl.style.display = 'none';
    return;
  }

  if (paginationEl) {
    paginationEl.style.display = totalPages > 1 ? 'flex' : 'none';
  }
  if (pageLabel)  pageLabel.textContent  = `Page ${warrantyPage} of ${totalPages} · ${total} total`;
  if (prevBtn)    prevBtn.disabled       = warrantyPage === 1;
  if (nextBtn)    nextBtn.disabled       = warrantyPage === totalPages;

  listEl.innerHTML = pageItems.map((w, idx) => {
    const globalIdx = start + idx;
    const matchedHtml = `
      <span style="display:inline-flex;align-items:center;gap:4px;background:rgba(232,255,74,0.1);border:1px solid rgba(232,255,74,0.25);border-radius:4px;padding:2px 7px;font-size:10px;color:var(--accent);font-weight:600;">
        🧾 ${w.invoiceId} · ${w.customer}
      </span>`;

    return `
      <div style="background:var(--surface-2);border:1px solid var(--border);border-radius:var(--radius);padding:14px 16px;border-left:3px solid ${w.color};">
        <div style="display:flex;align-items:flex-start;justify-content:space-between;gap:12px;flex-wrap:wrap;">
          <div style="flex:1;min-width:0;">
            <div style="font-weight:700;font-size:13px;color:var(--text);margin-bottom:2px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">${w.title}</div>
            <div style="display:flex;gap:16px;flex-wrap:wrap;margin-top:6px;">
              <div>
                <div style="font-size:9px;text-transform:uppercase;letter-spacing:0.1em;color:var(--text-3);margin-bottom:2px;">Engine Code</div>
                <div style="font-size:12px;font-weight:700;color:var(--text);">${w.code}</div>
              </div>
              <div>
                <div style="font-size:9px;text-transform:uppercase;letter-spacing:0.1em;color:var(--text-3);margin-bottom:2px;">Purchase Date</div>
                <div style="font-size:12px;color:var(--text-2);">${w.purchaseDate}</div>
              </div>
              <div>
                <div style="font-size:9px;text-transform:uppercase;letter-spacing:0.1em;color:var(--text-3);margin-bottom:2px;">Expires</div>
                <div style="font-size:12px;color:var(--text-2);">${w.expiryDisplay}</div>
              </div>
            </div>
            <div style="margin-top:8px;display:flex;gap:6px;flex-wrap:wrap;align-items:center;">
              ${matchedHtml}
            </div>
          </div>
          <div style="text-align:right;flex-shrink:0;">
            <div style="font-size:9px;text-transform:uppercase;letter-spacing:0.1em;color:var(--text-3);margin-bottom:4px;">Time Remaining</div>
            <div id="wtimer-${globalIdx}" style="font-family:var(--font-mono, 'DM Mono', monospace);font-weight:500;font-size:12px;color:${w.color};font-variant-numeric:tabular-nums;letter-spacing:0.03em;">—</div>
          </div>
        </div>
      </div>
    `;
  }).join('');

  // Start countdown timers for this page
  pageItems.forEach((w, idx) => {
    const globalIdx = start + idx;
    const el = document.getElementById(`wtimer-${globalIdx}`);
    if (!el) return;

    if (w.expired) {
      el.textContent = 'EXPIRED';
      el.style.color = '#666666';
    } else {
      const update = () => {
        const ms = warrantyTimeRemaining(w.expiryStr);
        if (!ms) {
          el.textContent = 'EXPIRED';
          el.style.color = '#666666';
          return;
        }
        const { str } = warrantyFormatCountdown(ms);
        el.textContent = str;
        el.style.color = warrantyUrgencyColor(ms);
      };
      update();
      const tid = setInterval(update, 1000);
      warrantyTimerIds.push(tid);
    }
  });
}

function warrantySearch(query) {
  warrantySearchQuery = query.toLowerCase().trim();
  warrantyPage = 1;
  renderWarrantyPage();
}

function warrantyPageChange(dir) {
  const totalPages = Math.ceil(warrantyAllItems.length / WARRANTY_PER_PAGE);
  warrantyPage = Math.max(1, Math.min(totalPages, warrantyPage + dir));
  renderWarrantyPage();
}

const DEFAULT_PERMISSIONS = {
  createInvoices:      true,
  editDocuments:       true,
  deleteDocuments:     true,
  downloadPDF:         true,
  markPaid:            true,
  downloadAllZip:      true,
  viewDashboard:       true,
  viewIntake:          true,
  manageIntake:        true,
  viewWaitlist:        true,
  manageWaitlist:      true,
  viewCalendar:        true,
  manageCalendar:      true,
  accessChat:          true,
  deleteChatMessages:  true,
  clearChatHistory:    true,
  changePassword:      true,
};

const PERMISSION_LABELS = {
  createInvoices:      { label: 'Create Invoices & Documents', icon: '📄', group: 'Documents' },
  editDocuments:       { label: 'Edit Saved Documents',        icon: '✏️', group: 'Documents' },
  deleteDocuments:     { label: 'Delete Documents',            icon: '🗑️', group: 'Documents' },
  downloadPDF:         { label: 'Download / Share PDFs',       icon: '⬇️', group: 'Documents' },
  markPaid:            { label: 'Mark Invoices as Paid',       icon: '💰', group: 'Documents' },
  downloadAllZip:      { label: 'Download All as ZIP',         icon: '📦', group: 'Documents' },
  viewDashboard:       { label: 'View Dashboard & Revenue',    icon: '📊', group: 'Analytics' },
  viewIntake:          { label: 'View Customer Intake',        icon: '📥', group: 'Customers' },
  manageIntake:        { label: 'Manage Intake (mark/delete)', icon: '⚙️', group: 'Customers' },
  viewWaitlist:        { label: 'View Part Request Waitlist',  icon: '📋', group: 'Customers' },
  manageWaitlist:      { label: 'Manage Waitlist (mark/delete)', icon: '⚙️', group: 'Customers' },
  viewCalendar:        { label: 'View Delivery Calendar',      icon: '📅', group: 'Calendar' },
  manageCalendar:      { label: 'Add / Edit / Delete Events',  icon: '✏️', group: 'Calendar' },
  accessChat:          { label: 'Access Family Chat',          icon: '💬', group: 'Chat' },
  deleteChatMessages:  { label: 'Delete Chat Messages',        icon: '🗑️', group: 'Chat' },
  clearChatHistory:    { label: 'Clear All Chat History',      icon: '💣', group: 'Chat' },
  changePassword:      { label: 'Change Own Password',         icon: '🔒', group: 'Account' },
};

// Get effective permissions for current user
function getPermissions() {
  if (!currentUserProfile) return DEFAULT_PERMISSIONS;
  if (currentUserProfile.role === 'admin') return DEFAULT_PERMISSIONS; // admin always has all
  return { ...DEFAULT_PERMISSIONS, ...(currentUserProfile.permissions || {}) };
}

// Check a single permission — show toast if blocked
function can(permission, silent = false) {
  const perms = getPermissions();
  const allowed = perms[permission] !== false;
  if (!allowed && !silent) {
    const label = PERMISSION_LABELS[permission]?.label || permission;
    showToast(`🚫 Access restricted — "${label}" is disabled for your account. Contact Farhod.`);
  }
  return allowed;
}

/* ══════════════════════════════════════════════════════
   STAFF MANAGEMENT PANEL (admin only)
══════════════════════════════════════════════════════ */
let staffProfiles = {}; // uid → profile data

async function loadStaffManagement() {
  const container = document.getElementById('staff-management-list');
  if (!container) return;
  if (currentUserProfile?.role !== 'admin') {
    container.innerHTML = '<div style="color:var(--text-3);font-size:12px;">Admin only.</div>';
    return;
  }

  container.innerHTML = '<div style="color:var(--text-3);font-size:12px;padding:8px 0;">Loading staff...</div>';

  const snap = await db.ref('users').once('value');
  const allUsers = snap.val() || {};
  staffProfiles = allUsers;

  const staff = Object.entries(allUsers).filter(([uid, u]) => u.role !== 'admin');

  if (!staff.length) {
    container.innerHTML = '<div style="color:var(--text-3);font-size:12px;padding:8px 0;">No staff members found.</div>';
    return;
  }

  container.innerHTML = staff.map(([uid, u]) => {
    const perms = { ...DEFAULT_PERMISSIONS, ...(u.permissions || {}) };
    const groups = {};
    Object.entries(PERMISSION_LABELS).forEach(([key, meta]) => {
      if (!groups[meta.group]) groups[meta.group] = [];
      groups[meta.group].push({ key, ...meta, value: perms[key] !== false });
    });

    const groupHtml = Object.entries(groups).map(([groupName, items]) => `
      <div style="margin-bottom:12px;">
        <div style="font-size:9px;text-transform:uppercase;letter-spacing:0.12em;color:var(--accent);font-family:var(--font-head);font-weight:700;margin-bottom:6px;">${groupName}</div>
        ${items.map(item => `
          <div style="display:flex;justify-content:space-between;align-items:center;padding:6px 0;border-bottom:1px solid var(--border);">
            <span style="font-size:12px;color:var(--text-2);">${item.icon} ${item.label}</span>
            <label class="toggle-switch" style="width:36px;height:20px;">
              <input type="checkbox" ${item.value ? 'checked' : ''}
                onchange="updateStaffPermission('${uid}','${item.key}',this.checked, this)">
              <span class="toggle-slider"></span>
            </label>
          </div>
        `).join('')}
      </div>
    `).join('');

    const color = u.color || '#4af0ff';
    const initial = (u.name || '?')[0].toUpperCase();
    const avatarHtml = u.avatar
      ? `<img src="${u.avatar}" style="width:36px;height:36px;border-radius:50%;object-fit:cover;border:2px solid ${color};">`
      : `<div style="width:36px;height:36px;border-radius:50%;background:${color};color:#000;display:flex;align-items:center;justify-content:center;font-family:var(--font-head);font-weight:800;font-size:14px;">${initial}</div>`;

    return `
      <div style="background:var(--surface-2);border:1px solid var(--border);border-radius:var(--radius-lg);margin-bottom:12px;overflow:hidden;">
        <div onclick="this.nextElementSibling.style.display=this.nextElementSibling.style.display==='none'?'block':'none'" style="padding:14px 16px;cursor:pointer;display:flex;align-items:center;gap:12px;">
          ${avatarHtml}
          <div style="flex:1;">
            <div style="font-family:var(--font-head);font-weight:700;font-size:14px;color:${color};">${escI(u.name || '?')}</div>
            <div style="font-size:11px;color:var(--text-3);">Staff · tap to edit permissions</div>
          </div>
          <span style="color:var(--text-3);">▾</span>
        </div>
        <div style="display:none;padding:0 16px 16px;">
          ${groupHtml}
          <button onclick="resetStaffPermissions('${uid}')" style="margin-top:10px;width:100%;background:rgba(232,255,74,0.08);border:1px solid rgba(232,255,74,0.2);color:var(--accent);border-radius:var(--radius);padding:8px;font-family:var(--font-head);font-size:11px;font-weight:700;cursor:pointer;min-height:36px;">↺ Reset to All Enabled</button>
        </div>
      </div>
    `;
  }).join('');
}

async function updateStaffPermission(uid, permission, value, toggleEl) {
  // Defensive admin guard — prevents non-admins from even attempting the write
  if (!currentUserProfile || currentUserProfile.role !== 'admin') {
    if (toggleEl) toggleEl.checked = !value;
    showToast('🚫 Only admins can change permissions.');
    return;
  }
  try {
    await db.ref(`users/${uid}/permissions/${permission}`).set(value);
    const label = PERMISSION_LABELS[permission]?.label || permission;
    showToast(`✓ ${label} ${value ? 'enabled' : 'disabled'}.`);
    // If this is the currently logged-in user, refresh their profile
    if (uid === currentUserProfile?.uid) {
      currentUserProfile.permissions = currentUserProfile.permissions || {};
      currentUserProfile.permissions[permission] = value;
    }
  } catch(e) {
    console.error('[updateStaffPermission] Firebase rejected the write:', e);
    // Revert the toggle so the UI matches reality
    if (toggleEl) toggleEl.checked = !value;
    // Surface the real reason
    const code = e?.code || '';
    const msg  = e?.message || '';
    if (code === 'PERMISSION_DENIED' || /permission_denied/i.test(msg)) {
      showToast('⚠️ Firebase blocked the write — update your Database Rules to allow admins to write users/$uid/permissions.');
    } else {
      showToast('⚠️ Failed to update permission: ' + (msg || 'Unknown error'));
    }
  }
}

async function resetStaffPermissions(uid) {
  if (!currentUserProfile || currentUserProfile.role !== 'admin') {
    showToast('🚫 Only admins can reset permissions.');
    return;
  }
  if (!confirm('Reset all permissions to fully enabled for this staff member?')) return;
  const reset = {};
  Object.keys(DEFAULT_PERMISSIONS).forEach(k => reset[k] = true);
  try {
    await db.ref(`users/${uid}/permissions`).set(reset);
    showToast('✓ Permissions reset.');
    loadStaffManagement();
  } catch(e) {
    console.error('[resetStaffPermissions]', e);
    const code = e?.code || '';
    const msg  = e?.message || '';
    if (code === 'PERMISSION_DENIED' || /permission_denied/i.test(msg)) {
      showToast('⚠️ Firebase blocked the reset — update your Database Rules to allow admins to write users/$uid/permissions.');
    } else {
      showToast('⚠️ Failed to reset permissions: ' + (msg || 'Unknown error'));
    }
  }
}
/* ═══════════════════════════════════════════════════════════════════
   SMART REMINDERS ENGINE
   - Firebase storage under `reminders/`
   - Anthropic API key fetched from Firebase `config/anthropicKey`
   - Hourly push + in-app notifications
   - Screenshot scan via Claude claude-sonnet-4-20250514 vision
   - Manual entry, snooze, done/archive, permanent delete
═══════════════════════════════════════════════════════════════════ */

/* ─── State ─── */
let remindersData        = {};   // firebaseKey → reminder object
let remindersNotifTimer  = null;
let scanImageBase64      = null; // current screenshot in scan modal
let scanImageMime        = 'image/jpeg';
let scanSelectedUrgency  = 'medium';
let manualSelectedUrgency = 'medium';
let anthropicKeyCache    = null;
let completedListOpen    = false;

/* ─── Bootstrap ─── */
function initReminders() {
  db.ref('reminders').on('value', (snap) => {
    remindersData = snap.val() || {};
    renderReminders();
    updateReminderBadges();
    showReminderNotifStack();
    renderLandingReminders();
  });
  scheduleHourlyNotifications();
  // Request notification permission
  if ('Notification' in window && Notification.permission === 'default') {
    Notification.requestPermission();
  }
}

/* ─── Tab switching (Warranties / Reminders) ─── */
function switchWRTab(tab) {
  document.getElementById('warranties-panel').classList.toggle('active', tab === 'warranties');
  document.getElementById('reminders-panel').classList.toggle('active', tab === 'reminders');
  document.getElementById('wr-tab-warranties').classList.toggle('active', tab === 'warranties');
  document.getElementById('wr-tab-reminders').classList.toggle('active', tab === 'reminders');
  if (tab === 'warranties' && !warrantyAllItems.length) loadWarrantyList();
}

/* ─── Badge updates ─── */
function updateReminderBadges() {
  const active = Object.values(remindersData).filter(r => !r.done && !r.snoozedUntil || (r.snoozedUntil && r.snoozedUntil < Date.now()));
  const count  = Object.values(remindersData).filter(r => !r.done).length;

  const accordionBadge = document.getElementById('reminders-accordion-badge');
  const tabBadge       = document.getElementById('reminders-tab-badge');

  if (accordionBadge) {
    accordionBadge.textContent = count > 0 ? String(count) : '';
    accordionBadge.style.display = count > 0 ? 'inline' : 'none';
  }
  if (tabBadge) {
    tabBadge.textContent = count > 0 ? String(count) : '';
    tabBadge.style.display = count > 0 ? 'flex' : 'none';
  }
}

/* ─── Render all reminders ─── */
function renderReminders() {
  const activeEl    = document.getElementById('reminders-active-list');
  const completedEl = document.getElementById('reminders-completed-list');
  const completedSection = document.getElementById('reminders-completed-section');
  const completedCount   = document.getElementById('reminders-completed-count');
  if (!activeEl) return;

  const now = Date.now();
  const entries = Object.entries(remindersData);

  // Separate active vs completed, sort active by urgency then createdAt
  const urgencyOrder = { urgent: 0, high: 1, medium: 2, low: 3 };
  const active = entries
    .filter(([, r]) => !r.done && (!r.snoozedUntil || r.snoozedUntil < now))
    .sort((a, b) => {
      const uDiff = (urgencyOrder[a[1].urgency] ?? 2) - (urgencyOrder[b[1].urgency] ?? 2);
      return uDiff !== 0 ? uDiff : (b[1].createdAt || 0) - (a[1].createdAt || 0);
    });

  const snoozed = entries.filter(([, r]) => !r.done && r.snoozedUntil && r.snoozedUntil >= now)
    .sort((a, b) => a[1].snoozedUntil - b[1].snoozedUntil);

  const done = entries.filter(([, r]) => r.done)
    .sort((a, b) => (b[1].completedAt || 0) - (a[1].completedAt || 0));

  // Render active
  if (active.length === 0 && snoozed.length === 0) {
    activeEl.innerHTML = '<div class="reminders-empty"><span>✅</span>No active reminders. Great job staying on top of things!</div>';
  } else {
    activeEl.innerHTML = [
      ...active.map(([k, r]) => buildReminderCard(k, r, false)),
      ...(snoozed.length ? [`<div style="font-size:10px;text-transform:uppercase;letter-spacing:0.12em;color:var(--text-3);font-family:var(--font-head);font-weight:700;margin:14px 0 8px;">⏰ Snoozed</div>`] : []),
      ...snoozed.map(([k, r]) => buildReminderCard(k, r, false, true))
    ].join('');
  }

  // Render completed
  if (done.length > 0) {
    completedSection.style.display = 'block';
    completedCount.textContent = String(done.length);
    completedEl.innerHTML = done.map(([k, r]) => buildReminderCard(k, r, true)).join('');
  } else {
    completedSection.style.display = 'none';
  }
}

/* ─── Build a single reminder card ─── */
function buildReminderCard(key, r, isDone = false, isSnoozed = false) {
  const urgency    = r.urgency || 'medium';
  const platform   = r.platform || '';
  const customer   = r.customer || 'Unknown';
  const task       = r.task || '';
  const reply      = r.reply || '';
  const thumb      = r.thumb || '';
  const createdAt  = r.createdAt ? new Date(r.createdAt).toLocaleString('en-CA', { month:'short', day:'numeric', hour:'numeric', minute:'2-digit' }) : '';
  const snoozedMsg = isSnoozed && r.snoozedUntil
    ? 'Snoozed until ' + new Date(r.snoozedUntil).toLocaleString('en-CA', { month:'short', day:'numeric', hour:'numeric', minute:'2-digit' })
    : '';

  const platformPill = platform
    ? `<span class="reminder-platform-pill">${escI(platform)}</span>` : '';

  const thumbHtml = thumb
    ? `<img class="reminder-thumb" src="${thumb}" alt="screenshot" onclick="openReminderImgViewer('${key}')">` : '';

  const replySection = reply ? `
    <button class="reminder-reply-toggle" onclick="toggleReminderReply('${key}')">
      💬 Show suggested reply ▸
    </button>
    <div class="reminder-reply-box" id="reply-box-${key}">
      <button class="reminder-reply-copy" onclick="copyReminderReply('${key}')">Copy</button>
      ${escI(reply)}
    </div>` : '';

  let actionsHtml = '';
  if (isDone) {
    actionsHtml = `
      <div class="reminder-actions">
        <button class="reminder-btn reminder-btn-restore" onclick="restoreReminder('${key}')">↩ Restore</button>
        <button class="reminder-btn reminder-btn-delete" onclick="deleteReminder('${key}')">🗑 Delete</button>
      </div>`;
  } else {
    actionsHtml = `
      <div class="reminder-actions">
        <button class="reminder-btn reminder-btn-done" onclick="markReminderDone('${key}')">✓ Done</button>
        <button class="reminder-btn reminder-btn-snooze" onclick="toggleSnooze('${key}',this)">
          ⏰ Snooze
          <div class="snooze-picker" id="snooze-picker-${key}">
            <div class="snooze-option" onclick="snoozeReminder('${key}',1);event.stopPropagation();">1 hour</div>
            <div class="snooze-option" onclick="snoozeReminder('${key}',2);event.stopPropagation();">2 hours</div>
            <div class="snooze-option" onclick="snoozeReminder('${key}',4);event.stopPropagation();">4 hours</div>
            <div class="snooze-option" onclick="snoozeReminder('${key}',24);event.stopPropagation();">Tomorrow</div>
          </div>
        </button>
        <button class="reminder-btn reminder-btn-delete" onclick="deleteReminder('${key}')">🗑</button>
      </div>`;
  }

  return `
    <div class="reminder-card urgency-${urgency}${isDone ? ' done' : ''}" id="rc-${key}">
      <div class="reminder-card-top">
        <div class="reminder-urgency-dot"></div>
        <div class="reminder-main">
          <div class="reminder-customer">${escI(customer)}${platformPill}</div>
          <div class="reminder-task">${escI(task)}</div>
          <div class="reminder-meta">
            <span>${createdAt}</span>
            ${isSnoozed ? `<span style="color:var(--accent);">${escI(snoozedMsg)}</span>` : ''}
            ${isDone && r.completedAt ? `<span>Completed ${new Date(r.completedAt).toLocaleString('en-CA',{month:'short',day:'numeric'})}</span>` : ''}
          </div>
        </div>
        ${thumbHtml}
      </div>
      ${replySection}
      ${actionsHtml}
    </div>`;
}

/* ─── Toggle reply box ─── */
function toggleReminderReply(key) {
  const box = document.getElementById(`reply-box-${key}`);
  if (!box) return;
  const isOpen = box.style.display === 'block';
  box.style.display = isOpen ? 'none' : 'block';
  const toggle = box.previousElementSibling;
  if (toggle) toggle.textContent = isOpen ? '💬 Show suggested reply ▸' : '💬 Hide reply ▾';
}

/* ─── Copy reply to clipboard ─── */
function copyReminderReply(key) {
  const r = remindersData[key];
  if (!r?.reply) return;
  navigator.clipboard.writeText(r.reply)
    .then(() => showToast('✓ Reply copied to clipboard!'))
    .catch(() => showToast('Could not copy'));
}

/* ─── Mark done ─── */
async function markReminderDone(key) {
  try {
    await db.ref(`reminders/${key}`).update({ done: true, completedAt: Date.now() });
    showToast('✓ Marked as done!');
  } catch(e) { showToast('⚠ Could not update reminder'); }
}

/* ─── Restore from completed ─── */
async function restoreReminder(key) {
  try {
    await db.ref(`reminders/${key}`).update({ done: false, completedAt: null });
    showToast('↩ Reminder restored');
  } catch(e) { showToast('⚠ Could not restore'); }
}

/* ─── Delete permanently ─── */
async function deleteReminder(key) {
  if (!confirm('Permanently delete this reminder?')) return;
  try {
    await db.ref(`reminders/${key}`).remove();
    showToast('Reminder deleted.');
  } catch(e) { showToast('⚠ Could not delete'); }
}

/* ─── Snooze ─── */
function toggleSnooze(key, btn) {
  const picker = document.getElementById(`snooze-picker-${key}`);
  if (!picker) return;
  // Close all other open pickers first
  document.querySelectorAll('.snooze-picker.open').forEach(p => {
    if (p.id !== `snooze-picker-${key}`) p.classList.remove('open');
  });
  picker.classList.toggle('open');
  // Close on outside click
  const closeHandler = (e) => {
    if (!picker.contains(e.target) && e.target !== btn) {
      picker.classList.remove('open');
      document.removeEventListener('click', closeHandler);
    }
  };
  setTimeout(() => document.addEventListener('click', closeHandler), 10);
}

async function snoozeReminder(key, hours) {
  const snoozedUntil = Date.now() + hours * 3600000;
  try {
    await db.ref(`reminders/${key}`).update({ snoozedUntil });
    const label = hours === 24 ? 'tomorrow' : `${hours}h`;
    showToast(`⏰ Snoozed for ${label}`);
    document.getElementById(`snooze-picker-${key}`)?.classList.remove('open');
  } catch(e) { showToast('⚠ Could not snooze'); }
}

/* ─── Clear all completed ─── */
async function clearAllCompleted() {
  if (!confirm('Permanently delete all completed reminders?')) return;
  const keys = Object.entries(remindersData).filter(([,r]) => r.done).map(([k]) => k);
  const updates = {};
  keys.forEach(k => { updates[`reminders/${k}`] = null; });
  try {
    await db.ref().update(updates);
    showToast('✓ Completed reminders cleared');
  } catch(e) { showToast('⚠ Could not clear completed'); }
}

/* ─── Toggle completed section ─── */
function toggleCompletedList() {
  completedListOpen = !completedListOpen;
  const list   = document.getElementById('reminders-completed-list');
  const caret  = document.getElementById('reminders-completed-caret');
  list?.classList.toggle('open', completedListOpen);
  caret?.classList.toggle('open', completedListOpen);
}

/* ─── Urgency pill selector ─── */
function selectUrgency(urgency, btn, context = 'scan') {
  const rowId = context === 'scan' ? 'scan-urgency-row' : 'manual-urgency-row';
  document.querySelectorAll(`#${rowId} .urgency-pill`).forEach(p => p.classList.remove('selected'));
  btn.classList.add('selected');
  if (context === 'scan') scanSelectedUrgency = urgency;
  else manualSelectedUrgency = urgency;
}

/* ──────────────────────────────────────────
   SCAN MODAL
────────────────────────────────────────── */
function openScanModal() {
  resetScanModal();
  document.getElementById('reminder-scan-overlay').classList.add('open');
  document.getElementById('reminder-scan-modal').classList.add('open');
}

function closeScanModal() {
  document.getElementById('reminder-scan-overlay').classList.remove('open');
  document.getElementById('reminder-scan-modal').classList.remove('open');
}

function resetScanModal() {
  scanImageBase64 = null;
  scanSelectedUrgency = 'medium';
  document.getElementById('scan-step-upload').style.display = 'block';
  document.getElementById('scan-progress').classList.remove('active');
  document.getElementById('scan-result-card').classList.remove('visible');
  document.getElementById('scan-preview-img').style.display = 'none';
  document.getElementById('scan-preview-img').src = '';
  document.getElementById('scan-upload-error').style.display = 'none';
  document.getElementById('scan-file-input').value = '';
  document.getElementById('scan-result-name').value = '';
  document.getElementById('scan-result-platform').value = '';
  document.getElementById('scan-result-task').value = '';
  document.getElementById('scan-result-reply').value = '';
  document.querySelectorAll('#scan-urgency-row .urgency-pill').forEach(p => p.classList.remove('selected'));
  const actionBtn = document.getElementById('scan-action-btn');
  if (actionBtn) { actionBtn.textContent = 'Scan →'; actionBtn.onclick = startScan; }
}

function handleScanFile(input) {
  const file = input.files[0];
  if (!file) return;
  if (!file.type.startsWith('image/')) {
    document.getElementById('scan-upload-error').textContent = 'Please upload an image file (PNG, JPG, WEBP).';
    document.getElementById('scan-upload-error').style.display = 'block';
    return;
  }
  document.getElementById('scan-upload-error').style.display = 'none';
  scanImageMime = file.type;

  const reader = new FileReader();
  reader.onload = (e) => {
    const fullDataUrl = e.target.result;
    // Strip data URL prefix to get raw base64
    scanImageBase64 = fullDataUrl.split(',')[1];
    // Show preview
    const preview = document.getElementById('scan-preview-img');
    preview.src = fullDataUrl;
    preview.style.display = 'block';
  };
  reader.readAsDataURL(file);
}

// Drag-and-drop on drop zone
document.addEventListener('DOMContentLoaded', () => {
  const dz = document.getElementById('reminder-drop-zone');
  if (!dz) return;
  dz.addEventListener('dragover', (e) => { e.preventDefault(); dz.classList.add('drag-over'); });
  dz.addEventListener('dragleave', () => dz.classList.remove('drag-over'));
  dz.addEventListener('drop', (e) => {
    e.preventDefault();
    dz.classList.remove('drag-over');
    const file = e.dataTransfer.files[0];
    if (file) {
      const dt = new DataTransfer();
      dt.items.add(file);
      document.getElementById('scan-file-input').files = dt.files;
      handleScanFile(document.getElementById('scan-file-input'));
    }
  });
});

/* ─── Fetch Anthropic key from Firebase config node ─── */
async function getOpenRouterKey() {
  if (anthropicKeyCache) return anthropicKeyCache;
  try {
    const snap = await db.ref('config/openrouterKey').once('value');
    const key = snap.val();
    if (!key) throw new Error('No OpenRouter API key found in Firebase at config/openrouterKey');
    anthropicKeyCache = key;
    return key;
  } catch(e) {
    showToast('⚠ OpenRouter API key not found. Set it in Firebase at config/openrouterKey');
    throw e;
  }
}

/* ─── Start scan: call Anthropic API with image ─── */
async function startScan() {
  if (!scanImageBase64) {
    document.getElementById('scan-upload-error').textContent = 'Please upload a screenshot first.';
    document.getElementById('scan-upload-error').style.display = 'block';
    return;
  }

  // Switch UI to scanning state
  document.getElementById('scan-step-upload').style.display = 'none';
  document.getElementById('scan-result-card').classList.remove('visible');
  document.getElementById('scan-progress').classList.add('active');

  const labels = [
    'Reading screenshot...',
    'Identifying customer...',
    'Extracting context...',
    'Drafting reply...'
  ];
  let labelIdx = 0;
  const labelEl = document.getElementById('scan-progress-label');
  const labelTimer = setInterval(() => {
    labelIdx = (labelIdx + 1) % labels.length;
    if (labelEl) labelEl.textContent = labels[labelIdx];
  }, 1800);

  try {
    const apiKey = await getOpenRouterKey();

    const response = await fetch('https://openrouter.ai/api/v1/chat/completions', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiKey}`,
        'HTTP-Referer': 'https://globaljdmautoparts.com',
        'X-Title': 'Global JDM Admin Terminal'
      },
      body: JSON.stringify({
        model: 'openrouter/free',
        messages: [
          {
            role: 'user',
            content: [
              {
                type: 'image_url',
                image_url: {
                  url: `data:${scanImageMime};base64,${scanImageBase64}`
                }
              },
              {
                type: 'text',
                text: `You are an assistant helping a used JDM auto parts dealer manage customer follow-ups.\n\nAnalyse this screenshot carefully and extract the following. Respond with ONLY valid JSON, no markdown, no explanation:\n\n{\n  "customer": "The person's name shown at the very top of the chat screen in the header/title bar — this is who the conversation is with. Do NOT return Unknown. If you see any name anywhere in the screenshot, use it.",\n  "platform": "The app or platform shown in the screenshot — look at the UI style, icons, and layout to identify it (e.g. Facebook Marketplace, Facebook Messenger, Instagram, WhatsApp, iMessage, Gmail)",\n  "task": "A clear one-sentence description of what the dealer needs to do — focus on what the customer is asking about or waiting for",\n  "urgency": "urgent | high | medium | low — based on how long ago the message was sent and what they are asking"\n}`
              }
            ]
          }
        ],
        max_tokens: 400,
        temperature: 0.2
      })
    });

    clearInterval(labelTimer);
    document.getElementById('scan-progress').classList.remove('active');

    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err.error?.message || `API error ${response.status}`);
    }

    const data = await response.json();
    const raw  = data.choices?.[0]?.message?.content || '';

    let parsed;
    try {
      // Extract just the JSON object from whatever the model returns
      const jsonMatch = raw.match(/\{[\s\S]*\}/);
      if (!jsonMatch) throw new Error('No JSON found in response');
      const clean = jsonMatch[0].trim();
      parsed = JSON.parse(clean);
    } catch(e) {
      console.error('Raw AI response was:', raw);
      throw new Error('Could not parse AI response. Try again.');
    }

    // Populate result fields
    document.getElementById('scan-result-name').value     = parsed.customer || '';
    document.getElementById('scan-result-platform').value = parsed.platform || '';
    document.getElementById('scan-result-task').value     = parsed.task || '';

    // Set urgency pill
    const detectedUrgency = parsed.urgency || 'medium';
    scanSelectedUrgency = detectedUrgency;
    document.querySelectorAll('#scan-urgency-row .urgency-pill').forEach(p => {
      p.classList.toggle('selected', p.classList.contains(detectedUrgency));
    });

    // Show result card
    document.getElementById('scan-step-upload').style.display = 'block';
    document.getElementById('scan-result-card').classList.add('visible');

    // Change button to "Save Reminder"
    const actionBtn = document.getElementById('scan-action-btn');
    if (actionBtn) {
      actionBtn.textContent = '+ Save Reminder';
      actionBtn.onclick = saveScanReminder;
    }

  } catch(e) {
    clearInterval(labelTimer);
    document.getElementById('scan-progress').classList.remove('active');
    document.getElementById('scan-step-upload').style.display = 'block';
    document.getElementById('scan-upload-error').textContent = '⚠ ' + (e.message || 'Scan failed. Check your API key and try again.');
    document.getElementById('scan-upload-error').style.display = 'block';
    console.error('Reminder scan error:', e);
  }
}

/* ─── Save scanned reminder to Firebase ─── */
async function saveScanReminder() {
  const name    = document.getElementById('scan-result-name').value.trim();
  const task    = document.getElementById('scan-result-task').value.trim();
  const platform = document.getElementById('scan-result-platform').value.trim();
  const reply   = document.getElementById('scan-result-reply').value.trim();

  if (!name || !task) {
    document.getElementById('scan-upload-error').textContent = 'Customer name and task are required.';
    document.getElementById('scan-upload-error').style.display = 'block';
    return;
  }

  // Generate a small thumbnail from the base64 image (max 120px wide)
  let thumb = '';
  let fullImage = '';
  if (scanImageBase64) {
    try {
      thumb = await generateThumb(scanImageBase64, scanImageMime, 800);
    } catch(e) { /* thumb optional */ }
  }

  const reminder = {
    customer:  name,
    platform:  platform,
    task:      task,
    urgency:   scanSelectedUrgency,
    reply:     reply,
    thumb:     thumb,
    done:      false,
    createdAt: Date.now(),
    snoozedUntil: null,
    completedAt:  null,
    source: 'scan'
  };

  try {
    await db.ref('reminders').push(reminder);
    showToast('✓ Reminder saved!');
    closeScanModal();
    // Auto-switch to reminders tab and open accordion
    const acc = document.getElementById('accordion-warranties');
    if (acc && !acc.open) acc.open = true;
    switchWRTab('reminders');
  } catch(e) {
    document.getElementById('scan-upload-error').textContent = '⚠ Could not save. Check your connection.';
    document.getElementById('scan-upload-error').style.display = 'block';
  }
}

/* ─── Generate small thumbnail ─── */
function generateThumb(base64, mime, maxW = 120) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const ratio = Math.min(maxW / img.width, maxW / img.height);
      const w = Math.round(img.width * ratio);
      const h = Math.round(img.height * ratio);
      const canvas = document.createElement('canvas');
      canvas.width  = w;
      canvas.height = h;
      canvas.getContext('2d').drawImage(img, 0, 0, w, h);
      resolve(canvas.toDataURL('image/jpeg', 0.7));
    };
    img.onerror = reject;
    img.src = `data:${mime};base64,${base64}`;
  });
}

/* ──────────────────────────────────────────
   MANUAL ADD MODAL
────────────────────────────────────────── */
function openManualModal() {
  document.getElementById('manual-name').value     = '';
  document.getElementById('manual-platform').value = '';
  document.getElementById('manual-task').value     = '';
  document.getElementById('manual-reply').value    = '';
  document.getElementById('manual-error').style.display = 'none';
  manualSelectedUrgency = 'medium';
  // Reset urgency pills to medium
  document.querySelectorAll('#manual-urgency-row .urgency-pill').forEach(p => {
    p.classList.toggle('selected', p.classList.contains('medium'));
  });
  document.getElementById('reminder-manual-overlay').classList.add('open');
  document.getElementById('reminder-manual-modal').classList.add('open');
  setTimeout(() => document.getElementById('manual-name').focus(), 200);
}

function closeManualModal() {
  document.getElementById('reminder-manual-overlay').classList.remove('open');
  document.getElementById('reminder-manual-modal').classList.remove('open');
}

async function saveManualReminder() {
  const name     = document.getElementById('manual-name').value.trim();
  const task     = document.getElementById('manual-task').value.trim();
  const platform = document.getElementById('manual-platform').value.trim();
  const reply    = document.getElementById('manual-reply').value.trim();
  const errEl    = document.getElementById('manual-error');

  if (!name) { errEl.textContent = 'Customer name is required.'; errEl.style.display = 'block'; return; }
  if (!task) { errEl.textContent = 'Task description is required.'; errEl.style.display = 'block'; return; }
  errEl.style.display = 'none';

  const reminder = {
    customer: name,
    platform: platform,
    task:     task,
    urgency:  manualSelectedUrgency,
    reply:    reply,
    thumb:    '',
    done:     false,
    createdAt: Date.now(),
    snoozedUntil: null,
    completedAt:  null,
    source: 'manual'
  };

  try {
    await db.ref('reminders').push(reminder);
    showToast('✓ Reminder saved!');
    closeManualModal();
    const acc = document.getElementById('accordion-warranties');
    if (acc && !acc.open) acc.open = true;
    switchWRTab('reminders');
  } catch(e) {
    errEl.textContent = '⚠ Could not save. Check your connection.';
    errEl.style.display = 'block';
  }
}

/* ──────────────────────────────────────────
   IMAGE VIEWER
────────────────────────────────────────── */
function openReminderImgViewer(key) {
  const r = remindersData[key];
  if (!r?.thumb) return;
  document.getElementById('reminder-img-viewer-src').src = r.thumb;
  document.getElementById('reminder-img-viewer').classList.add('open');
}

function closeReminderImgViewer() {
  document.getElementById('reminder-img-viewer').classList.remove('open');
}

/* ──────────────────────────────────────────
   HOURLY NOTIFICATIONS
────────────────────────────────────────── */
function scheduleHourlyNotifications() {
  // Fire once at next top-of-hour, then every 60 min
  const now = Date.now();
  const msToNextHour = 3600000 - (now % 3600000);
  setTimeout(() => {
    fireReminderNotifications();
    remindersNotifTimer = setInterval(fireReminderNotifications, 3600000);
  }, msToNextHour);
}

function fireReminderNotifications() {
  const now = Date.now();
  const activeReminders = Object.values(remindersData).filter(r =>
    !r.done && (!r.snoozedUntil || r.snoozedUntil < now)
  );

  if (activeReminders.length === 0) return;

  const urgencyOrder = { urgent: 0, high: 1, medium: 2, low: 3 };
  const top = activeReminders.sort((a, b) => (urgencyOrder[a.urgency] ?? 2) - (urgencyOrder[b.urgency] ?? 2))[0];

  const title = `🔔 ${activeReminders.length} Reminder${activeReminders.length > 1 ? 's' : ''} Pending`;
  const body  = `${top.customer}: ${top.task}${activeReminders.length > 1 ? ` (+${activeReminders.length - 1} more)` : ''}`;

  // Show persistent notification stack instead of toast
  showReminderNotifStack();

  // Browser push (if tab is not focused or user is away)
  if ('Notification' in window && Notification.permission === 'granted' && document.hidden) {
    try {
      new Notification(title, {
        body: body,
        icon: 'https://globaljdmautoparts.com/cdn/shop/t/10/assets/favicon-96x96.png',
        tag:  'gjdm-reminders', // Replaces previous reminder notification
        requireInteraction: true
      });
    } catch(e) { /* notifications may not be available */ }
  }
}

/* ─── Hook into app init ─── */
// Called from onAuthStateChanged — see note in integration instructions

/* ═══════════════════════════════════════════════════
   PERSISTENT NOTIFICATION STACK
═══════════════════════════════════════════════════ */

let shownNotifKeys = new Set(); // track which reminders already have a card showing

function showReminderNotifStack() {
  const stack = document.getElementById('reminder-notif-stack');
  if (!stack) return;

  const now = Date.now();
  const active = Object.entries(remindersData).filter(([, r]) =>
    !r.done && (!r.snoozedUntil || r.snoozedUntil < now)
  );

  // Add cards for any new reminders not already shown
  active.forEach(([key, r]) => {
    if (shownNotifKeys.has(key)) return;
    shownNotifKeys.add(key);

    const urgency  = r.urgency || 'medium';
    const platform = r.platform ? `<span class="reminder-platform-pill" style="font-size:9px;padding:1px 6px;">${escI(r.platform)}</span>` : '';

    const card = document.createElement('div');
    card.className = `reminder-notif-card urgency-${urgency}`;
    card.id = `rnotif-${key}`;
    card.innerHTML = `
      <div class="reminder-notif-top">
        <div class="reminder-notif-info">
          <div class="reminder-notif-customer">
            🔔 ${escI(r.customer || 'Reminder')}${platform}
          </div>
          <div class="reminder-notif-task">${escI(r.task || '')}</div>
        </div>
        <button class="reminder-notif-close" onclick="dismissReminderNotif('${key}')">✕</button>
      </div>
      <div class="reminder-notif-actions">
        <button class="reminder-notif-btn reminder-notif-btn-done" onclick="markDoneFromNotif('${key}')">✓ Done</button>
        <button class="reminder-notif-btn reminder-notif-btn-snooze" onclick="snoozeFromNotif('${key}')">⏰ 1hr</button>
      </div>
    `;
    stack.appendChild(card);
  });

  // Remove cards for reminders that are now done or snoozed
  shownNotifKeys.forEach(key => {
    const r = remindersData[key];
    if (!r || r.done || (r.snoozedUntil && r.snoozedUntil >= now)) {
      dismissReminderNotif(key);
    }
  });
}

function dismissReminderNotif(key) {
  const card = document.getElementById(`rnotif-${key}`);
  if (!card) { shownNotifKeys.delete(key); return; }
  card.classList.add('dismissing');
  setTimeout(() => {
    card.remove();
    shownNotifKeys.delete(key);
  }, 300);
}

async function markDoneFromNotif(key) {
  await markReminderDone(key);
  dismissReminderNotif(key);
}

async function snoozeFromNotif(key) {
  await snoozeReminder(key, 1);
  dismissReminderNotif(key);
}

/* ═══════════════════════════════════════════════════
   LANDING PAGE REMINDERS
═══════════════════════════════════════════════════ */

function renderLandingReminders() {
  const wrap = document.getElementById('landing-reminders-wrap');
  const list = document.getElementById('landing-reminders-list');
  if (!wrap || !list) return;

  const now = Date.now();
  const active = Object.entries(remindersData)
    .filter(([, r]) => !r.done && (!r.snoozedUntil || r.snoozedUntil < now))
    .sort((a, b) => {
      const order = { urgent: 0, high: 1, medium: 2, low: 3 };
      return (order[a[1].urgency] ?? 2) - (order[b[1].urgency] ?? 2);
    });

  if (!active.length) {
    wrap.style.display = 'none';
    return;
  }

  wrap.style.display = 'block';
  list.innerHTML = active.map(([key, r]) => `
    <div class="landing-reminder-item urgency-${r.urgency || 'medium'}">
      <div class="landing-reminder-dot"></div>
      <div style="flex:1;min-width:0;">
        <div class="landing-reminder-customer">${escI(r.customer || 'Reminder')}${r.platform ? ` <span style="font-size:9px;color:var(--text-3);font-weight:400;">· ${escI(r.platform)}</span>` : ''}</div>
        <div class="landing-reminder-task">${escI(r.task || '')}</div>
      </div>
    </div>
  `).join('');
}
/* ═══════════════════════════════════════════════════════════════════
   MOBILE OVERHAUL — Unified JS
   ═══════════════════════════════════════════════════════════════════ */

(function() {
  'use strict';

  const MOBILE_BREAKPOINT = 768;
  const isMobile = () => window.innerWidth <= MOBILE_BREAKPOINT;

  // ─── State ──────────────────────────────────────────────────────
  const wizardState = {
    step: 0,
    editIdx: null,    // null = adding new, number = editing row index
    data: { description:'', sku:'', qty:'1', price:'', photo:null, photoFile:null }
  };

  const WIZARD_STEPS = [
    { label:'Step 1 of 6', question:'What is the product?',
      hint:'Enter the full name. This appears on the invoice.',
      type:'text', placeholder:'e.g. JDM Honda K20A Engine',
      field:'description', required:true },
    { label:'Step 2 of 6', question:'Item ID or SKU',
      hint:'Your internal part number. Leave blank if not applicable.',
      type:'text', placeholder:'e.g. K20A-2002-JDM',
      field:'sku', required:false },
    { label:'Step 3 of 6', question:'How many units?',
      hint:'Enter a whole number.',
      type:'number', inputMode:'numeric', placeholder:'1',
      field:'qty', required:true },
    { label:'Step 4 of 6', question:'Unit price?',
      hint:'Numbers only — no $ symbol.',
      type:'number', inputMode:'decimal', placeholder:'0.00',
      field:'price', required:true },
    { label:'Step 5 of 6', question:'Add a photo?',
      hint:'Optional — tap to choose from camera or library.',
      type:'file', field:'photo', required:false },
    { label:'Step 6 of 6 — Review', question:'Does everything look right?',
      hint:'Tap Save to add this item, or go back to edit.',
      field:null, required:false },
  ];

  // ─── HTML escaping ──────────────────────────────────────────────
  const esc = s => String(s||'')
    .replace(/&/g,'&amp;').replace(/</g,'&lt;')
    .replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  const escAttr = s => String(s||'')
    .replace(/"/g,'&quot;').replace(/'/g,'&#39;');

  // ─── SIDEBAR TOGGLE ─────────────────────────────────────────────
  function initSidebarToggle() {
    const btn = document.getElementById('mobile-sidebar-toggle');
    const sidebar = document.getElementById('app-sidebar');
    if (!btn || !sidebar) return;
    if (btn.dataset.bound === '1') return;
    btn.dataset.bound = '1';

    btn.addEventListener('click', () => {
      const open = sidebar.classList.toggle('mobile-expanded');
      btn.classList.toggle('open', open);
      btn.setAttribute('aria-expanded', String(open));
      const txt = btn.querySelector('.sidebar-toggle-text');
      if (txt) txt.textContent = open ? 'Hide Controls' : 'Document Controls';
    });
  }

  function updateDocTypePill() {
    const pill = document.getElementById('sidebar-doc-type-pill');
    if (!pill) return;
    const t = (typeof currentDocType !== 'undefined') ? currentDocType : 'INVOICE';
    pill.textContent = t === 'INVOICE' ? 'Invoice' : t === 'QUOTE' ? 'Quote' : 'Deposit';
  }

  // ─── MORE-ACTIONS SHEET ─────────────────────────────────────────
  window.openMoreSheet = function() {
    document.getElementById('mobile-more-sheet')?.classList.add('open');
    document.getElementById('mobile-more-overlay')?.classList.add('open');
  };
  window.closeMoreSheet = function() {
    document.getElementById('mobile-more-sheet')?.classList.remove('open');
    document.getElementById('mobile-more-overlay')?.classList.remove('open');
  };

  function initMoreSheet() {
    const overlay = document.getElementById('mobile-more-overlay');
    if (overlay && overlay.dataset.bound !== '1') {
      overlay.dataset.bound = '1';
      overlay.addEventListener('click', window.closeMoreSheet);
    }
  }

  // ─── MOBILE ITEM CARD LIST ──────────────────────────────────────
  // Source of truth: <tbody id="line-items"> rows
  // The card list is a read-only view rendered via MutationObserver

  function renderItemList() {
    if (!isMobile()) return;
    const list = document.getElementById('mobile-item-list');
    if (!list) return;

    const rows = document.querySelectorAll('#line-items .line-row');

    if (rows.length === 0) {
      list.innerHTML = `
        <div class="mobile-item-empty">
          <span>📦</span>
          No items yet. Tap "Add Item" below.
        </div>`;
      return;
    }

    let html = '';
    rows.forEach((row, idx) => {
      const desc  = (row.querySelector('.item-desc')?.value || '').trim();
      const qty   = parseFloat(row.querySelector('.item-qty')?.value)   || 0;
      const price = parseFloat(row.querySelector('.item-price')?.value) || 0;
      const total = (qty * price);
      const totalStr = total.toLocaleString(undefined, {
        minimumFractionDigits: 2, maximumFractionDigits: 2
      });
      const priceStr = price.toLocaleString(undefined, {
        minimumFractionDigits: 2, maximumFractionDigits: 2
      });

      const nameClass = desc ? '' : 'empty';
      const nameText = desc || `Item ${idx + 1} (empty — tap edit)`;

      html += `
        <div class="mobile-item-card" data-idx="${idx}">
          <div class="mobile-item-card-info">
            <div class="mobile-item-card-name ${nameClass}">${esc(nameText)}</div>
            <div class="mobile-item-card-meta">
              <span>Qty ${qty || 1}</span>
              <span>$${priceStr}</span>
            </div>
          </div>
          <div class="mobile-item-card-total">$${totalStr}</div>
          <div class="mobile-item-card-actions">
            <button class="mobile-item-edit-btn"
              onclick="window.openItemWizard(${idx})"
              aria-label="Edit item">✎</button>
            <button class="mobile-item-delete-btn"
              onclick="window.deleteMobileItem(${idx})"
              aria-label="Delete item">✕</button>
          </div>
        </div>`;
    });
    list.innerHTML = html;
  }

  window.deleteMobileItem = function(idx) {
    const rows = document.querySelectorAll('#line-items .line-row');
    if (rows.length <= 1) {
      if (typeof showToast === 'function') {
        showToast('⚠️ At least one item is required.');
      }
      return;
    }
    const row = rows[idx];
    if (!row) return;
    if (typeof currentPhotos !== 'undefined' && row.dataset.rowKey) {
      currentPhotos.delete(row.dataset.rowKey);
    }
    row.remove();
    if (typeof calc === 'function') calc();
    if (typeof scheduleAutosave === 'function') scheduleAutosave();
  };

  // ─── ITEM WIZARD ────────────────────────────────────────────────
  window.openItemWizard = function(editIdx) {
    wizardState.step = 0;
    wizardState.editIdx = (editIdx !== undefined && editIdx !== null) ? editIdx : null;

    if (wizardState.editIdx !== null) {
      const row = document.querySelectorAll('#line-items .line-row')[wizardState.editIdx];
      if (row) {
        wizardState.data = {
          description: row.querySelector('.item-desc')?.value  || '',
          sku:         row.querySelector('.item-sku')?.value   || '',
          qty:         row.querySelector('.item-qty')?.value   || '1',
          price:       row.querySelector('.item-price')?.value || '',
          photo: null, photoFile: null,
        };
      }
    } else {
      wizardState.data = {
        description:'', sku:'', qty:'1', price:'',
        photo: null, photoFile: null
      };
    }

    renderWizard();
    document.getElementById('mobile-item-wizard')?.classList.add('open');

    // Focus first input after slide-up animation completes
    setTimeout(() => {
      const i = document.getElementById('wizard-input');
      if (i && i.type !== 'file') i.focus();
    }, 350);
  };

  window.closeItemWizard = function() {
    document.getElementById('mobile-item-wizard')?.classList.remove('open');
  };

  function renderWizard() {
    const panel = document.querySelector('#mobile-item-wizard .wizard-panel');
    if (!panel) return;

    const step = WIZARD_STEPS[wizardState.step];
    const isLast = wizardState.step === WIZARD_STEPS.length - 1;

    // Progress dots
    const dots = WIZARD_STEPS.map((_, i) => {
      let cls = 'wizard-step-dot';
      if (i < wizardState.step) cls += ' done';
      else if (i === wizardState.step) cls += ' active';
      return `<div class="${cls}"></div>`;
    }).join('');

    // Input area
    let inputHTML = '';
    if (!isLast) {
      if (step.type === 'file') {
        const prev = wizardState.data.photo;
        inputHTML = `
          <label class="wizard-photo-label">
            ${prev
              ? `<img src="${prev}" alt="Photo preview" style="max-height:160px;max-width:100%;object-fit:contain;border-radius:6px;">
                 <div style="font-size:11px;color:var(--text-3);">Tap to change</div>`
              : `<div style="font-size:36px;">📷</div>
                 <div style="font-family:var(--font-head);font-weight:700;font-size:13px;color:var(--text-2);">Tap to choose photo</div>
                 <div style="font-size:11px;color:var(--text-3);">or skip with Next →</div>`
            }
            <input type="file" id="wizard-input" accept="image/*"
              capture="environment" style="display:none;"
              onchange="window._wizardHandlePhoto(this)">
          </label>`;
      } else {
        const val = wizardState.data[step.field] || '';
        inputHTML = `
          <input id="wizard-input"
            type="${step.type}"
            inputmode="${step.inputMode || ''}"
            class="wizard-input"
            placeholder="${escAttr(step.placeholder || '')}"
            value="${escAttr(val)}"
            autocomplete="off"
            onkeydown="if(event.key==='Enter'){event.preventDefault();window.wizardNext();}"
            oninput="window._wizardSetField('${step.field}', this.value)">`;
      }
    } else {
      // Review step
      const qty   = parseFloat(wizardState.data.qty)   || 0;
      const price = parseFloat(wizardState.data.price) || 0;
      const total = (qty * price).toFixed(2);
      inputHTML = `
        <div class="wizard-summary-card">
          <div class="wizard-summary-row">
            <span class="wizard-summary-key">Product</span>
            <span class="wizard-summary-val">${esc(wizardState.data.description || '—')}</span>
          </div>
          <div class="wizard-summary-row">
            <span class="wizard-summary-key">Item ID</span>
            <span class="wizard-summary-val">${esc(wizardState.data.sku || '—')}</span>
          </div>
          <div class="wizard-summary-row">
            <span class="wizard-summary-key">Qty</span>
            <span class="wizard-summary-val">${esc(wizardState.data.qty || '1')}</span>
          </div>
          <div class="wizard-summary-row">
            <span class="wizard-summary-key">Unit Price</span>
            <span class="wizard-summary-val">$${parseFloat(wizardState.data.price || 0).toFixed(2)}</span>
          </div>
          <div class="wizard-summary-row" style="margin-top:6px;padding-top:10px;border-top:1px solid var(--border);">
            <span class="wizard-summary-key">Total</span>
            <span class="wizard-summary-val accent">$${total}</span>
          </div>
          ${wizardState.data.photo
            ? `<img src="${wizardState.data.photo}" alt="Photo" style="max-height:90px;max-width:100%;object-fit:contain;border-radius:4px;margin-top:8px;">`
            : ''}
        </div>`;
    }

    // Nav buttons
    const prevBtn = wizardState.step > 0
      ? `<button class="wizard-btn wizard-btn-prev" onclick="window.wizardBack()">← Back</button>`
      : `<button class="wizard-btn wizard-btn-prev" onclick="window.closeItemWizard()">Cancel</button>`;

    const nextLabel = isLast
      ? (wizardState.editIdx !== null ? '✓ Save Changes' : '✓ Add Item')
      : 'Next →';

    const disabled = (!isLast && step.required &&
      !(wizardState.data[step.field] || '').toString().trim()) ? 'disabled' : '';

    panel.innerHTML = `
      <div class="wizard-handle"></div>
      <div class="wizard-progress">${dots}</div>
      <div class="wizard-step-label">${step.label}</div>
      <div class="wizard-question">${step.question}</div>
      <div class="wizard-hint">${step.hint}</div>
      ${inputHTML}
      <div class="wizard-nav">
        ${prevBtn}
        <button class="wizard-btn wizard-btn-next" id="wizard-next-btn"
          onclick="window.wizardNext()" ${disabled}>${nextLabel}</button>
      </div>`;

    // Live-enable next button on text/number inputs
    const inp = document.getElementById('wizard-input');
    if (inp && step.required && inp.type !== 'file') {
      const sync = () => {
        const btn = document.getElementById('wizard-next-btn');
        if (btn) btn.disabled = !inp.value.trim();
      };
      inp.addEventListener('input', sync);
      sync();
    }
  }

  window._wizardSetField = function(field, val) {
    wizardState.data[field] = val;
  };

  window._wizardHandlePhoto = function(input) {
    if (!input.files || !input.files[0]) return;
    const file = input.files[0];
    const reader = new FileReader();
    reader.onload = e => {
      wizardState.data.photo = e.target.result;
      wizardState.data.photoFile = file;
      renderWizard();
    };
    reader.readAsDataURL(file);
  };

  window.wizardNext = function() {
    const step = WIZARD_STEPS[wizardState.step];
    const isLast = wizardState.step === WIZARD_STEPS.length - 1;

    // Capture current input value
    if (!isLast && step.type !== 'file' && step.field) {
      const inp = document.getElementById('wizard-input');
      if (inp) wizardState.data[step.field] = inp.value;
    }

    if (isLast) {
      commitWizard();
      window.closeItemWizard();
      return;
    }

    wizardState.step++;
    renderWizard();
    setTimeout(() => {
      const i = document.getElementById('wizard-input');
      if (i && i.type !== 'file') i.focus();
    }, 50);
  };

  window.wizardBack = function() {
    if (wizardState.step === 0) {
      window.closeItemWizard();
      return;
    }
    const step = WIZARD_STEPS[wizardState.step];
    if (step.type !== 'file' && step.field) {
      const inp = document.getElementById('wizard-input');
      if (inp) wizardState.data[step.field] = inp.value;
    }
    wizardState.step--;
    renderWizard();
    setTimeout(() => {
      const i = document.getElementById('wizard-input');
      if (i && i.type !== 'file') i.focus();
    }, 50);
  };

  function commitWizard() {
    const d = wizardState.data;
    const setVal = (el, v) => {
      if (!el) return;
      el.value = v;
      el.dispatchEvent(new Event('input', { bubbles: true }));
      el.dispatchEvent(new Event('change', { bubbles: true }));
    };

    if (wizardState.editIdx !== null) {
      // Edit existing row
      const row = document.querySelectorAll('#line-items .line-row')[wizardState.editIdx];
      if (row) {
        setVal(row.querySelector('.item-desc'),  d.description);
        setVal(row.querySelector('.item-sku'),   d.sku);
        setVal(row.querySelector('.item-qty'),   d.qty);
        setVal(row.querySelector('.item-price'), d.price);
        if (d.photo && d.photoFile && typeof handlePhotoUpload === 'function') {
          // Inject the file into the row's hidden file input + trigger handler
          const photoInput = row.querySelector('.photo-input');
          if (photoInput) {
            const dt = new DataTransfer();
            dt.items.add(d.photoFile);
            photoInput.files = dt.files;
            handlePhotoUpload(photoInput);
          }
        }
      }
    } else {
      // Add new row
      if (typeof addRow !== 'function') return;
      addRow();
      const rows = document.querySelectorAll('#line-items .line-row');
      const newRow = rows[rows.length - 1];
      if (newRow) {
        setVal(newRow.querySelector('.item-desc'),  d.description);
        setVal(newRow.querySelector('.item-sku'),   d.sku);
        setVal(newRow.querySelector('.item-qty'),   d.qty);
        setVal(newRow.querySelector('.item-price'), d.price);
        if (d.photo && d.photoFile && typeof handlePhotoUpload === 'function') {
          const photoInput = newRow.querySelector('.photo-input');
          if (photoInput) {
            const dt = new DataTransfer();
            dt.items.add(d.photoFile);
            photoInput.files = dt.files;
            handlePhotoUpload(photoInput);
          }
        }
      }
    }

    if (typeof calc === 'function') calc();
    if (typeof scheduleAutosave === 'function') scheduleAutosave();
  }

  // ─── MUTATION OBSERVER — keeps cards in sync with table ────────
  // Observes #line-items for: row added, row removed, input edited
  let cardSyncTimer = null;
  function scheduleCardSync() {
    if (!isMobile()) return;
    clearTimeout(cardSyncTimer);
    cardSyncTimer = setTimeout(renderItemList, 50);
  }

  function initObserver() {
    const tbody = document.getElementById('line-items');
    if (!tbody || tbody.dataset.observed === '1') return;
    tbody.dataset.observed = '1';

    // Re-render on row add/remove
    new MutationObserver(scheduleCardSync).observe(tbody, {
      childList: true, subtree: false
    });

    // Re-render on input changes inside rows
    tbody.addEventListener('input',  scheduleCardSync);
    tbody.addEventListener('change', scheduleCardSync);
  }

  // ─── WIZARD MODAL: tap backdrop to close ───────────────────────
  function initWizardModal() {
    const wiz = document.getElementById('mobile-item-wizard');
    if (!wiz || wiz.dataset.bound === '1') return;
    wiz.dataset.bound = '1';
    wiz.addEventListener('click', e => {
      if (e.target === wiz) window.closeItemWizard();
    });
  }

  // ─── PILL SYNC: hook into setType without breaking it ──────────
  function hookSetType() {
    if (typeof window.setType !== 'function') return;
    if (window.setType._mobilePatched) return;
    const orig = window.setType;
    window.setType = function(type) {
      const result = orig.apply(this, arguments);
      updateDocTypePill();
      return result;
    };
    window.setType._mobilePatched = true;
  }

  // ─── BOOT ──────────────────────────────────────────────────────
  function boot() {
    initSidebarToggle();
    initMoreSheet();
    initWizardModal();
    initObserver();
    hookSetType();
    updateDocTypePill();
    renderItemList();
  }

  // First run after the main app boots its own DOMContentLoaded
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(boot, 100);
  });

  // Re-run on resize (orientation change, dev tools, etc)
  let resizeTimer = null;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(boot, 200);
  });

  // Also boot when user enters terminal (if landing page is being used)
  // The original code calls enterTerminal() which sets main-app to visible
  const mainApp = () => document.getElementById('main-app');
  let bootedAfterShow = false;
  const visibilityCheck = setInterval(() => {
    const m = mainApp();
    if (m && m.style.display !== 'none' && !bootedAfterShow) {
      bootedAfterShow = true;
      setTimeout(boot, 300);
    }
  }, 500);
  // Stop checking after 30s
  setTimeout(() => clearInterval(visibilityCheck), 30000);

})();

/* ═══════════════════════════════════════════════════════════════
   MOBILE BOTTOM-TAB NAVIGATION
   Append-only — does not modify any existing functions.
   ═══════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  var TAB_KEY = 'gjdm_active_tab_v1';
  var VALID_TABS = { build: 1, docs: 1, more: 1 };
  var DEFAULT_TAB = 'build';

  window.setActiveTab = function (tabId) {
    if (!VALID_TABS[tabId]) tabId = DEFAULT_TAB;
    document.body.setAttribute('data-active-tab', tabId);

    var buttons = document.querySelectorAll('#mobile-tab-nav .m-tab');
    for (var i = 0; i < buttons.length; i++) {
      var b = buttons[i];
      if (b.getAttribute('data-target-tab') === tabId) b.classList.add('active');
      else b.classList.remove('active');
    }

    try { localStorage.setItem(TAB_KEY, tabId); } catch (e) {}

    try { window.scrollTo({ top: 0, behavior: 'instant' in window ? 'instant' : 'auto' }); } catch (e) {
      window.scrollTo(0, 0);
    }

    try {
      if (tabId === 'more') {
        if (typeof loadDashboard === 'function' && document.getElementById('accordion-dashboard') && document.getElementById('accordion-dashboard').open) {
          try { loadDashboard(); } catch (e) {}
        }
        if (window.L && document.getElementById('delivery-map')) {
          setTimeout(function () {
            try {
              var map = window._gjdmDeliveryMap;
              if (map && typeof map.invalidateSize === 'function') map.invalidateSize();
            } catch (e) {}
          }, 200);
        }
      }
    } catch (e) {}
  };

  window.getActiveTab = function () {
    return document.body.getAttribute('data-active-tab') || DEFAULT_TAB;
  };

  window.syncTabBadges = function () {
    try {
      var intakeHeader = document.getElementById('intake-header-badge');
      var intakeAccordion = document.getElementById('intake-accordion-badge');
      var docsBadge = document.getElementById('m-tab-badge-docs');
      if (docsBadge) {
        var src = (intakeHeader && intakeHeader.textContent.trim())
               || (intakeAccordion && intakeAccordion.textContent.trim())
               || '';
        if (src && src !== '0') {
          docsBadge.textContent = src;
          docsBadge.style.display = '';
        } else {
          docsBadge.style.display = 'none';
        }
      }

      var remBadge = document.getElementById('reminders-accordion-badge');
      var wlBadge  = document.getElementById('waitlist-accordion-badge');
      var moreBadge = document.getElementById('m-tab-badge-more');
      if (moreBadge) {
        var rem = (remBadge && remBadge.textContent.trim()) || '';
        var wl  = (wlBadge  && wlBadge.textContent.trim())  || '';
        var show = '';
        if (rem && rem !== '0') show = rem;
        else if (wl && wl !== '0') show = wl;
        if (show) {
          moreBadge.textContent = show;
          moreBadge.style.display = '';
        } else {
          moreBadge.style.display = 'none';
        }
      }
    } catch (e) {}
  };

  document.addEventListener('toggle', function (e) {
    var target = e.target;
    if (!target || !target.matches || !target.matches('details.accordion[data-tab]')) return;
    if (!target.open) return;
    if (window.innerWidth > 768) return;
    var sectionTab = target.getAttribute('data-tab');
    var current = window.getActiveTab();
    if (sectionTab && sectionTab !== current) {
      window.setActiveTab(sectionTab);
    }
  }, true);

  function init() {
    var saved = DEFAULT_TAB;
    try {
      var stored = localStorage.getItem(TAB_KEY);
      if (stored && VALID_TABS[stored]) saved = stored;
    } catch (e) {}

    window.setActiveTab(saved);
    window.syncTabBadges();

    var observerTargets = [
      'intake-header-badge',
      'intake-accordion-badge',
      'reminders-accordion-badge',
      'waitlist-accordion-badge'
    ];
    if (typeof MutationObserver !== 'undefined') {
      var observer = new MutationObserver(function () { window.syncTabBadges(); });
      observerTargets.forEach(function (id) {
        var el = document.getElementById(id);
        if (el) {
          observer.observe(el, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['style'] });
        }
      });
    }

    setInterval(window.syncTabBadges, 10000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ═══════════════════════════════════════════════════════════════
   MORE TAB DRILL-DOWN MENU
   ═══════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  var VALID_MORE_PAGES = {
    dashboard:     { accordion: 'accordion-dashboard',     title: 'Dashboard' },
    calendar:      { accordion: 'accordion-calendar',      title: 'Calendar' },
    waitlist:      { accordion: 'accordion-waitlist',      title: 'Waitlist' },
    deliverymap:   { accordion: 'accordion-deliverymap',   title: 'Delivery Map' },
    warranties:    { accordion: 'accordion-warranties',    title: 'Warranties', wrTab: 'warranties' },
    reminders:     { accordion: 'accordion-warranties',    title: 'Reminders',  wrTab: 'reminders' },
    phototransfer: { accordion: 'accordion-phototransfer', title: 'Photo Transfer' },
    reviews:       { accordion: 'accordion-reviews',       title: 'Customer Reviews' },
returns:       { accordion: 'accordion-returns',       title: 'Product Returns' }
  };

  window.setActiveMorePage = function (page) {
    if (page && !VALID_MORE_PAGES[page]) page = null;

    if (!page) {
      document.body.removeAttribute('data-active-more-page');
      window.scrollTo(0, 0);
      return;
    }

    document.body.setAttribute('data-active-more-page', page);
    var info = VALID_MORE_PAGES[page];

    var acc = document.getElementById(info.accordion);
    if (acc && 'open' in acc) acc.open = true;

    if (info.wrTab && typeof window.switchWRTab === 'function') {
      try { window.switchWRTab(info.wrTab); } catch (e) {}
    }

    var titleEl = document.getElementById('more-back-title');
    if (titleEl) titleEl.textContent = info.title;

    window.scrollTo(0, 0);

    try {
      if (page === 'dashboard' && typeof loadDashboard === 'function') loadDashboard();
      if (page === 'deliverymap' && window.L) {
        setTimeout(function () {
          try {
            var map = window._gjdmDeliveryMap;
            if (map && typeof map.invalidateSize === 'function') map.invalidateSize();
          } catch (e) {}
        }, 200);
      }
      if (page === 'warranties' && typeof loadWarrantyList === 'function') loadWarrantyList();
      if (page === 'phototransfer' && typeof ptInitOnOpen === 'function') ptInitOnOpen();
      if (page === 'reviews' && typeof loadReviewsAdmin === 'function') loadReviewsAdmin();
      if (page === 'returns' && typeof loadReturnsAdmin === 'function') loadReturnsAdmin();
    } catch (e) {}
  };

  if (typeof window.setActiveTab === 'function' && !window.__morePagePatched) {
    var __originalSetActiveTab = window.setActiveTab;
    window.setActiveTab = function (tabId) {
      __originalSetActiveTab(tabId);
      if (tabId !== 'more') {
        document.body.removeAttribute('data-active-more-page');
      }
    };
    window.__morePagePatched = true;
  }

  function syncMoreMenuBadges() {
    try {
      var pairs = [
        ['waitlist-accordion-badge',  'more-menu-badge-waitlist'],
        ['reminders-accordion-badge', 'more-menu-badge-reminders']
      ];
      pairs.forEach(function (p) {
        var src = document.getElementById(p[0]);
        var dst = document.getElementById(p[1]);
        if (!dst) return;
        var visible = src && src.style.display !== 'none';
        var txt = (src && src.textContent.trim()) || '';
        if (visible && txt && txt !== '0') {
          dst.textContent = txt;
          dst.style.display = '';
        } else {
          dst.style.display = 'none';
        }
      });
    } catch (e) {}
  }

  function init() {
    syncMoreMenuBadges();
    setInterval(syncMoreMenuBadges, 8000);
    if (typeof MutationObserver !== 'undefined') {
      var obs = new MutationObserver(syncMoreMenuBadges);
      ['waitlist-accordion-badge', 'reminders-accordion-badge'].forEach(function (id) {
        var el = document.getElementById(id);
        if (el) obs.observe(el, { childList: true, characterData: true, subtree: true, attributes: true });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
/* ═══════════════════════════════════════════════════════════════
   MOBILE PAID-TOGGLE BUTTON SYNC
   Mirrors the desktop #btn-paid-toggle state onto #btn-mobile-paid.
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  function applyMobilePaidUI(status) {
    var mobile = document.getElementById('btn-mobile-paid');
    if (!mobile) return;

    if (typeof currentDocType !== 'undefined' && currentDocType !== 'INVOICE') {
      mobile.style.display = 'none';
      return;
    }
    mobile.style.display = '';

    if (status === 'paid') {
      mobile.textContent       = '✓ Paid';
      mobile.style.background  = 'rgba(76,255,145,0.12)';
      mobile.style.color       = '#4cff91';
      mobile.style.borderColor = '#4cff91';
    } else {
      mobile.textContent       = '$ Mark Paid';
      mobile.style.background  = '';
      mobile.style.color       = '';
      mobile.style.borderColor = '';
    }
  }

  function patch() {
    if (typeof window.updatePaidToggleUI !== 'function') return false;
    if (window.__mobilePaidPatched) return true;

    var __orig = window.updatePaidToggleUI;
    window.updatePaidToggleUI = function (status) {
      __orig.call(this, status);
      applyMobilePaidUI(status);
    };
    window.__mobilePaidPatched = true;
    return true;
  }

  function init() {
    if (!patch()) {
      // updatePaidToggleUI not defined yet — retry shortly
      setTimeout(init, 500);
      return;
    }
    // Sync once based on current desktop button state
    setTimeout(function () {
      var desktop = document.getElementById('btn-paid-toggle');
      if (!desktop) { applyMobilePaidUI('unpaid'); return; }
      var isPaid = desktop.textContent.indexOf('✓') === 0;
      applyMobilePaidUI(isPaid ? 'paid' : 'unpaid');
    }, 800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ═══════════════════════════════════════════════════════════════
   PDF PREVIEW MODAL — build once, view, then share or save
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var _previewBlobUrl  = null;
  var _previewBlob     = null;
  var _previewPdfDoc   = null;
  var _previewFilename = null;

  window.previewPDF = async function () {
    if (typeof can === 'function' && !can('downloadPDF')) return;
    if (typeof validateBeforeExport === 'function' && !validateBeforeExport()) return;

    var loader = document.getElementById('loader');
    if (loader) loader.style.display = 'flex';

    try {
      var result = await buildPDF();
      _previewPdfDoc   = result.pdf;
      _previewFilename = result.filename;
      _previewBlob     = result.pdf.output('blob');

      // Render the visible HTML to an image — blob-PDF iframes fail on iOS Safari
      var renderZone = document.getElementById('pdf-render-zone');
      var imageData = '';
      if (renderZone && typeof html2canvas === 'function') {
        var c = await html2canvas(renderZone, {
          scale: 1.5,
          useCORS: true,
          allowTaint: true,
          backgroundColor: '#ffffff',
          logging: false
        });
        imageData = c.toDataURL('image/jpeg', 0.88);
      }

      var modal  = document.getElementById('pdf-preview-modal');
      var imgEl  = document.getElementById('pdf-preview-image');
      var nameEl = document.getElementById('pdf-preview-name');

      if (imgEl)  imgEl.src = imageData;
      if (nameEl) nameEl.textContent = _previewFilename;
      if (modal)  modal.classList.add('open');
      document.body.style.overflow = 'hidden';
    } catch (err) {
      console.error('Preview failed:', err);
      alert('Could not generate preview. Please try again.');
    } finally {
      if (loader) loader.style.display = 'none';
    }
  };

  window.closePDFPreview = function () {
    var modal = document.getElementById('pdf-preview-modal');
    var imgEl = document.getElementById('pdf-preview-image');
    if (imgEl) imgEl.src = '';
    if (modal) modal.classList.remove('open');
    document.body.style.overflow = '';
    if (_previewBlobUrl) {
      URL.revokeObjectURL(_previewBlobUrl);
      _previewBlobUrl = null;
    }
    _previewBlob     = null;
    _previewPdfDoc   = null;
    _previewFilename = null;
  };

  window.downloadFromPreview = async function () {
    if (!_previewPdfDoc || !_previewFilename) return;
    try {
      _previewPdfDoc.save(_previewFilename);
      if (typeof saveDocument === 'function') await saveDocument(false);
      if (typeof draftKey !== 'undefined') localStorage.removeItem(draftKey);
      if (typeof setAutosaveStatus === 'function') setAutosaveStatus('idle');
      if (typeof db !== 'undefined' && typeof getNextDocNumber === 'function') {
        db.ref('savedDocuments').once('value', function (snap) {
          var docIdEl = document.getElementById('doc-id');
          if (docIdEl) docIdEl.value = getNextDocNumber(snap.val(), currentDocType);
        });
      }
      window.closePDFPreview();
    } catch (err) {
      console.error('Save from preview failed:', err);
      alert('Could not save the file.');
    }
  };

  window.shareFromPreview = async function () {
    if (!_previewBlob || !_previewFilename) return;
    try {
      var file = new File([_previewBlob], _previewFilename, { type: 'application/pdf' });
      var docIdEl = document.getElementById('doc-id');
      var docId = docIdEl ? docIdEl.value : '';
      var shareData = {
        files: [file],
        title: 'Global JDM ' + currentDocType + ' #' + docId,
        text:  'Hello, here is your ' + currentDocType + ' from Global JDM.'
      };
      if (navigator.canShare && navigator.canShare(shareData)) {
        await navigator.share(shareData);
        if (typeof saveDocument === 'function') await saveDocument(false);
        if (typeof draftKey !== 'undefined') localStorage.removeItem(draftKey);
        if (typeof setAutosaveStatus === 'function') setAutosaveStatus('idle');
        window.closePDFPreview();
      } else {
        alert('Share is not supported on this device. Tap Save to download instead.');
      }
    } catch (err) {
      if (err && err.name !== 'AbortError') {
        console.error('Share from preview failed:', err);
        alert('Could not share the file.');
      }
      // Otherwise user cancelled — leave preview open
    }
  };
})();

/* ═══════════════════════════════════════════════════════════════
   TUTORIAL — make it work with the mobile tab layout
   Auto-switches to the right tab + drill-down before each step.
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  function getElementTabContext(el) {
    var cur = el;
    var tab = null, drill = null;
    while (cur && cur.nodeType === 1) {
      if (!tab && cur.hasAttribute && cur.hasAttribute('data-tab')) {
        tab = cur.getAttribute('data-tab');
      }
      if (!drill && cur.hasAttribute && cur.hasAttribute('data-more-page')) {
        drill = cur.getAttribute('data-more-page');
      }
      cur = cur.parentElement;
    }
    return { tab: tab, drill: drill };
  }

  function patchTutorial() {
    if (typeof window.showTutorialStep !== 'function') return false;
    if (window.__tutorialTabPatched) return true;

    var __orig = window.showTutorialStep;

    window.showTutorialStep = function (index) {
      // Desktop: unchanged
      if (window.innerWidth > 768) return __orig(index);

      var step = null;
      try { step = tutorialSteps[index]; } catch (e) {}
      if (!step) return __orig(index);

      var sel = step.selector || '';
      var el  = sel ? document.querySelector(sel) : null;
      var ctx = el ? getElementTabContext(el) : { tab: null, drill: null };

      // Manual overrides for steps whose visual target lives elsewhere on mobile
      if (sel === '#autosave-dot') {
        // mobileSelector points to .mobile-bottom-bar which is only on BUILD
        ctx.tab = 'build';
      }

      var currentTab   = (typeof window.getActiveTab === 'function')
                          ? window.getActiveTab()
                          : (document.body.getAttribute('data-active-tab') || 'build');
      var currentDrill = document.body.getAttribute('data-active-more-page') || null;

      var needTabSwitch = ctx.tab && ctx.tab !== currentTab;
      var needDrill     = (ctx.tab === 'more') && ((ctx.drill || null) !== currentDrill);

      if (!needTabSwitch && !needDrill) return __orig(index);

      // Switch tab first
      if (needTabSwitch && typeof window.setActiveTab === 'function') {
        window.setActiveTab(ctx.tab);
      }

      // For MORE: drill in (or back out to menu) before showing the step
      if (ctx.tab === 'more' && typeof window.setActiveMorePage === 'function') {
        setTimeout(function () {
          window.setActiveMorePage(ctx.drill || null);
          setTimeout(function () { __orig(index); }, 380);
        }, needTabSwitch ? 220 : 0);
      } else {
        setTimeout(function () { __orig(index); }, needTabSwitch ? 380 : 0);
      }
    };

    window.__tutorialTabPatched = true;
    return true;
  }

  function init() {
    if (!patchTutorial()) setTimeout(init, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  setTimeout(init, 1500);
})();

/* ═══════════════════════════════════════════════════════════════
   PHOTO TRANSFER (Phone → Desktop via WebRTC, Firebase signaling)
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  // Detect sender mode (phone-side) via ?photoSend=SESSION_ID URL param.
  var urlParams = new URLSearchParams(window.location.search);
  var senderSessionId = urlParams.get('photoSend');
  var IS_SENDER = !!senderSessionId;

  // Set the global flag synchronously so the auth state listener bails out
  // before it tries to show the login gate or call initApp() on the phone.
  if (IS_SENDER) {
    window.__ptSenderMode = true;
  }

  // Shared state
  var STUN = {
    iceServers: [
      { urls: 'stun:stun.relay.metered.ca:80' },
      { urls: 'turn:global.relay.metered.ca:80', username: 'f5bf451d84b2afc2c2e63a30', credential: 'lt3OEo8q1P+Wv9gS' },
      { urls: 'turn:global.relay.metered.ca:80?transport=tcp', username: 'f5bf451d84b2afc2c2e63a30', credential: 'lt3OEo8q1P+Wv9gS' },
      { urls: 'turn:global.relay.metered.ca:443', username: 'f5bf451d84b2afc2c2e63a30', credential: 'lt3OEo8q1P+Wv9gS' },
      { urls: 'turns:global.relay.metered.ca:443?transport=tcp', username: 'f5bf451d84b2afc2c2e63a30', credential: 'lt3OEo8q1P+Wv9gS' }
    ],
    iceTransportPolicy: 'relay',
    iceCandidatePoolSize: 4
  };
  var CHUNK_SIZE = 16 * 1024; // 16KB — WebRTC safe limit
  var tx = { pc: null, channel: null, sigRef: null, ready: false, queue: [], sending: false };

  // ───────────────────────────────────────────────────────────────
  // SENDER MODE  (runs on phone)
  // ───────────────────────────────────────────────────────────────
  if (IS_SENDER) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', startSender);
    } else {
      setTimeout(startSender, 100);
    }
    return; // sender code path stops here
  }

  function startSender() {
    if (!firebase || !firebase.apps || !firebase.apps.length) {
      return setTimeout(startSender, 300);
    }
    var ptDb;
    try {
      ptDb = firebase.database();
    } catch(e) {
      return setTimeout(startSender, 300);
    }
    if (!ptDb || !ptDb.ref) {
      return setTimeout(startSender, 300);
    }
    renderSenderUI();
    txStatus('Firebase ready. Looking for session: ' + senderSessionId);
    var testRef = ptDb.ref('phototransfer/' + senderSessionId);
    testRef.child('offer').once('value').then(function(snap) {
      var val = snap.val();
      if (val && val.sdp) {
        txStatus('Offer found! Starting connection…');
      } else {
        txStatus('Waiting for computer… (session: ' + senderSessionId.slice(0,6) + '…) Open Photo Transfer on your desktop first.');
      }
      initSender(ptDb).catch(function(e) {
        txStatus('Error: ' + e.message);
      });
    }).catch(function(e) {
      txStatus('Firebase error: ' + e.message + '. Check your connection.');
    });
  }

  // ───────────────────────────────────────────────────────────────
  // RECEIVER MODE  (runs on desktop / admin terminal)
  // ───────────────────────────────────────────────────────────────
  var rxState = {
    sessionId: null,
    pc: null,
    channel: null,
    sigRef: null,
    incoming: {},
    activeId: null,
    photos: [],
    selected: new Set(),
    page: 0,
    pageSize: 24,
    connected: false
  };

  function rxLog(msg, kind) {
    var el = document.getElementById('pt-status');
    if (!el) return;
    el.textContent = msg;
    el.dataset.kind = kind || 'info';
  }

  function rxRandomId() {
    return Math.random().toString(36).slice(2, 10) + Date.now().toString(36).slice(-4);
  }

  function rxRenderQR(url) {
    var box = document.getElementById('pt-qr-box');
    if (!box) return;
    box.innerHTML = '';
    if (typeof QRCode === 'undefined') {
      box.innerHTML = '<div style="color:var(--text-3);font-size:12px;">QR library loading…</div>';
      setTimeout(function () { rxRenderQR(url); }, 400);
      return;
    }
    try {
      new QRCode(box, { text: url, width: 200, height: 200, correctLevel: QRCode.CorrectLevel.M });
    } catch (e) {
      box.innerHTML = '<div style="color:var(--red);font-size:12px;">QR error: ' + e.message + '</div>';
    }
    var linkEl = document.getElementById('pt-qr-link');
    if (linkEl) {
      linkEl.textContent = url;
      linkEl.href = url;
    }
  }

  async function rxStartSession() {
    if (rxState.pc) rxCleanupSession(false);
    rxState.sessionId = rxRandomId();
    rxState.incoming = {};
    rxState.photos = [];
    rxState.selected.clear();
    rxState.page = 0;
    rxState.connected = false;
    rxRenderGrid();
    rxUpdateCounts();

    var url = window.location.origin + window.location.pathname + '?photoSend=' + rxState.sessionId;
    rxRenderQR(url);

    rxState.sigRef = firebase.database().ref('phototransfer/' + rxState.sessionId);

    rxState.pc = new RTCPeerConnection(STUN);

    // Desktop creates the DataChannel (offerer must create it)
    rxState.channel = rxState.pc.createDataChannel('photos', { ordered: true });
    rxState.channel.binaryType = 'arraybuffer';
    rxState.channel.onopen = function () {
      rxState.connected = true;
      rxLog('Phone connected. Waiting for photos…', 'ok');
      var qrBox = document.getElementById('pt-qr-wrap');
      if (qrBox) qrBox.style.display = 'none';
      var connBox = document.getElementById('pt-conn-banner');
      if (connBox) connBox.style.display = '';
    };
    rxState.channel.onmessage = rxHandleMessage;
    rxState.channel.onclose = function () {
      rxState.connected = false;
      rxLog('Phone disconnected.', 'warn');
    };

    rxState.pc.onicecandidate = function (ev) {
      if (ev.candidate) {
        rxState.sigRef.child('rxCandidates').push(ev.candidate.toJSON());
      }
    };

    var rxRemoteSet = false;
    var rxPendingCandidates = [];

    rxState.sigRef.child('answer').on('value', async function (snap) {
      var ans = snap.val();
      if (!ans || !ans.sdp || !rxState.pc || rxRemoteSet) return;
      try {
        await rxState.pc.setRemoteDescription(ans);
        rxRemoteSet = true;
        for (var i = 0; i < rxPendingCandidates.length; i++) {
          try { await rxState.pc.addIceCandidate(rxPendingCandidates[i]); } catch (e) {}
        }
        rxPendingCandidates = [];
      } catch (e) { console.error(e); }
    });
    rxState.sigRef.child('txCandidates').on('child_added', async function (snap) {
      var c = snap.val();
      if (!c || !rxState.pc) return;
      if (rxRemoteSet) {
        try { await rxState.pc.addIceCandidate(c); } catch (e) { console.error(e); }
      } else {
        rxPendingCandidates.push(c);
      }
    });

    var offer = await rxState.pc.createOffer();
    await rxState.pc.setLocalDescription(offer);
    await rxState.sigRef.child('offer').set({ type: offer.type, sdp: offer.sdp });

    rxLog('Waiting for phone… Scan the QR code with your phone camera.', 'info');
  }

  function rxCleanupSession(showQR) {
    try { if (rxState.channel) rxState.channel.close(); } catch (e) {}
    try { if (rxState.pc) rxState.pc.close(); } catch (e) {}
    if (rxState.sigRef) {
      try { rxState.sigRef.off(); } catch (e) {}
      try { rxState.sigRef.remove(); } catch (e) {}
    }
    rxState.pc = null;
    rxState.channel = null;
    rxState.sigRef = null;
    rxState.connected = false;
    var connBox = document.getElementById('pt-conn-banner');
    if (connBox) connBox.style.display = 'none';
    if (showQR) {
      var qrBox = document.getElementById('pt-qr-wrap');
      if (qrBox) qrBox.style.display = '';
    }
  }

  function rxHandleMessage(ev) {
    var data = ev.data;
    if (typeof data === 'string') {
      var msg;
      try { msg = JSON.parse(data); } catch (e) { return; }
      if (msg.type === 'meta') {
        rxState.incoming[msg.id] = { meta: msg, chunks: [], received: 0 };
        rxState.activeId = msg.id;
        rxLog('Receiving ' + msg.name + '…', 'info');
      } else if (msg.type === 'done') {
        var rec = rxState.incoming[msg.id];
        if (!rec) return;
        var blob = new Blob(rec.chunks, { type: rec.meta.mime || 'image/jpeg' });
        var url = URL.createObjectURL(blob);
        var cleanName = rec.meta.name.replace(/\.[^.]+$/, '') + '.jpg';
        rxState.photos.push({
          id: rec.meta.id,
          name: cleanName,
          size: rec.meta.size,
          type: 'image/jpeg',
          blob: blob,
          url: url
        });
        delete rxState.incoming[msg.id];
        if (rxState.activeId === msg.id) rxState.activeId = null;
        rxRenderGrid();
        rxUpdateCounts();
        rxLog('Received ' + rxState.photos.length + ' photo(s).', 'ok');
      } else if (msg.type === 'batchDone') {
        rxLog('Done. ' + rxState.photos.length + ' photo(s) received.', 'ok');
      }
    } else {
      var rec2 = rxState.activeId ? rxState.incoming[rxState.activeId] : null;
      if (!rec2) return;
      rec2.chunks.push(data);
      rec2.received += data.byteLength;
    }
  }

  function rxUpdateCounts() {
    var total = rxState.photos.length;
    var sel = rxState.selected.size;
    var countEl = document.getElementById('pt-count');
    if (countEl) countEl.textContent = total + ' photo' + (total === 1 ? '' : 's') + ' \u2022 ' + sel + ' selected';
    var dlBtn = document.getElementById('pt-download-btn');
    if (dlBtn) dlBtn.disabled = sel === 0;
  }

  function rxRenderGrid() {
    var grid = document.getElementById('pt-grid');
    var pager = document.getElementById('pt-pager');
    if (!grid) return;
    var total = rxState.photos.length;
    if (total === 0) {
      grid.innerHTML = '<div style="grid-column:1/-1;padding:40px;text-align:center;color:var(--text-3);font-size:12px;">No photos yet. Photos from your phone will appear here.</div>';
      if (pager) pager.style.display = 'none';
      return;
    }
    var pages = Math.max(1, Math.ceil(total / rxState.pageSize));
    if (rxState.page >= pages) rxState.page = pages - 1;
    var start = rxState.page * rxState.pageSize;
    var end = Math.min(start + rxState.pageSize, total);

    var html = '';
    for (var i = start; i < end; i++) {
      var p = rxState.photos[i];
      var checked = rxState.selected.has(p.id) ? 'checked' : '';
      var sizeKB = Math.round(p.size / 1024);
      html += '<label class="pt-tile' + (checked ? ' pt-tile-on' : '') + '" data-id="' + p.id + '">'
            +   '<input type="checkbox" ' + checked + ' onchange="window.ptToggle(\'' + p.id + '\')">'
            +   '<img src="' + p.url + '" alt="" loading="lazy">'
            +   '<div class="pt-tile-meta"><div class="pt-tile-name">' + p.name + '</div><div class="pt-tile-size">' + sizeKB + ' KB</div></div>'
            + '</label>';
    }
    grid.innerHTML = html;

    if (pager) {
      if (pages <= 1) {
        pager.style.display = 'none';
      } else {
        pager.style.display = '';
        pager.innerHTML =
          '<button class="pt-page-btn" onclick="window.ptPage(-1)"' + (rxState.page === 0 ? ' disabled' : '') + '>\u2039 Prev</button>'
        + '<span class="pt-page-info">Page ' + (rxState.page + 1) + ' of ' + pages + '</span>'
        + '<button class="pt-page-btn" onclick="window.ptPage(1)"' + (rxState.page === pages - 1 ? ' disabled' : '') + '>Next \u203a</button>';
      }
    }
  }

  window.ptToggle = function (id) {
    if (rxState.selected.has(id)) rxState.selected.delete(id);
    else rxState.selected.add(id);
    rxRenderGrid();
    rxUpdateCounts();
  };

  window.ptPage = function (dir) {
    rxState.page += dir;
    if (rxState.page < 0) rxState.page = 0;
    rxRenderGrid();
  };

  window.ptSelectAllPage = function () {
    var start = rxState.page * rxState.pageSize;
    var end = Math.min(start + rxState.pageSize, rxState.photos.length);
    for (var i = start; i < end; i++) rxState.selected.add(rxState.photos[i].id);
    rxRenderGrid();
    rxUpdateCounts();
  };

  window.ptSelectAll = function () {
    rxState.photos.forEach(function (p) { rxState.selected.add(p.id); });
    rxRenderGrid();
    rxUpdateCounts();
  };

  window.ptClearSelection = function () {
    rxState.selected.clear();
    rxRenderGrid();
    rxUpdateCounts();
  };

  window.ptDownloadSelected = async function () {
    if (rxState.selected.size === 0) return;
    if (typeof JSZip === 'undefined') {
      alert('JSZip not loaded.');
      return;
    }
    var btn = document.getElementById('pt-download-btn');
    var oldTxt = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Zipping\u2026'; }

    var zip = new JSZip();
    var usedNames = {};
    rxState.photos.forEach(function (p) {
      if (!rxState.selected.has(p.id)) return;
      var name = p.name || 'photo.jpg';
      if (usedNames[name]) {
        var n = 1;
        var dot = name.lastIndexOf('.');
        var base = dot > 0 ? name.slice(0, dot) : name;
        var ext = dot > 0 ? name.slice(dot) : '';
        var candidate;
        do {
          candidate = base + '_' + n + ext;
          n++;
        } while (usedNames[candidate]);
        name = candidate;
      }
      usedNames[name] = true;
      zip.file(name, p.blob);
    });

    try {
      var content = await zip.generateAsync({ type: 'blob' }, function (meta) {
        if (btn) btn.textContent = 'Zipping\u2026 ' + Math.round(meta.percent) + '%';
      });
      var ts = new Date().toISOString().replace(/[:.]/g, '-').slice(0, 19);
      var a = document.createElement('a');
      a.href = URL.createObjectURL(content);
      a.download = 'photos-' + ts + '.zip';
      document.body.appendChild(a);
      a.click();
      setTimeout(function () {
        URL.revokeObjectURL(a.href);
        a.remove();
      }, 1000);
    } catch (e) {
      alert('Zip failed: ' + e.message);
    } finally {
      if (btn) { btn.disabled = false; btn.textContent = oldTxt || '\u2b07 Download as ZIP'; }
    }
  };

  window.ptClearPhotos = function () {
    if (rxState.photos.length === 0) return;
    if (!confirm('Clear all received photos? (You can still receive more)')) return;
    rxState.photos.forEach(function (p) { try { URL.revokeObjectURL(p.url); } catch (e) {} });
    rxState.photos = [];
    rxState.selected.clear();
    rxState.page = 0;
    rxRenderGrid();
    rxUpdateCounts();
  };

  window.ptNewSession = function () {
    rxCleanupSession(true);
    rxStartSession();
  };

  window.ptInitOnOpen = function () {
    if (!rxState.pc) rxStartSession();
  };

  // ───────────────────────────────────────────────────────────────
  // SENDER UI + LOGIC  (phone side)
  // ───────────────────────────────────────────────────────────────
  function renderSenderUI() {
    document.documentElement.style.background = '#0a0a0a';
    document.body.innerHTML =
      '<div id="pt-sender-root" style="min-height:100vh;background:#0a0a0a;color:#fff;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,sans-serif;display:flex;flex-direction:column;align-items:center;padding:24px 16px;">'
    +   '<div style="font-size:13px;color:#888;text-transform:uppercase;letter-spacing:0.15em;margin-bottom:8px;">Photo Transfer</div>'
    +   '<div style="font-size:22px;font-weight:700;margin-bottom:24px;text-align:center;">Send Photos to Computer</div>'
    +   '<div id="pt-sender-status" style="font-size:14px;color:#aaa;margin-bottom:24px;text-align:center;max-width:340px;line-height:1.5;">Connecting to computer\u2026</div>'
    +   '<button id="pt-sender-pick" type="button" disabled style="background:#e8ff4a;color:#000;border:none;border-radius:10px;padding:18px 28px;font-size:16px;font-weight:700;cursor:pointer;min-width:260px;opacity:0.4;">\ud83d\udcf7 Choose Photos</button>'
    +   '<input id="pt-sender-input" type="file" accept="image/*" multiple style="display:none;">'
    +   '<div id="pt-sender-progress" style="margin-top:24px;font-size:13px;color:#aaa;text-align:center;max-width:340px;line-height:1.6;"></div>'
    + '</div>';

    document.getElementById('pt-sender-input').addEventListener('change', txOnFilesPicked);
    document.getElementById('pt-sender-pick').addEventListener('click', function () {
      document.getElementById('pt-sender-input').click();
    });
  }



  function txStatus(msg) {
    var el = document.getElementById('pt-sender-status');
    if (el) el.textContent = msg;
  }

  function txProgress(msg) {
    var el = document.getElementById('pt-sender-progress');
    if (el) el.textContent = msg;
  }

  async function initSender(ptDb) {
    tx.sigRef = ptDb.ref('phototransfer/' + senderSessionId);
    txStatus('Connecting… (1/4 — Firebase ready)');

    tx.pc = new RTCPeerConnection(STUN);
    var pendingCandidates = [];
    var remoteSet = false;

    tx.pc.ondatachannel = function (ev) {
      txStatus('Connecting… (3/4 — channel received)');
      tx.channel = ev.channel;
      tx.channel.binaryType = 'arraybuffer';
      tx.channel.bufferedAmountLowThreshold = 256 * 1024;
      tx.channel.onopen = function () {
        tx.ready = true;
        txStatus('\u2713 Connected to computer. Tap below to choose photos.');
        var btn = document.getElementById('pt-sender-pick');
        if (btn) { btn.disabled = false; btn.style.opacity = '1'; }
      };
      tx.channel.onclose = function () {
        tx.ready = false;
        txStatus('Connection closed.');
      };
      tx.channel.onerror = function () {
        txStatus('Connection error.');
      };
    };

    var txCandidateCount = 0;
    tx.pc.onicecandidate = function (ev) {
      if (ev.candidate) {
        txCandidateCount++;
        txProgress('Candidate ' + txCandidateCount + ': ' + ev.candidate.type + ' ' + (ev.candidate.address || ev.candidate.candidate.split(' ')[4] || '?'));
        tx.sigRef.child('txCandidates').push(ev.candidate.toJSON());
      } else {
        txProgress('Gathering done. ' + txCandidateCount + ' candidates sent.');
      }
    };

    tx.pc.onconnectionstatechange = function () {
      var s = tx.pc.connectionState;
      if (s === 'connected') txStatus('Connecting… (4/4 — peer connected)');
      if (s === 'failed') txStatus('Connection failed. Close this tab and try again.');
      txProgress('conn:' + s + ' ice:' + tx.pc.iceConnectionState + ' gather:' + tx.pc.iceGatheringState);
    };

    tx.pc.oniceconnectionstatechange = function () {
      txProgress('ICE state: ' + tx.pc.iceConnectionState + ' | gathering: ' + tx.pc.iceGatheringState);
    };

    // Queue remote ICE candidates until remote description is set
    tx.sigRef.child('rxCandidates').on('child_added', async function (snap) {
      var c = snap.val();
      if (!c) return;
      if (remoteSet && tx.pc) {
        try { await tx.pc.addIceCandidate(c); } catch (e) {}
      } else {
        pendingCandidates.push(c);
      }
    });

    tx.sigRef.child('offer').on('value', async function (snap) {
      var offer = snap.val();
      if (!offer || !offer.sdp) return;
      if (tx.pc.signalingState !== 'stable') return;
      txStatus('Connecting… (2/4 — offer received)');
      try {
        await tx.pc.setRemoteDescription(new RTCSessionDescription(offer));
        remoteSet = true;
        // Flush queued candidates
        for (var i = 0; i < pendingCandidates.length; i++) {
          try { await tx.pc.addIceCandidate(pendingCandidates[i]); } catch (e) {}
        }
        pendingCandidates = [];
        var answer = await tx.pc.createAnswer();
        await tx.pc.setLocalDescription(answer);
        await tx.sigRef.child('answer').set({ type: answer.type, sdp: answer.sdp });
      } catch (e) {
        txStatus('Handshake error: ' + e.message);
      }
    });
  }

  function txOnFilesPicked(ev) {
    var files = Array.from(ev.target.files || []);
    if (!files.length) return;
    if (!tx.ready) { txStatus('Not connected yet, wait a moment\u2026'); return; }
    tx.queue = tx.queue.concat(files);
    txStatus('Sending ' + tx.queue.length + ' photo(s)\u2026');
    if (!tx.sending) txDrainQueue();
    ev.target.value = '';
  }

  function waitForBufferLow() {
    return new Promise(function (resolve) {
      if (tx.channel.bufferedAmount < tx.channel.bufferedAmountLowThreshold) return resolve();
      var handler = function () {
        tx.channel.removeEventListener('bufferedamountlow', handler);
        resolve();
      };
      tx.channel.addEventListener('bufferedamountlow', handler);
    });
  }

  async function txDrainQueue() {
    tx.sending = true;
    var totalThisBatch = tx.queue.length;
    var doneCount = 0;
    while (tx.queue.length) {
      var f = tx.queue.shift();
      doneCount++;
      txProgress('Sending ' + doneCount + ' of ' + totalThisBatch + ': ' + f.name);
      try {
        await txSendOneFile(f);
      } catch (e) {
        txProgress('Error on ' + f.name + ': ' + e.message);
      }
    }
    tx.channel.send(JSON.stringify({ type: 'batchDone' }));
    txProgress('\u2713 All ' + totalThisBatch + ' photo(s) sent. You can pick more or close this tab.');
    tx.sending = false;
  }

  async function txCompressFile(file) {
    return new Promise(function(resolve) {
      var img = new Image();
      var url = URL.createObjectURL(file);
      img.onload = function() {
        var maxDim = 2048;
        var w = img.width, h = img.height;
        if (w > maxDim || h > maxDim) {
          if (w > h) { h = Math.round(h * maxDim / w); w = maxDim; }
          else { w = Math.round(w * maxDim / h); h = maxDim; }
        }
        var canvas = document.createElement('canvas');
        canvas.width = w; canvas.height = h;
        canvas.getContext('2d').drawImage(img, 0, 0, w, h);
        URL.revokeObjectURL(url);
        canvas.toBlob(function(blob) {
          resolve(blob || file);
        }, 'image/jpeg', 0.85);
      };
      img.onerror = function() { URL.revokeObjectURL(url); resolve(file); };
      img.src = url;
    });
  }

  async function txSendOneFile(file) {
    txProgress('Compressing ' + file.name + '\u2026');
    var sendFile = await txCompressFile(file);
    var fileId = Math.random().toString(36).slice(2, 10);
    tx.channel.send(JSON.stringify({
      type: 'meta',
      id: fileId,
      name: file.name,
      size: sendFile.size,
      mime: 'image/jpeg'
    }));

    var buf = await sendFile.arrayBuffer();
    var offset = 0;
    while (offset < buf.byteLength) {
      if (tx.channel.bufferedAmount > 8 * 1024 * 1024) {
        await waitForBufferLow();
      }
      var slice = buf.slice(offset, offset + CHUNK_SIZE);
      tx.channel.send(slice);
      offset += slice.byteLength;
    }
    tx.channel.send(JSON.stringify({ type: 'done', id: fileId }));
  }

})();

/* ══════════════════════════════════════════════════════════════════════
   CUSTOMER REVIEWS
   ══════════════════════════════════════════════════════════════════════ */
(function () {
  var RV_WORKER = 'https://reviews-api.globaljdmautoparts.com';

  // Get a fresh Firebase ID token for the signed-in admin.
  // Nothing secret lives in this file — the token is short-lived and
  // the worker verifies it against Google's public keys.
  function rvAuthHeader() {
    return new Promise(function (resolve, reject) {
      try {
        var user = firebase.auth().currentUser;
        if (!user) { reject(new Error('Not signed in')); return; }
        user.getIdToken().then(function (t) {
          resolve({ 'Authorization': 'Bearer ' + t });
        }).catch(reject);
      } catch (e) { reject(new Error('Firebase not ready')); }
    });
  }

  var rvAll = [];
  var rvFilter = 'all';

  function rvEsc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function rvStars(n) {
    var out = '';
    for (var i = 1; i <= 5; i++) out += (i <= n ? '★' : '☆');
    return out;
  }

  function rvDate(iso) {
    try { return new Date(iso).toLocaleString(); } catch (e) { return ''; }
  }

  window.setReviewsFilter = function (f, btn) {
    rvFilter = f;
    var strip = btn && btn.parentNode;
    if (strip) {
      var tabs = strip.querySelectorAll('.wr-tab');
      for (var i = 0; i < tabs.length; i++) tabs[i].classList.remove('active');
    }
    if (btn) btn.classList.add('active');
    renderReviewsAdmin();
  };

  window.loadReviewsAdmin = function () {
    var list = document.getElementById('rv-list');
    if (list) list.innerHTML = '<div class="intake-empty">Loading reviews…</div>';

    rvAuthHeader().then(function (headers) {
      return fetch(RV_WORKER + '/admin/reviews', { headers: headers });
    })
      .then(function (r) {
        if (r.status === 401) return r.json().then(function (d) { throw new Error(d.error || 'Not authorised'); });
        return r.json();
      })
      .then(function (data) {
        if (!data.ok) throw new Error(data.error || 'Failed to load');
        rvAll = data.reviews || [];
        rvUpdateStats();
        renderReviewsAdmin();
      })
      .catch(function (e) {
        if (list) list.innerHTML = '<div class="intake-empty">Could not load reviews: ' + rvEsc(e.message) + '</div>';
      });
  };

  function rvUpdateStats() {
    var total = rvAll.length;
    var noReply = rvAll.filter(function (r) { return !r.reply; }).length;
    var avg = total ? (rvAll.reduce(function (s, r) { return s + (r.rating || 0); }, 0) / total).toFixed(1) : '—';

    var el;
    if ((el = document.getElementById('rv-stat-total')))   el.textContent = total;
    if ((el = document.getElementById('rv-stat-avg')))     el.textContent = avg + (total ? ' ★' : '');
    if ((el = document.getElementById('rv-stat-noreply'))) el.textContent = noReply;

    var badge = document.getElementById('reviews-accordion-badge');
    var menuBadge = document.getElementById('more-menu-badge-reviews');
    var tabBadge = document.getElementById('rv-tab-noreply-badge');
    [badge, menuBadge, tabBadge].forEach(function (b) {
      if (!b) return;
      if (noReply > 0) { b.textContent = noReply; b.style.display = ''; }
      else { b.style.display = 'none'; }
    });
  }

  window.renderReviewsAdmin = function () {
    var list = document.getElementById('rv-list');
    if (!list) return;

    var sb = document.getElementById('rv-search');
    var q = sb ? (sb.value || '').toLowerCase().trim() : '';

    var rows = rvAll.filter(function (r) {
      if (rvFilter === 'noreply') return !r.reply;
      if (rvFilter === 'low')     return r.rating <= 2;
      if (rvFilter === '5')       return r.rating === 5;
      return true;
    });

    if (q) {
      rows = rows.filter(function (r) {
        return (r.sku || '').toLowerCase().indexOf(q) !== -1
            || (r.name || '').toLowerCase().indexOf(q) !== -1
            || (r.comment || '').toLowerCase().indexOf(q) !== -1;
      });
    }

    if (!rows.length) {
      list.innerHTML = '<div class="intake-empty">No reviews match this filter.</div>';
      return;
    }

    list.innerHTML = rows.map(function (r) {
      var lowClass = r.rating <= 2 ? ' rv-card-low' : '';
      var replyHTML = r.reply
        ? '<div class="rv-reply"><div class="rv-reply-label">Your reply</div><div>' + rvEsc(r.reply) + '</div></div>'
        : '';
      return ''
        + '<div class="rv-card' + lowClass + '" id="rv-card-' + rvEsc(r.id) + '">'
        +   '<div class="rv-card-top">'
        +     '<div>'
        +       '<div class="rv-name">' + rvEsc(r.name) + '</div>'
        +       '<div class="rv-meta">' + rvDate(r.createdAt) + ' &middot; <span class="rv-sku">' + rvEsc(r.sku) + '</span></div>'
        +     '</div>'
        +     '<div class="rv-rating">' + rvStars(r.rating) + '</div>'
        +   '</div>'
        +   '<div class="rv-private"><strong>🔒 Private —</strong> '
        +     '<a href="mailto:' + rvEsc(r.email) + '" class="rv-link">' + rvEsc(r.email || 'no email') + '</a>'
        +     (r.phone ? ' &nbsp;|&nbsp; <a href="tel:' + rvEsc(r.phone) + '" class="rv-link">' + rvEsc(r.phone) + '</a>' : '')
        +   '</div>'
        +   '<div class="rv-comment">' + rvEsc(r.comment) + '</div>'
        +   replyHTML
        +   '<div class="rv-actions">'
        +     '<button class="btn-action btn-secondary" style="min-height:30px;padding:4px 12px;font-size:10px;" onclick="rvToggleReply(\'' + rvEsc(r.id) + '\')">'
        +       (r.reply ? '✏️ Edit reply' : '💬 Reply') + '</button>'
        +     '<button class="btn-action btn-secondary" style="min-height:30px;padding:4px 12px;font-size:10px;border-color:var(--red);color:var(--red);" onclick="rvDelete(\'' + rvEsc(r.id) + '\',\'' + rvEsc(r.sku) + '\')">🗑 Delete</button>'
        +   '</div>'
        +   '<div class="rv-reply-form" id="rv-form-' + rvEsc(r.id) + '" style="display:none;">'
        +     '<textarea class="rv-textarea" id="rv-text-' + rvEsc(r.id) + '" placeholder="Write your public reply…">' + rvEsc(r.reply || '') + '</textarea>'
        +     '<button class="btn-action btn-primary" style="min-height:32px;padding:6px 14px;font-size:11px;" onclick="rvSubmitReply(\'' + rvEsc(r.id) + '\',\'' + rvEsc(r.sku) + '\')">Post reply</button>'
        +   '</div>'
        + '</div>';
    }).join('');
  };

  window.rvToggleReply = function (id) {
    var f = document.getElementById('rv-form-' + id);
    if (!f) return;
    f.style.display = (f.style.display === 'none' || !f.style.display) ? 'flex' : 'none';
    if (f.style.display === 'flex') {
      var t = document.getElementById('rv-text-' + id);
      if (t) t.focus();
    }
  };

  window.rvSubmitReply = function (id, sku) {
    var t = document.getElementById('rv-text-' + id);
    var reply = t ? t.value.trim() : '';
    if (!reply) { alert('Reply cannot be empty.'); return; }

    rvAuthHeader().then(function (headers) {
      headers['Content-Type'] = 'application/json';
      return fetch(RV_WORKER + '/admin/reply', {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({ id: id, sku: sku, reply: reply })
      });
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data.ok) throw new Error(data.error || 'failed');
        loadReviewsAdmin();
      })
      .catch(function (e) { alert('Could not post reply: ' + e.message); });
  };

  window.rvDelete = function (id, sku) {
    if (!confirm('Delete this review permanently? This cannot be undone.')) return;

    rvAuthHeader().then(function (headers) {
      headers['Content-Type'] = 'application/json';
      return fetch(RV_WORKER + '/admin/delete', {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({ id: id, sku: sku })
      });
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data.ok) throw new Error(data.error || 'failed');
        rvAll = rvAll.filter(function (r) { return r.id !== id; });
        rvUpdateStats();
        renderReviewsAdmin();
      })
      .catch(function (e) { alert('Could not delete: ' + e.message); });
  };

  // Load once signed in, so the badge count is live
  try {
    firebase.auth().onAuthStateChanged(function (user) {
      if (user && typeof loadReviewsAdmin === 'function') loadReviewsAdmin();
    });
  } catch (e) {}
})();

/* ═══════════════════════════════════════════════════════════
     PRODUCT RETURNS — admin panel
  ═══════════════════════════════════════════════════════════ */
(function () {
  var rtnAll = [];
  var rtnFilter = 'all';

  function rtnEsc(s) { return String(s || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }

  function rtnDate(ts) {
    if (!ts) return '—';
    var d = new Date(ts);
    var now = new Date();
    var diff = Math.floor((now - d) / 60000);
    if (diff < 2) return 'Just now';
    if (diff < 60) return diff + 'm ago';
    var diffH = Math.floor(diff / 60);
    if (diffH < 24) return diffH + 'h ago';
    var diffD = Math.floor(diffH / 24);
    if (diffD < 7) return diffD + 'd ago';
    return d.toLocaleDateString('en-CA', { month: 'short', day: 'numeric' });
  }

  var reasonLabels = {
    'wrong-part': 'Wrong part / doesn\'t fit',
    'damaged': 'Part arrived damaged',
    'defective': 'Part is defective',
    'changed-mind': 'Changed mind',
    'other': 'Other'
  };

  var statusColors = {
    pending:  'background:var(--hold-bg);color:var(--hold);border:1px solid rgba(179,100,26,.2)',
    approved: 'background:var(--avail-bg);color:var(--avail);border:1px solid rgba(27,122,69,.2)',
    denied:   'background:var(--out-bg);color:var(--out);border:1px solid rgba(154,59,52,.2)',
    done:     'background:rgba(232,255,74,0.08);color:var(--accent);border:1px solid rgba(232,255,74,.15)'
  };

  // ── ntfy notification helper ──
  function sendNtfy(title, body, priority) {
    fetch('https://inventorysync-globaljdm.clashofclansgamer973.workers.dev/api/notify', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ title: title, body: body, priority: priority || 'default', tags: 'bell' })
    }).catch(function(){});
  }
  window.sendNtfy = sendNtfy;

  /* ── Load from Firebase ── */
  window.loadReturnsAdmin = function () {
    var list = document.getElementById('rtn-list');
    if (list) list.innerHTML = '<div class="intake-empty">Loading returns…</div>';

    db.ref('returnRequests').once('value').then(function (snap) {
      var data = snap.val() || {};
      rtnAll = Object.entries(data).map(function (e) {
        var r = e[1]; r._key = e[0]; return r;
      }).sort(function (a, b) { return (b.submittedAt || 0) - (a.submittedAt || 0); });
      rtnUpdateStats();
      renderReturnsAdmin();
    }).catch(function (e) {
      if (list) list.innerHTML = '<div class="intake-empty">Could not load returns: ' + rtnEsc(e.message) + '</div>';
    });
  };

  /* ── Also listen in realtime for badge updates ── */
  var rtnPrevCount = null;
  db.ref('returnRequests').on('value', function (snap) {
    var data = snap.val() || {};
    rtnAll = Object.entries(data).map(function (e) {
      var r = e[1]; r._key = e[0]; return r;
    }).sort(function (a, b) { return (b.submittedAt || 0) - (a.submittedAt || 0); });

    // Notify on new return — but not on first load
    var newCount = rtnAll.length;
    if (rtnPrevCount !== null && newCount > rtnPrevCount) {
      var newest = rtnAll[0];
      sendNtfy(
        '📦 New Return Request — ' + (newest.ref || ''),
        (newest.name || 'Customer') + ' · Order ' + (newest.orderNumber || '—') + '\n' + (newest.partName || '') + '\nReason: ' + (newest.reason || '').replace(/-/g,' '),
        'high'
      );
    }
    rtnPrevCount = newCount;

    rtnUpdateStats();
    var acc = document.getElementById('accordion-returns');
    if (acc && acc.open) renderReturnsAdmin();
  });

  /* ── Stats + badges ── */
  function rtnUpdateStats() {
    var total    = rtnAll.length;
    var pending  = rtnAll.filter(function (r) { return r.status === 'pending'; }).length;
    var approved = rtnAll.filter(function (r) { return r.status === 'approved'; }).length;

    var el;
    if ((el = document.getElementById('rtn-stat-total')))    el.textContent = total;
    if ((el = document.getElementById('rtn-stat-pending')))  el.textContent = pending;
    if ((el = document.getElementById('rtn-stat-approved'))) el.textContent = approved;

    // Badges
    var badge     = document.getElementById('returns-accordion-badge');
    var menuBadge = document.getElementById('more-menu-badge-returns');
    var tabBadge  = document.getElementById('rtn-tab-pending-badge');
    [badge, menuBadge, tabBadge].forEach(function (b) {
      if (!b) return;
      if (pending > 0) { b.textContent = pending; b.style.display = ''; }
      else { b.style.display = 'none'; }
    });
  }

  /* ── Filter ── */
  window.setReturnsFilter = function (f, btn) {
    rtnFilter = f;
    var strip = btn && btn.parentNode;
    if (strip) {
      var tabs = strip.querySelectorAll('.wr-tab');
      for (var i = 0; i < tabs.length; i++) tabs[i].classList.remove('active');
    }
    if (btn) btn.classList.add('active');
    renderReturnsAdmin();
  };

  /* ── Render list ── */
  window.renderReturnsAdmin = function () {
    var list = document.getElementById('rtn-list');
    if (!list) return;

    var sb = document.getElementById('rtn-search');
    var q = sb ? (sb.value || '').toLowerCase().trim() : '';

    var rows = rtnAll.filter(function (r) {
      var effectiveStatus = r.status === 'done' ? 'resolved' : r.status;
      if (rtnFilter !== 'all' && effectiveStatus !== rtnFilter) return false;
      if (q) {
        return (r.ref || '').toLowerCase().indexOf(q) !== -1
            || (r.orderNumber || '').toLowerCase().indexOf(q) !== -1
            || (r.name || '').toLowerCase().indexOf(q) !== -1
            || (r.partName || '').toLowerCase().indexOf(q) !== -1;
      }
      return true;
    });

    if (!rows.length) {
      list.innerHTML = '<div class="intake-empty">No return requests match this filter.</div>';
      return;
    }

    list.innerHTML = rows.map(function (r) {
      var st = r.status || 'pending';
      var stStyle = statusColors[st] || statusColors.pending;
      var typeLabel = r.requestType === 'cancel' ? '❌ Cancellation' : '↩️ Return / Exchange';
      var reasonText = reasonLabels[r.reason] || r.reason || '—';
      var fulfillText = r.fulfillment === 'shipping' ? '📦 Shipped' : '🏪 Pickup';

      var waLink = r.phone
        ? 'https://wa.me/' + r.phone.replace(/\D/g, '') + '?text=' + encodeURIComponent('Hi ' + r.name + ', this is Global JDM Auto Parts following up on your return request (Ref: ' + r.ref + '). ')
        : null;

      var notesHTML = r.notes ? '<div style="margin-top:8px;font-size:12px;color:var(--faded);line-height:1.5;"><strong>Notes:</strong> ' + rtnEsc(r.notes) + '</div>' : '';
      var adminNotesVal = r.adminNotes || '';

      return ''
        + '<div class="intake-card" style="margin-bottom:10px;" id="rtn-card-' + rtnEsc(r._key) + '">'
        +   '<div style="display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:8px;">'
        +     '<div>'
        +       '<div style="font-weight:700;font-size:14px;color:var(--text);">' + rtnEsc(r.name || '—') + '</div>'
        +       '<div style="font-size:11px;color:var(--faded);margin-top:2px;">'
        +         '🕐 ' + rtnDate(r.submittedAt) + ' · Ref: <span style="font-family:monospace;color:var(--accent);">' + rtnEsc(r.ref) + '</span>'
        +       '</div>'
        +     '</div>'
        +     '<span style="font-size:10px;font-weight:700;text-transform:uppercase;padding:3px 10px;border-radius:8px;' + stStyle + ';">' + rtnEsc(st) + '</span>'
        +   '</div>'

        +   '<div style="display:grid;grid-template-columns:1fr 1fr;gap:6px 16px;font-size:12px;color:var(--faded);margin-bottom:8px;">'
        +     '<div>📋 <strong>Order:</strong> ' + rtnEsc(r.orderNumber || '—') + '</div>'
        +     '<div>' + typeLabel + '</div>'
        +     '<div>📧 <a href="mailto:' + rtnEsc(r.email) + '" style="color:var(--accent);">' + rtnEsc(r.email || '—') + '</a></div>'
        +     '<div>📞 ' + rtnEsc(r.phone || '—') + '</div>'
        +     '<div>🔧 ' + rtnEsc(r.partName || '—') + '</div>'
        +     '<div>' + fulfillText + '</div>'
        +     '<div>📅 Pickup/Delivery: ' + rtnEsc(r.pickupDate || '—') + '</div>'
        +     '<div>⚠️ Reason: ' + rtnEsc(reasonText) + '</div>'
        +   '</div>'

        +   notesHTML

        // Admin notes
        +   '<div style="margin-top:10px;">'
        +     '<textarea class="rv-textarea" id="rtn-notes-' + rtnEsc(r._key) + '" placeholder="Internal admin notes…" style="min-height:50px;font-size:12px;">' + rtnEsc(adminNotesVal) + '</textarea>'
        +   '</div>'

        // Actions
        +   '<div style="display:flex;flex-wrap:wrap;gap:6px;margin-top:10px;">'
        +     (st === 'pending' ? '<button class="btn-action btn-primary" style="min-height:30px;padding:4px 12px;font-size:10px;" onclick="rtnSetStatus(\'' + rtnEsc(r._key) + '\',\'approved\')">✅ Approve</button>' : '')
        +     (st === 'pending' ? '<button class="btn-action btn-secondary" style="min-height:30px;padding:4px 12px;font-size:10px;border-color:var(--red);color:var(--red);" onclick="rtnSetStatus(\'' + rtnEsc(r._key) + '\',\'denied\')">✕ Deny</button>' : '')
        +     (st === 'approved' ? '<button class="btn-action btn-primary" style="min-height:30px;padding:4px 12px;font-size:10px;background:#2563eb;" onclick="rtnSetStatus(\'' + rtnEsc(r._key) + '\',\'received\')">📦 Mark Part Received</button>' : '')
        +     (st === 'received' ? '<button class="btn-action btn-primary" style="min-height:30px;padding:4px 12px;font-size:10px;" onclick="rtnSetStatus(\'' + rtnEsc(r._key) + '\',\'resolved\')">💰 Mark Refunded</button>' : '')
        +     '<button class="btn-action btn-secondary" style="min-height:30px;padding:4px 12px;font-size:10px;" onclick="rtnSaveNotes(\'' + rtnEsc(r._key) + '\')">💾 Save Notes</button>'
        +     (waLink ? '<a href="' + waLink + '" target="_blank" class="btn-action btn-secondary" style="min-height:30px;padding:4px 12px;font-size:10px;text-decoration:none;">💬 WhatsApp</a>' : '')
        +     '<button class="btn-action btn-secondary" style="min-height:30px;padding:4px 12px;font-size:10px;border-color:var(--red);color:var(--red);margin-left:auto;" onclick="rtnDelete(\'' + rtnEsc(r._key) + '\')">🗑 Delete</button>'
        +   '</div>'
        + '</div>';
    }).join('');
  };

  /* ── Status change ── */
  window.rtnSetStatus = function (key, status) {
    if (status === 'denied') {
      var reason = prompt('Enter reason for declining (customer will see this):');
      if (!reason) return;
      db.ref('returnRequests/' + key).update({ status: 'denied', deniedReason: reason, updatedAt: Date.now() })
        .then(function () { showToast('✓ Return declined'); sendNtfy('📦 Return Declined', 'You declined a return request. Reason: ' + reason, 'default'); })
        .catch(function (e) { alert('Failed: ' + e.message); });
      return;
    }
    // Map 'done' to 'resolved' so returns page status checker works correctly
    var mapped = status === 'done' ? 'resolved' : status;
    db.ref('returnRequests/' + key).update({ status: mapped, updatedAt: Date.now() })
      .then(function () { showToast('✓ Status → ' + mapped); })
      .catch(function (e) { alert('Failed: ' + e.message); });
  };

  /* ── Save admin notes ── */
  window.rtnSaveNotes = function (key) {
    var t = document.getElementById('rtn-notes-' + key);
    var notes = t ? t.value.trim() : '';
    db.ref('returnRequests/' + key + '/adminNotes').set(notes)
      .then(function () { showToast('✓ Notes saved'); })
      .catch(function (e) { alert('Failed: ' + e.message); });
  };

  /* ── Delete ── */
  window.rtnDelete = function (key) {
    if (!confirm('Delete this return request permanently?')) return;
    db.ref('returnRequests/' + key).remove()
      .then(function () { showToast('✓ Deleted'); })
      .catch(function (e) { alert('Failed: ' + e.message); });
  };
})();
